import { __decorate, __rest } from 'tslib';
import { ɵɵdefineInjectable, Injectable, Component, ɵɵinject, NgModule, EventEmitter, Input, Output, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { ToastrNotificationService, SpinnerService, ValidationService, UtilsModule } from '@lbmx/phoenix-lib-utils';
import { BaseHttpService as BaseHttpService$1, SearchContainerLoaderService, SearchContainerModule, SearchContainerLoaderModule } from '@lbmx/search-container';
import { Router, ActivatedRoute, RouterModule } from '@angular/router';
import { TemplateTypes, PerFormPrimengModule, LuiWizardV3Module, LuiWidgetWrapperModule, LuiWizardModule } from '@lbmx/per-form-primeng';
import { HttpMethod as HttpMethod$1 } from '@lbmx/web-core';
import { TranslocoService, TranslocoModule } from '@ngneat/transloco';
import { ConfirmationService } from 'primeng';
import { Action, ActionUiService } from '@lbmx/action-ui';
import { ConfirmationService as ConfirmationService$1 } from 'primeng-lts/api';
import { of, Subject, forkJoin } from 'rxjs';
import { map, tap, catchError, takeUntil, finalize, startWith, withLatestFrom, first, switchMap, exhaustMap, concatMap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import urlJoin from 'proper-url-join';
import { BaseAPIService, LoggerService } from '@lbmx/phoenix-lib-core';
import { DatePipe, CommonModule } from '@angular/common';
import { FormControl, Validators, FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Store, select } from '@ngrx/store';
import { saveAs } from 'file-saver';
import { ConfirmationService as ConfirmationService$2 } from 'primeng/api';
import { selectors, actions } from '@lbmx/app-state';
import { toolKeys } from '@lbmx/types';
import { PopupService, BaseHttpService as BaseHttpService$2, urlJoin as urlJoin$1 } from '@lbmx/root-services';
import { alpha3ToAlpha2, alpha2ToAlpha3 } from 'i18n-iso-countries';
import { parsePhoneNumber, isValidNumberForRegion } from 'libphonenumber-js';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { EditorModule } from 'primeng/editor';
import { TableModule } from 'primeng/table';
import { TreeModule } from 'primeng/tree';
import { ButtonModule as ButtonModule$1 } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { FileUploadModule } from 'primeng/fileupload';
import { InputTextModule } from 'primeng/inputtext';
import { MenubarModule } from 'primeng/menubar';
import { MultiSelectModule } from 'primeng/multiselect';
import { PasswordModule } from 'primeng/password';
import { TabViewModule } from 'primeng/tabview';
import { VirtualScrollerModule } from 'primeng/virtualscroller';
import { ToolbarModule } from 'primeng/toolbar';
import { TreeTableModule } from 'primeng/treetable';
import { CalendarModule } from 'primeng/calendar';
import { InputNumberModule } from 'primeng/inputnumber';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ConfirmationService as ConfirmationService$3, DialogModule as DialogModule$1, TabMenuModule, ButtonModule as ButtonModule$2, ProgressSpinnerModule as ProgressSpinnerModule$2 } from 'primeng-lts';
import { ProgressSpinnerModule as ProgressSpinnerModule$1 } from 'primeng/progressspinner';
import { GenerateFormService, PerFormModule } from '@lbmx/per-form';
import { ButtonModule } from 'primeng-lts/button';
import { ProgressSpinnerModule } from 'primeng-lts/progressspinner';

let AdministrationService = class AdministrationService {
    constructor() {
        /** empty block */
    }
    setConfig(config) {
        this.config = config;
    }
    getConfig() {
        return this.config;
    }
    getAccount() {
        return this.config;
    }
};
AdministrationService.ɵprov = ɵɵdefineInjectable({ factory: function AdministrationService_Factory() { return new AdministrationService(); }, token: AdministrationService, providedIn: "root" });
AdministrationService = __decorate([
    Injectable({
        providedIn: 'root',
    })
], AdministrationService);

let AdministrationComponent = class AdministrationComponent {
};
AdministrationComponent = __decorate([
    Component({
        selector: 'lib-administration',
        template: `
    <div class="phoenix">
      <lib-working-spinner-component></lib-working-spinner-component>
      <lib-toast-notification></lib-toast-notification>
      <router-outlet></router-outlet>
    </div>
  `
    })
], AdministrationComponent);

let EditConnectionWizardComponent = class EditConnectionWizardComponent {
    constructor(confirmationService, translocoService, toast, spinner, adminService, http, router, route) {
        this.confirmationService = confirmationService;
        this.translocoService = translocoService;
        this.toast = toast;
        this.spinner = spinner;
        this.adminService = adminService;
        this.http = http;
        this.router = router;
        this.route = route;
        this.wizardUrl = this.adminService.getConfig().apiBaseUrl;
        this.templateTypes = TemplateTypes;
        this.connectionKey = '';
        this.route.queryParams.subscribe((params) => {
            this.connectionKey = params['key'];
        });
        this.editWizardConfig = {
            endpoint: `connector/ui/connection/${this.connectionKey}/edit`,
            httpMethod: HttpMethod$1.PUT,
        };
    }
    submitNew(event) {
        this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
        this.router.navigate(['/AdministrationModule/marketplace-connectors'], {
            relativeTo: this.route,
        });
    }
    redirect() {
        this.confirmationService.confirm({
            header: this.translocoService.translate('ACTIONS.CANCEL'),
            message: this.translocoService.translate('COMMON.CONFIRM_LEAVE'),
            acceptLabel: this.translocoService.translate('ACTIONS.YES'),
            rejectLabel: this.translocoService.translate('ACTIONS.NO'),
            accept: () => {
                this.router.navigate(['/AdministrationModule/marketplace-connectors'], {
                    relativeTo: this.route,
                });
            },
        });
    }
};
EditConnectionWizardComponent.ctorParameters = () => [
    { type: ConfirmationService },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: SpinnerService },
    { type: AdministrationService },
    { type: BaseHttpService$1 },
    { type: Router },
    { type: ActivatedRoute }
];
EditConnectionWizardComponent = __decorate([
    Component({
        selector: 'lib-edit-connection-wizard',
        template: "<lui-wizard-v3\r\n  [baseUrl]=\"wizardUrl\"\r\n  [wizardConfig]=\"editWizardConfig\"\r\n  (submit)=\"submitNew($event)\"\r\n  (cancel)=\"redirect()\"\r\n  data-testid=\"editConnectionWizard\"\r\n>\r\n  <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n    <div\r\n      class=\"error\"\r\n      style=\"\r\n        min-height: 30vh;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n      \"\r\n    >\r\n      <div>\r\n        <span>\r\n          <i class=\"pi pi-times-circle\"></i>\r\n          {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n        </span>\r\n      </div>\r\n    </div>\r\n    <button\r\n      pButton\r\n      (click)=\"redirect()\"\r\n      class=\"ds secondary\"\r\n      data-testid=\"cancelButton\"\r\n    >\r\n      {{ 'ACTIONS.CANCEL' | transloco }}\r\n    </button>\r\n  </ng-template>\r\n</lui-wizard-v3>\r\n\r\n<p-confirmDialog [closeOnEscape]=\"false\" [closable]=\"false\"></p-confirmDialog>\r\n",
        providers: [ConfirmationService]
    })
], EditConnectionWizardComponent);

let MarketplaceConnectorComponent = class MarketplaceConnectorComponent {
    constructor() { }
    ngOnInit() { }
};
MarketplaceConnectorComponent = __decorate([
    Component({
        selector: 'lib-marketplace-connector',
        template: `<router-outlet></router-outlet>`
    })
], MarketplaceConnectorComponent);

let NewConnectionWizardComponent = class NewConnectionWizardComponent {
    constructor(confirmationService, translocoService, toast, spinner, adminService, http, router, route) {
        this.confirmationService = confirmationService;
        this.translocoService = translocoService;
        this.toast = toast;
        this.spinner = spinner;
        this.adminService = adminService;
        this.http = http;
        this.router = router;
        this.route = route;
        this.wizardUrl = this.adminService.getConfig().apiBaseUrl;
        this.templateTypes = TemplateTypes;
        // --------- new wizard config --------
        this.newWizardConfig = {
            endpoint: 'connector/ui/connection/new',
            httpMethod: HttpMethod$1.POST,
        };
    }
    submitNew(event) {
        this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
        this.router.navigate(['/AdministrationModule/marketplace-connectors'], {
            relativeTo: this.route,
        });
    }
    redirect() {
        this.confirmationService.confirm({
            header: this.translocoService.translate('ACTIONS.CANCEL'),
            message: this.translocoService.translate('COMMON.CONFIRM_LEAVE'),
            acceptLabel: this.translocoService.translate('ACTIONS.YES'),
            rejectLabel: this.translocoService.translate('ACTIONS.NO'),
            accept: () => {
                this.router.navigate(['/AdministrationModule/marketplace-connectors'], {
                    relativeTo: this.route,
                });
            },
        });
    }
};
NewConnectionWizardComponent.ctorParameters = () => [
    { type: ConfirmationService },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: SpinnerService },
    { type: AdministrationService },
    { type: BaseHttpService$1 },
    { type: Router },
    { type: ActivatedRoute }
];
NewConnectionWizardComponent = __decorate([
    Component({
        selector: 'lib-new-connection-wizard',
        template: "<lui-wizard-v3\r\n  [baseUrl]=\"wizardUrl\"\r\n  [wizardConfig]=\"newWizardConfig\"\r\n  (submit)=\"submitNew($event)\"\r\n  (cancel)=\"redirect()\"\r\n  data-testid=\"newConnectionWizard\"\r\n>\r\n  <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n    <div\r\n      class=\"error\"\r\n      style=\"\r\n        min-height: 30vh;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n      \"\r\n    >\r\n      <div>\r\n        <span>\r\n          <i class=\"pi pi-times-circle\"></i>\r\n          {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n        </span>\r\n      </div>\r\n    </div>\r\n    <button\r\n      pButton\r\n      (click)=\"redirect()\"\r\n      class=\"ds secondary\"\r\n      data-testid=\"cancelButton\"\r\n    >\r\n      {{ 'ACTIONS.CANCEL' | transloco }}\r\n    </button>\r\n  </ng-template>\r\n</lui-wizard-v3>\r\n\r\n<p-confirmDialog [closeOnEscape]=\"false\" [closable]=\"false\"></p-confirmDialog>\r\n",
        providers: [ConfirmationService]
    })
], NewConnectionWizardComponent);

var HttpMethod;
(function (HttpMethod) {
    HttpMethod["DELETE"] = "DELETE";
    HttpMethod["GET"] = "GET";
    HttpMethod["POST"] = "POST";
    HttpMethod["PUT"] = "PUT";
})(HttpMethod || (HttpMethod = {}));
let BaseHttpService = class BaseHttpService {
    constructor(http) {
        this.http = http;
        this._baseUrl = '';
    }
    set baseUrl(baseUrl) {
        this._baseUrl = baseUrl;
    }
    get baseUrl() {
        return this._baseUrl;
    }
    fetchWithFqn({ endpoint, httpMethod, body, responseField, }) {
        return this.buildRequest(endpoint, httpMethod, body).pipe(map((response) => responseField && response ? response[responseField] : response));
    }
    fetch({ endpoint, httpMethod, body, responseField, options, }) {
        return this.buildRequest(urlJoin(this._baseUrl, endpoint), httpMethod, body, options).pipe(map((response) => responseField && response ? response[responseField] : response));
    }
    buildRequest(endpoint, httpMethod, body, options) {
        switch (httpMethod) {
            case HttpMethod.GET:
                return this.http.get(endpoint, Object.assign(Object.assign({}, options), { withCredentials: true }));
            case HttpMethod.POST:
                return this.http.post(endpoint, body, Object.assign(Object.assign({}, options), { withCredentials: true }));
            case HttpMethod.PUT:
                return this.http.put(endpoint, body, Object.assign(Object.assign({}, options), { withCredentials: true }));
            case HttpMethod.DELETE:
                return this.http.delete(endpoint, Object.assign(Object.assign({}, options), { withCredentials: true }));
        }
    }
};
BaseHttpService.ctorParameters = () => [
    { type: HttpClient }
];
BaseHttpService.ɵprov = ɵɵdefineInjectable({ factory: function BaseHttpService_Factory() { return new BaseHttpService(ɵɵinject(HttpClient)); }, token: BaseHttpService, providedIn: "root" });
BaseHttpService = __decorate([
    Injectable({
        providedIn: 'root',
    })
], BaseHttpService);

const toDropdownOptions = (options, valueKey, labelKey) => {
    return [
        ...options.map((item) => ({
            value: item[valueKey],
            label: item[labelKey],
        })),
    ];
};

const defaultState = {
    defaultState: {
        page: 0,
        screens: {},
    },
    showWizard: false,
    toolbarActionsType: '',
};
const ɵ0 = (defaultWizardState) => ({
    defaultState: defaultWizardState,
}), ɵ1 = (showWizard) => ({
    showWizard,
}), ɵ2 = (toolbarActionsType) => ({
    toolbarActionsType,
});
const schema = {
    setDefaultState: {
        command: ɵ0,
    },
    setShowWizard: {
        command: ɵ1,
    },
    setToolbarActionsType: {
        command: ɵ2,
    },
};
const wizardConfig = (translateService) => [
    ({ title }) => ({
        fetchUrl: '/type',
        fetchMethod: 'GET',
        responseField: 'records',
        title: translateService.translate(title),
        form: (options) => ({
            fields: {
                description: {
                    type: 'text',
                    label: translateService.translate('ADMINISTRATION.CONNECTOR_DESCRIPTION'),
                    required: true,
                },
                typeKey: {
                    type: 'dropdown',
                    label: translateService.translate('ADMINISTRATION.CONNECTOR_TYPE'),
                    options: [
                        {
                            value: null,
                            label: translateService.translate('ADMINISTRATION.CHOOSE_CONNECTOR'),
                        },
                        ...toDropdownOptions(options, 'key', 'description'),
                    ],
                    required: true,
                },
                isActive: {
                    label: translateService.translate('ADMINISTRATION.STATUS'),
                    type: 'dropdown',
                    options: [
                        {
                            label: translateService.translate('ADMINISTRATION.CHOOSE_STATUS'),
                            value: null,
                        },
                        {
                            label: translateService.translate('ADMINISTRATION.ACTIVE'),
                            value: true,
                        },
                        {
                            label: translateService.translate('ADMINISTRATION.INACTIVE'),
                            value: false,
                        },
                    ],
                    required: true,
                },
            },
        }),
        response: ({ screenConfig, response }) => {
            const { form } = screenConfig;
            return form(response);
        },
        buttons: {
            cancel: {
                label: translateService.translate('ACTIONS.CANCEL'),
            },
            next: {
                label: translateService.translate('ACTIONS.NEXT'),
                componentProperties: {
                    style: { 'flex-grow': 1 },
                },
            },
        },
    }),
    ({ screens }) => ({
        fetchUrl: `/type/${screens[0].typeKey}`,
        fetchMethod: 'GET',
        title: translateService.translate('ADMINISTRATION.CONFIGURATION'),
        response: ({ response }) => {
            return response;
        },
        buttons: {
            cancel: {
                label: translateService.translate('ACTIONS.CANCEL'),
            },
            previous: {
                label: translateService.translate('ACTIONS.PREVIOUS'),
            },
            next: {
                label: translateService.translate('ACTIONS.NEXT'),
                componentProperties: {
                    style: { 'flex-grow': 1 },
                },
            },
        },
    }),
    ({ screens }) => ({
        fetchUrl: `/type/${screens[0].typeKey}/form`,
        fetchMethod: 'POST',
        body: screens[1],
        title: translateService.translate('ADMINISTRATION.ACTIONS'),
        response: ({ response }) => {
            return response;
        },
        buttons: {
            cancel: {
                label: translateService.translate('ACTIONS.CANCEL'),
            },
            previous: {
                label: translateService.translate('ACTIONS.PREVIOUS'),
            },
            submit: {
                label: translateService.translate('ACTIONS.SUBMIT'),
                componentProperties: {
                    style: { 'flex-grow': 1 },
                },
            },
        },
    }),
];

let ViewMarketplaceConnectorsComponent = class ViewMarketplaceConnectorsComponent {
    constructor(actionUi, confirmationService, translocoService, toast, spinner, adminService, http, searchContainerLoaderService, router, route) {
        this.actionUi = actionUi;
        this.confirmationService = confirmationService;
        this.translocoService = translocoService;
        this.toast = toast;
        this.spinner = spinner;
        this.adminService = adminService;
        this.http = http;
        this.searchContainerLoaderService = searchContainerLoaderService;
        this.router = router;
        this.route = route;
        // --------- toolbar actions --------
        this.toolbarActionsDispatcher = {
            new: () => {
                this.actions.setDefaultState.dispatch({
                    page: 0,
                    title: 'ADMINISTRATION.NEW_CONNECTOR_WIZARD_TITLE',
                    screens: {},
                });
                this.actions.setToolbarActionsType.dispatch('new');
                this.actions.setShowWizard.dispatch(true);
            },
            newWizard: () => {
                this.router.navigate(['/AdministrationModule/new-connection'], {
                    relativeTo: this.route,
                });
            },
            edit: (selection) => {
                var _a;
                const connectionKey = (_a = selection[0]) === null || _a === void 0 ? void 0 : _a.connectionKey;
                this.router.navigate(['/AdministrationModule/edit-connection'], {
                    relativeTo: this.route,
                    queryParams: { key: connectionKey },
                });
            },
            delete: (selection, clearSelection) => {
                this.delete(selection, clearSelection);
            },
            setActive: (selection) => {
                this.http
                    .fetch({
                    endpoint: 'connection/set-active',
                    httpMethod: 'POST',
                    body: [...selection].map((_a) => {
                        var { connectionKey } = _a, _ = __rest(_a, ["connectionKey"]);
                        return connectionKey;
                    }),
                })
                    .pipe(tap(() => {
                    this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                    this.searchContainerLoaderService.refreshSearch();
                }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))))
                    .subscribe();
            },
            setInactive: (selection) => {
                this.http
                    .fetch({
                    endpoint: 'connection/set-inactive',
                    httpMethod: 'POST',
                    body: [...selection].map((_a) => {
                        var { connectionKey } = _a, _ = __rest(_a, ["connectionKey"]);
                        return connectionKey;
                    }),
                })
                    .pipe(tap(() => {
                    this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                    this.searchContainerLoaderService.refreshSearch();
                }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))))
                    .subscribe();
            },
            pimProductPush: (selection) => {
                this.http
                    .fetch({
                    endpoint: 'connection/product-push',
                    httpMethod: 'POST',
                    body: [...selection].reduce((keys, _a) => {
                        var { connectionKey } = _a, _ = __rest(_a, ["connectionKey"]);
                        return [...keys, connectionKey];
                    }, []),
                })
                    .pipe(tap(() => {
                    this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                    this.searchContainerLoaderService.refreshSearch();
                }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))))
                    .subscribe();
            },
        };
        // --------- search configs --------
        this.searchContainerName = 'marketplaceConnectorsSearch';
        this.i18nSearchField = 'MARKETPLACE_CONNECTORS.SEARCH';
        this.templateTypes = TemplateTypes;
        this.actions = Action.createDispatcher(schema);
        this.subscriptions = [];
        this.baseUrl = `${this.adminService.getConfig().getConnectorEndpoint}/connection`;
        this.wizardUrl = this.adminService.getConfig().getConnectorEndpoint;
        http.baseUrl = adminService.getConfig().getConnectorEndpoint;
    }
    ngOnInit() {
        this.actionUi.initialize(defaultState, this.actions);
        this.actionUi.state
            .pipe(tap((state) => (this.state = Object.assign({}, state))), takeUntil(this.actionUi.shouldDestroy))
            .subscribe();
        this.wizardConfig = wizardConfig(this.translocoService);
        this.searchContainerLoaderService.searchError$
            .pipe(tap(() => this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE'))), takeUntil(this.actionUi.shouldDestroy))
            .subscribe();
        this.searchContainerLoaderService.searchConfigError$
            .pipe(tap(() => this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE'))), takeUntil(this.actionUi.shouldDestroy))
            .subscribe();
    }
    delete(data, clearSelection) {
        this.confirmationService.confirm({
            message: this.translocoService.translate('VALIDATION_MESSAGE.CONFIRMATION_MESSAGE'),
            header: this.translocoService.translate('VALIDATION_MESSAGE.CONFIRMATION_HEADER'),
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: this.translocoService.translate('ACTIONS.YES'),
            rejectLabel: this.translocoService.translate('ACTIONS.NO'),
            accept: () => {
                this.http
                    .fetch({
                    endpoint: 'connection/delete',
                    httpMethod: 'POST',
                    body: [...data].reduce((keys, _a) => {
                        var { connectionKey } = _a, _ = __rest(_a, ["connectionKey"]);
                        return [...keys, connectionKey];
                    }, []),
                })
                    .pipe(tap(() => {
                    this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                    this.searchContainerLoaderService.refreshSearch();
                }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))))
                    .subscribe();
                clearSelection();
            },
            reject: () => {
                clearSelection();
            },
        });
    }
    data(data) {
        this.state.toolbarActionsType === 'new'
            ? this.http
                .fetch({
                endpoint: 'connection',
                httpMethod: 'POST',
                body: {
                    typeKey: data[0].typeKey,
                    description: data[0].description,
                    fieldJson: JSON.stringify(data),
                    isActive: data[0].isActive,
                },
            })
                .pipe(tap(() => {
                this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                this.searchContainerLoaderService.refreshSearch();
            }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))))
                .subscribe()
            : this.http
                .fetch({
                endpoint: `connection/${this.selectionConnectionKey}`,
                httpMethod: 'PUT',
                body: {
                    typeKey: data[0].typeKey,
                    description: data[0].description,
                    fieldJson: JSON.stringify(data),
                    isActive: data[0].isActive,
                },
            })
                .pipe(tap(() => {
                this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                this.searchContainerLoaderService.refreshSearch();
            }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))))
                .subscribe();
        this.actions.setShowWizard.dispatch(false);
    }
};
ViewMarketplaceConnectorsComponent.ctorParameters = () => [
    { type: ActionUiService },
    { type: ConfirmationService$1 },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: SpinnerService },
    { type: AdministrationService },
    { type: BaseHttpService },
    { type: SearchContainerLoaderService },
    { type: Router },
    { type: ActivatedRoute }
];
ViewMarketplaceConnectorsComponent = __decorate([
    Component({
        selector: 'lib-view-marketplace-connectors',
        template: "<h2>{{ 'MARKETPLACE_CONNECTORS.MARKETPLACE_CONNECTORS' | transloco }}</h2>\r\n<lib-search-container-loader\r\n  [searchContainerName]=\"searchContainerName\"\r\n  [i18nSearchField]=\"i18nSearchField\"\r\n  [toolbarActionsDispatcher]=\"toolbarActionsDispatcher\"\r\n  [params]=\"params\"\r\n  [disableAdvancedSearch]=\"true\"\r\n  [baseUrl]=\"baseUrl\"\r\n></lib-search-container-loader>\r\n\r\n<p-dialog\r\n  *ngIf=\"state.showWizard\"\r\n  [visible]=\"true\"\r\n  [showHeader]=\"false\"\r\n  [modal]=\"true\"\r\n  position=\"center\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [responsive]=\"true\"\r\n  [focusOnShow]=\"false\"\r\n  styleClass=\"lbmx-modal\"\r\n  data-testid=\"newConnectorDialog\"\r\n>\r\n  <lib-wizard\r\n    [wizardConfig]=\"wizardConfig\"\r\n    [defaultState]=\"state.defaultState\"\r\n    (finalize)=\"data($event)\"\r\n    (cancel)=\"actions.setShowWizard.dispatch(false)\"\r\n  ></lib-wizard>\r\n</p-dialog>\r\n",
        providers: [SearchContainerLoaderService]
    })
], ViewMarketplaceConnectorsComponent);

const ɵ0$1 = { breadcrumb: 'BREADCRUMB.MARKETPLACE_CONNECTORS' }, ɵ1$1 = { breadcrumb: 'BREADCRUMB.MARKETPLACE_CONNECTORS' }, ɵ2$1 = { breadcrumb: 'BREADCRUMB.MARKETPLACE_CONNECTORS' };
const routes = [
    {
        path: 'marketplace-connectors',
        component: MarketplaceConnectorComponent,
        data: ɵ0$1,
        children: [{ path: '', component: ViewMarketplaceConnectorsComponent }],
    },
    {
        path: 'new-connection',
        component: NewConnectionWizardComponent,
        data: ɵ1$1,
    },
    {
        path: 'edit-connection',
        component: EditConnectionWizardComponent,
        data: ɵ2$1,
    },
];

let AccountingConfigurationComponent = class AccountingConfigurationComponent {
    constructor(translocoService) {
        this.translocoService = translocoService;
        this.items = [];
        this.subscriptions = [];
    }
    ngOnInit() {
        this.translateTabNames();
    }
    translateTabNames() {
        this.subscriptions.push(this.translocoService
            .selectTranslate('ADMINISTRATION')
            .pipe(map((translate) => translate), tap((translate) => {
            this.items = [
                {
                    label: translate.TAB_ACCOUNTING_CONFIGURATION_RECEIVABLE,
                    routerLink: 'receivable',
                },
                {
                    label: translate.TAB_ACCOUNTING_CONFIGURATION_PAYABLE,
                    routerLink: 'payable',
                },
            ];
        }))
            .subscribe());
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
};
AccountingConfigurationComponent.ctorParameters = () => [
    { type: TranslocoService }
];
AccountingConfigurationComponent = __decorate([
    Component({
        selector: 'lib-accounting-configuration',
        template: "<h2>{{ 'ADMINISTRATION.ACCOUNTING_CONFIGURATION' | transloco }}</h2>\r\n<div>\r\n  <p-tabMenu [model]=\"items\"></p-tabMenu>\r\n  <router-outlet></router-outlet>\r\n</div>\r\n"
    })
], AccountingConfigurationComponent);

let PayableComponent = class PayableComponent {
    constructor(translocoService, toast, spinner, router, route, adminService, http, searchContainerLoaderService) {
        this.translocoService = translocoService;
        this.toast = toast;
        this.spinner = spinner;
        this.router = router;
        this.route = route;
        this.adminService = adminService;
        this.http = http;
        this.searchContainerLoaderService = searchContainerLoaderService;
        this.showDialog = false;
        this.showEdit = false;
        this.showView = false;
        this.showBulkUpdate = false;
        // search container loader states
        this.searchContainerName = 'accountingConfigurationPayable';
        this.i18nSearchField = 'COMPANY.SEARCH';
        this.toolbarActionsDispatcher = {
            view: (selection) => {
                this.showDialog = true;
                this.showView = true;
                this.data = Object.assign({}, selection[0]);
            },
            edit: (selection) => {
                this.showDialog = true;
                this.showEdit = true;
                this.data = Object.assign({}, selection[0]);
            },
            editList: (selection) => { },
            bulkUpdate: (selection) => {
                this.showDialog = true;
                this.showBulkUpdate = true;
                this.data = {
                    baseUrl: this.baseUrl,
                    selectedAccounts: [...selection].map((_a) => {
                        var { accountRelationshipKey } = _a, _ = __rest(_a, ["accountRelationshipKey"]);
                        return accountRelationshipKey;
                    }),
                };
            },
            payConfiguration: (selection) => {
                var _a;
                const supplierKey = (_a = selection[0]) === null || _a === void 0 ? void 0 : _a.accountKey_Partner;
                this.router.navigate(['../../accounts-payable/pay-configuration'], {
                    relativeTo: this.route,
                    queryParams: { key: supplierKey },
                });
            },
        };
        this.baseUrl = `${this.adminService.getConfig().getAccountRootURL}/administration/accounts-payable`;
        this.columnActions = {};
        this._shouldDestroy = new Subject();
        http.baseUrl = adminService.getConfig().getAccountRootURL;
    }
    ngOnInit() {
        this.translocoService
            .selectTranslate('ADMINISTRATION')
            .pipe(tap((translate) => (this.translate = translate)))
            .subscribe();
    }
    closeDialog() {
        this.showDialog = false;
        this.showEdit = false;
        this.showView = false;
        this.showBulkUpdate = false;
    }
    saveBulkUpdate(formValues) {
        const _a = this.searchContainerLoaderService.getCurrentSearchDetails(), { filters } = _a, pagination = __rest(_a, ["filters"]);
        this.spinner.on();
        this.http
            .fetchWithFqn({
            endpoint: `${this.baseUrl}/bulk-update`,
            httpMethod: 'POST',
            body: Object.assign(Object.assign({}, formValues), { keys: this.data.selectedAccounts, search: {
                    page: { offset: pagination === null || pagination === void 0 ? void 0 : pagination.first, limit: pagination === null || pagination === void 0 ? void 0 : pagination.rows },
                    sort: {
                        field: pagination === null || pagination === void 0 ? void 0 : pagination.sortField,
                        order: pagination === null || pagination === void 0 ? void 0 : pagination.sortOrder,
                    },
                    search: {
                        filters: this.searchContainerLoaderService.filters,
                        term: (filters === null || filters === void 0 ? void 0 : filters.term) ? filters === null || filters === void 0 ? void 0 : filters.term : '',
                    },
                } }),
        })
            .pipe(tap((response) => {
            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
            this.showDialog = false;
            this.showBulkUpdate = false;
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => {
            this.showDialog = false;
            this.showBulkUpdate = false;
            this.spinner.off();
        }), takeUntil(this._shouldDestroy))
            .subscribe();
    }
    save(payable) {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: 'administration/accounts-payable',
            httpMethod: 'POST',
            body: payable,
        })
            .pipe(tap(() => {
            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()), takeUntil(this._shouldDestroy))
            .subscribe();
        this.closeDialog();
    }
    ngOnDestroy() {
        this._shouldDestroy.next(true);
    }
};
PayableComponent.ctorParameters = () => [
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: SpinnerService },
    { type: Router },
    { type: ActivatedRoute },
    { type: AdministrationService },
    { type: BaseHttpService },
    { type: SearchContainerLoaderService }
];
PayableComponent = __decorate([
    Component({
        selector: 'lib-payable',
        template: "<div style=\"padding-top: 2rem\">\r\n  <lib-search-container-loader\r\n    [searchContainerName]=\"searchContainerName\"\r\n    [i18nSearchField]=\"i18nSearchField\"\r\n    [toolbarActionsDispatcher]=\"toolbarActionsDispatcher\"\r\n    [baseUrl]=\"baseUrl\"\r\n    [columnActions]=\"columnActions\"\r\n  ></lib-search-container-loader>\r\n\r\n  <p-dialog\r\n    *ngIf=\"showDialog\"\r\n    [visible]=\"true\"\r\n    [modal]=\"true\"\r\n    [style]=\"{ width: '600px' }\"\r\n    [baseZIndex]=\"10000\"\r\n    [draggable]=\"false\"\r\n    [resizable]=\"false\"\r\n    [showHeader]=\"false\"\r\n    [focusOnShow]=\"false\"\r\n    position=\"center\"\r\n  >\r\n    <lib-edit-form\r\n      *ngIf=\"showEdit\"\r\n      [data]=\"data\"\r\n      [translate]=\"translate\"\r\n      (closeDialog)=\"closeDialog()\"\r\n      (saveDialog)=\"save($event)\"\r\n    ></lib-edit-form>\r\n\r\n    <lib-view-form\r\n      *ngIf=\"showView\"\r\n      [data]=\"data\"\r\n      [translate]=\"translate\"\r\n      (closeDialog)=\"closeDialog()\"\r\n    ></lib-view-form>\r\n\r\n    <lib-ap-bulk-update-container\r\n      *ngIf=\"showBulkUpdate\"\r\n      [translate]=\"translate\"\r\n      [baseUrl]=\"data.baseUrl\"\r\n      [selectedAccounts]=\"data.selectedAccounts\"\r\n      (closeDialog)=\"closeDialog()\"\r\n      (saveDialog)=\"saveBulkUpdate($event)\"\r\n    ></lib-ap-bulk-update-container>\r\n  </p-dialog>\r\n</div>\r\n",
        providers: [SearchContainerLoaderService]
    })
], PayableComponent);

let ReceivableComponent = class ReceivableComponent {
    constructor(translocoService, toast, spinner, adminService, http, searchContainerLoaderService) {
        this.translocoService = translocoService;
        this.toast = toast;
        this.spinner = spinner;
        this.adminService = adminService;
        this.http = http;
        this.searchContainerLoaderService = searchContainerLoaderService;
        this.showView = false;
        this.showEdit = false;
        this.showBulkUpdate = false;
        // search container loader states
        this.searchContainerName = 'accountingConfigurationReceivable';
        this.i18nSearchField = 'COMPANY.SEARCH';
        this.toolbarActionsDispatcher = {
            view: (selection) => {
                this.showView = true;
                this.data = Object.assign({}, selection[0]);
            },
            edit: (selection) => {
                this.showEdit = true;
                this.data = Object.assign({}, selection[0]);
            },
            bulkUpdate: (selection) => {
                this.showBulkUpdate = true;
                this.data = {
                    baseUrl: this.baseUrl,
                    selectedAccounts: [...selection].map((_a) => {
                        var { accountRelationshipKey } = _a, _ = __rest(_a, ["accountRelationshipKey"]);
                        return accountRelationshipKey;
                    }),
                };
            },
            editList: (selection) => { },
        };
        this.baseUrl = `${this.adminService.getConfig().getAccountRootURL}/administration/accounts-receivable`;
        this.columnActions = {};
        this._shouldDestroy = new Subject();
        http.baseUrl = adminService.getConfig().getAccountRootURL;
    }
    ngOnInit() {
        this.translocoService
            .selectTranslate('ADMINISTRATION')
            .pipe(tap((translate) => (this.translate = translate)))
            .subscribe();
    }
    closeDialog() {
        this.showView = false;
        this.showEdit = false;
        this.showBulkUpdate = false;
    }
    saveBulkUpdate(formValues) {
        const _a = this.searchContainerLoaderService.getCurrentSearchDetails(), { filters } = _a, pagination = __rest(_a, ["filters"]);
        this.spinner.on();
        this.http
            .fetchWithFqn({
            endpoint: `${this.baseUrl}/bulk-update`,
            httpMethod: 'POST',
            body: Object.assign(Object.assign({}, formValues), { keys: this.data.selectedAccounts, search: {
                    page: { offset: pagination === null || pagination === void 0 ? void 0 : pagination.first, limit: pagination === null || pagination === void 0 ? void 0 : pagination.rows },
                    sort: {
                        field: pagination === null || pagination === void 0 ? void 0 : pagination.sortField,
                        order: pagination === null || pagination === void 0 ? void 0 : pagination.sortOrder,
                    },
                    search: {
                        filters: this.searchContainerLoaderService.filters,
                        term: (filters === null || filters === void 0 ? void 0 : filters.term) ? filters === null || filters === void 0 ? void 0 : filters.term : '',
                    },
                } }),
        })
            .pipe(tap((response) => {
            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
            this.showBulkUpdate = false;
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => {
            this.showBulkUpdate = false;
            this.spinner.off();
        }), takeUntil(this._shouldDestroy))
            .subscribe();
    }
    save(payable) {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: 'administration/accounts-receivable',
            httpMethod: 'POST',
            body: payable,
        })
            .pipe(tap(() => {
            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()), takeUntil(this._shouldDestroy))
            .subscribe();
        this.closeDialog();
    }
    ngOnDestroy() {
        this._shouldDestroy.next(true);
    }
};
ReceivableComponent.ctorParameters = () => [
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: SpinnerService },
    { type: AdministrationService },
    { type: BaseHttpService },
    { type: SearchContainerLoaderService }
];
ReceivableComponent = __decorate([
    Component({
        selector: 'lib-receivable',
        template: "<div style=\"padding-top: 2rem\">\r\n  <lib-search-container-loader\r\n    [searchContainerName]=\"searchContainerName\"\r\n    [i18nSearchField]=\"i18nSearchField\"\r\n    [toolbarActionsDispatcher]=\"toolbarActionsDispatcher\"\r\n    [baseUrl]=\"baseUrl\"\r\n    [columnActions]=\"columnActions\"\r\n  ></lib-search-container-loader>\r\n\r\n  <p-dialog\r\n    *ngIf=\"showEdit || showView || showBulkUpdate\"\r\n    [visible]=\"true\"\r\n    [modal]=\"true\"\r\n    [style]=\"{ width: '600px' }\"\r\n    [baseZIndex]=\"10000\"\r\n    [draggable]=\"false\"\r\n    [resizable]=\"false\"\r\n    [showHeader]=\"false\"\r\n    [focusOnShow]=\"false\"\r\n    position=\"center\"\r\n  >\r\n    <lib-receivable-edit-form\r\n      *ngIf=\"showEdit\"\r\n      [data]=\"data\"\r\n      [translate]=\"translate\"\r\n      (closeDialog)=\"closeDialog()\"\r\n      (saveDialog)=\"save($event)\"\r\n    ></lib-receivable-edit-form>\r\n\r\n    <lib-receivable-view-form\r\n      *ngIf=\"showView\"\r\n      [data]=\"data\"\r\n      [translate]=\"translate\"\r\n      (closeDialog)=\"closeDialog()\"\r\n    ></lib-receivable-view-form>\r\n\r\n    <lib-ar-bulk-update-container\r\n      *ngIf=\"showBulkUpdate\"\r\n      [translate]=\"translate\"\r\n      [baseUrl]=\"data.baseUrl\"\r\n      [selectedAccounts]=\"data.selectedAccounts\"\r\n      (closeDialog)=\"closeDialog()\"\r\n      (saveDialog)=\"saveBulkUpdate($event)\"\r\n    ></lib-ar-bulk-update-container>\r\n  </p-dialog>\r\n</div>\r\n",
        providers: [SearchContainerLoaderService]
    })
], ReceivableComponent);

const ɵ0$2 = { breadcrumb: 'NAV.ACCOUNTING_CONFIGURATION' }, ɵ1$2 = { breadcrumb: { skip: true } }, ɵ2$2 = { breadcrumb: { skip: true } };
const routes$1 = [
    {
        path: 'accounting-configuration',
        component: AccountingConfigurationComponent,
        data: ɵ0$2,
        children: [
            {
                path: '',
                redirectTo: 'receivable',
                pathMatch: 'full',
            },
            {
                path: 'receivable',
                component: ReceivableComponent,
                data: ɵ1$2,
            },
            {
                path: 'payable',
                component: PayableComponent,
                data: ɵ2$2,
            },
        ],
    },
];

let AccountControlService = class AccountControlService {
    constructor(baseApiService, adminService) {
        this.baseApiService = baseApiService;
        this.adminService = adminService;
    }
    get() {
        this.baseApiService.set(`${this.adminService.getConfig().getAccountEndpoint}/accountcontrol`);
        return this.baseApiService.get();
    }
    update(accountControlKey, request) {
        this.baseApiService.set(`${this.adminService.getConfig().getAccountEndpoint}/accountcontrol/${accountControlKey}`);
        return this.baseApiService.put(request);
    }
    getImageUrl(accountAssetKey, accountKey) {
        return `${this.adminService.getConfig().accountAssetsEndPoint}/${accountAssetKey}?accountKey=${accountKey}`;
    }
    deleteMarketplaceAssetKey(accountControlKey, request) {
        this.baseApiService.set(`${this.adminService.getConfig().getAccountEndpoint}/accountcontrol/${accountControlKey}`);
        request.imgAccountAssetKey = null;
        return this.baseApiService.put(request);
    }
    deleteMarketplaceImage(imgAccountAssetKey) {
        this.baseApiService.set(`${this.adminService.getConfig().accountAssetsEndPoint}/deleteAccountAsset`);
        return this.baseApiService.post(imgAccountAssetKey);
    }
};
AccountControlService.ctorParameters = () => [
    { type: BaseAPIService },
    { type: AdministrationService }
];
AccountControlService.ɵprov = ɵɵdefineInjectable({ factory: function AccountControlService_Factory() { return new AccountControlService(ɵɵinject(BaseAPIService), ɵɵinject(AdministrationService)); }, token: AccountControlService, providedIn: "root" });
AccountControlService = __decorate([
    Injectable({
        providedIn: 'root',
    })
], AccountControlService);

let MarketplaceControlComponent = class MarketplaceControlComponent {
    constructor(accountControlService, adminService, spinner, transloco, toast) {
        this.accountControlService = accountControlService;
        this.adminService = adminService;
        this.spinner = spinner;
        this.transloco = transloco;
        this.toast = toast;
        this.uploadImageUrl = '';
        this.imageSource = '';
        this.subscriptions = [];
    }
    ngOnInit() {
        this.uploadImageUrl = this.adminService.getConfig().accountAssetsEndPoint;
        this.spinner.on();
        this.accountMessage$ = this.accountControlService.get().pipe(tap((accountControl) => {
            var _a, _b;
            try {
                const accountAssetKey = Number((_a = accountControl === null || accountControl === void 0 ? void 0 : accountControl.accountControl) === null || _a === void 0 ? void 0 : _a.imgAccountAssetKey);
                this.imageSource =
                    accountAssetKey > 0
                        ? this.accountControlService.getImageUrl(accountAssetKey, (_b = accountControl === null || accountControl === void 0 ? void 0 : accountControl.accountControl) === null || _b === void 0 ? void 0 : _b.accountKey)
                        : '';
            }
            catch (_c) {
                /*empty */
            }
            return accountControl;
        }), catchError(() => of(this.toast.errorNotify(this.transloco.translate('SUPPLIER.FAILURE_TOAST_MESSAGE')))), finalize(() => {
            this.spinner.off();
        }));
    }
    updateMessages(accountControl) {
        (accountControl === null || accountControl === void 0 ? void 0 : accountControl.accountControlKey) > 0
            ? this.update(accountControl, accountControl === null || accountControl === void 0 ? void 0 : accountControl.accountControlKey)
            : this.update(accountControl, 0);
    }
    update(accountControl, key) {
        this.spinner.on();
        this.subscriptions.push(this.accountControlService
            .update(key, {
            imgAccountAssetKey: accountControl === null || accountControl === void 0 ? void 0 : accountControl.imgAccountAssetKey,
            welcomeMessage: accountControl === null || accountControl === void 0 ? void 0 : accountControl.welcomeMessage,
            welcomeNews: accountControl === null || accountControl === void 0 ? void 0 : accountControl.welcomeNews,
        })
            .pipe(tap(() => {
            this.toast.successNotify(this.transloco.translate('SUPPLIER.SUCCESS_TOAST_MESSAGE'));
        }), catchError(() => of(this.toast.errorNotify(this.transloco.translate('SUPPLIER.FAILURE_TOAST_MESSAGE')))), finalize(() => {
            this.spinner.off();
        }))
            .subscribe());
    }
};
MarketplaceControlComponent.ctorParameters = () => [
    { type: AccountControlService },
    { type: AdministrationService },
    { type: SpinnerService },
    { type: TranslocoService },
    { type: ToastrNotificationService }
];
MarketplaceControlComponent = __decorate([
    Component({
        selector: 'lib-marketplace-control',
        template: `<lib-marketplace-control-view
    id="marketplace-controls"
    class="marketplace-controls"
    [accountMessage]="accountMessage$ | async"
    [imageSource]="imageSource"
    [uploadImageUrl]="uploadImageUrl"
    (update)="updateMessages($event)"
  ></lib-marketplace-control-view>`
    })
], MarketplaceControlComponent);

let UserService = class UserService {
    constructor(baseApiService, http, adminService) {
        this.baseApiService = baseApiService;
        this.http = http;
        this.adminService = adminService;
        this.permissionList = [];
        this.selectedNodes = [];
    }
    searchUser(request) {
        this.baseApiService.set(this.adminService.getConfig().searchUserEndpoint);
        return this.baseApiService.post(request);
    }
    addUser(request) {
        this.baseApiService.set(this.adminService.getConfig().addUserEndpoint);
        return this.baseApiService.post(request);
    }
    copyUser(request) {
        this.baseApiService.set(this.adminService.getConfig().copyUserEndpoint);
        return this.baseApiService.post(request);
    }
    updateUser(request) {
        this.baseApiService.set(this.adminService.getConfig().updateUserEndpoint);
        return this.baseApiService.post(request);
    }
    deleteUser(request) {
        this.baseApiService.set(this.adminService.getConfig().deleteUserEndpoint);
        return this.baseApiService.post(request);
    }
    exportUsers(request) {
        this.baseApiService.set(this.adminService.getConfig().exportUsersEndpoint);
        return this.baseApiService.post(request, {
            responseType: 'blob',
            observe: 'response',
        });
    }
    getPermissionsList() {
        this.baseApiService.set(this.adminService.getConfig().listPermissionsEndpoint);
        return this.baseApiService.get();
    }
    getLanguageTypes() {
        this.baseApiService.set(this.adminService.getConfig().languageTypesEndpoint);
        return this.baseApiService
            .get()
            .pipe(map((response) => response.languageTypes));
    }
    getTimeZoneTypes() {
        this.baseApiService.set(this.adminService.getConfig().timeZoneTypesEndpoint);
        return this.baseApiService
            .get()
            .pipe(map((response) => response.timeZoneTypeResponse));
    }
    getDateFormatTypes() {
        this.baseApiService.set(this.adminService.getConfig().dateFormatTypesEndpoint);
        return this.baseApiService
            .get()
            .pipe(map((response) => response.dateFormatTypeResponse));
    }
    getCountries() {
        this.baseApiService.set(`${this.adminService.getConfig().getConfigEndpoint}/country`);
        return this.baseApiService.get();
    }
    getAccount() {
        this.baseApiService.set(this.adminService.getConfig().getAccountEndpoint);
        return this.baseApiService.get().pipe(map((accountResponse) => {
            return Object.assign(Object.assign({}, accountResponse.account), { details: accountResponse.account.details[0] });
        }));
    }
    restructureList(list) {
        this.permissionList = [];
        for (const val in list) {
            if (list[val].toolKey_Parent >= 0 && list[val].toolKey !== 1) {
                // Converts the current node to  TreeNode
                const currentNode = {
                    label: list[val].description,
                    data: {
                        toolKey: list[val].toolKey,
                        toolKey_Parent: list[val].toolKey_Parent,
                        description: list[val].description,
                        name: list[val].name,
                    },
                    children: [],
                };
                // Append the current treenode into TreeNode[] at it's appropriate position- either as a
                // parent or as a child to its parent
                this.appendToTreeData(currentNode, list);
            }
        }
        return this.permissionList;
    }
    checkNodes(nodes, user) {
        this.selectedNodes = [];
        this.checkNodesHelper(nodes, user);
        return this.selectedNodes;
    }
    checkNodesHelper(nodes, user) {
        nodes.forEach((node) => {
            if (this.isNodeSelected(node, user)) {
                this.selectedNodes.push(node);
            }
            this.checkNodesHelper(node.children, user);
        });
    }
    isNodeSelected(currentNode, user) {
        return user.permissions.includes(currentNode.data.toolKey);
    }
    isNodePartialSelected(currentNode, user) {
        const someChildrenSelected = (children) => {
            if (children.some((node) => node.partialSelected)) {
                return true;
            }
            const count = children.reduce((sum, node) => sum +
                (node.partialSelected || this.isNodeSelected(node, user) ? 1 : 0), 0);
            return count > 0 && count < children.length;
        };
        currentNode.partialSelected = someChildrenSelected(currentNode.children);
        return currentNode.partialSelected;
    }
    appendToTreeData(currentNode, list) {
        if (currentNode.data.toolKey_Parent === 0) {
            if (this.permissionList.filter((x) => x.data.toolKey === currentNode.data.toolKey).length === 0 ||
                this.permissionList.length === 0) {
                this.permissionList.push(currentNode);
            }
            return {
                index: this.permissionList.findIndex((x) => x.data.toolKey === currentNode.data.toolKey),
                newPermissionlist: this.permissionList,
            };
        }
        else {
            const parentIndex = list.findIndex((x) => x.toolKey === currentNode.data.toolKey_Parent);
            const parentNode = {
                label: list[parentIndex].description,
                data: {
                    toolKey: list[parentIndex].toolKey,
                    toolKey_Parent: list[parentIndex].toolKey_Parent,
                    description: list[parentIndex].description,
                    name: list[parentIndex].name,
                },
                children: [],
            };
            const response = this.appendToTreeData(parentNode, list);
            const index = response.newPermissionlist[response.index].children.findIndex((x) => x.data.toolKey === currentNode.data.toolKey);
            if (index === -1) {
                response.newPermissionlist[response.index].children.push(currentNode);
            }
            return {
                index: response.newPermissionlist[response.index].children.findIndex((x) => x.data.toolKey === currentNode.data.toolKey),
                newPermissionlist: response.newPermissionlist[response.index].children,
            };
        }
    }
    getAllSelectedToolKeys(selectedNodes) {
        const finalToolKeyList = [];
        selectedNodes.map((node) => {
            finalToolKeyList.push(node.data.toolKey);
        });
        return finalToolKeyList.sort((a, b) => (a > b ? 1 : -1));
    }
};
UserService.ctorParameters = () => [
    { type: BaseAPIService },
    { type: HttpClient },
    { type: AdministrationService }
];
UserService.ɵprov = ɵɵdefineInjectable({ factory: function UserService_Factory() { return new UserService(ɵɵinject(BaseAPIService), ɵɵinject(HttpClient), ɵɵinject(AdministrationService)); }, token: UserService, providedIn: "root" });
UserService = __decorate([
    Injectable({
        providedIn: 'root',
    })
], UserService);

var routePermissions = {
    'accounting-configuration': toolKeys.ADMINISTRATION_ACCOUNTING_CONFIGURATION,
    'accounting-configuration_receivable': toolKeys.ADMINISTRATION_ACCOUNTING_CONFIGURATION,
    'accounting-configuration_payable': toolKeys.ADMINISTRATION_ACCOUNTING_CONFIGURATION,
    'accounts-payable_pay-configuration': toolKeys.ADMINISTRATION_ACCOUNTING_CONFIGURATION_EDIT,
    user: toolKeys.ADMINISTRATION_MAINTAIN_USERS,
    user_add: toolKeys.ADMINISTRATION_MAINTAIN_USERS_NEW,
    user_copy: toolKeys.ADMINISTRATION_MAINTAIN_USERS_COPY,
    user_update: toolKeys.ADMINISTRATION_MAINTAIN_USERS_EDIT,
    'marketplace-controls': toolKeys.ADMINISTRATION_MARKETPLACE_CONTROLS,
    'marketplace-connectors': toolKeys.ADMINISTRATION_MARKETPLACE_CONNECTORS,
    'new-connection': toolKeys.ADMINISTRATION_MARKETPLACE_CONNECTORS,
    'edit-connection': toolKeys.ADMINISTRATION_MARKETPLACE_CONNECTORS,
    'data-cross-reference': toolKeys.ADMINISTRATION_DATA_CROSSREFERENCE,
    tagging: toolKeys.ADMINISTRATION_USER_DEFINED_TAGS,
};

var buttonPermissions = {
    user_add: toolKeys.ADMINISTRATION_MAINTAIN_USERS_NEW,
    user_copy: toolKeys.ADMINISTRATION_MAINTAIN_USERS_COPY,
    user_update: toolKeys.ADMINISTRATION_MAINTAIN_USERS_EDIT,
    user_delete: toolKeys.ADMINISTRATION_MAINTAIN_USERS_DELETE,
    user_export: toolKeys.ADMINISTRATION_MAINTAIN_USERS_EXPORT,
};

let ViewusersComponent = class ViewusersComponent {
    constructor(router, userService, loggerService, spinnerService, toastrSrv, datePipe, confirmSrv, translocoService, route, store, formBuilder) {
        this.router = router;
        this.userService = userService;
        this.loggerService = loggerService;
        this.spinnerService = spinnerService;
        this.toastrSrv = toastrSrv;
        this.datePipe = datePipe;
        this.confirmSrv = confirmSrv;
        this.translocoService = translocoService;
        this.route = route;
        this.store = store;
        this.formBuilder = formBuilder;
        // search container related variables
        this.users$ = of([]);
        this.buttons$ = this.translocoService
            .selectTranslate('ACTIONS')
            .pipe(startWith([]), map((translations) => [
            {
                name: 'new',
                label: translations.NEW,
                mode: 0 /* ALWAYS */,
                disabled: false,
                toolKey: buttonPermissions.user_add,
            },
            {
                name: 'copy',
                label: translations.COPY,
                mode: 1 /* SINGLE */,
                disabled: false,
                toolKey: buttonPermissions.user_copy,
            },
            {
                name: 'edit',
                label: translations.EDIT,
                mode: 1 /* SINGLE */,
                disabled: false,
                toolKey: buttonPermissions.user_update,
            },
            {
                name: 'delete',
                label: translations.DELETE,
                mode: 2 /* MULTIPLE */,
                disabled: false,
                toolKey: buttonPermissions.user_delete,
            },
            {
                name: 'export',
                label: translations.EXPORT,
                mode: 0 /* ALWAYS */,
                disabled: false,
                toolKey: buttonPermissions.user_export,
            },
        ]), withLatestFrom(this.store
            .select(selectors.userProfile)
            .pipe(map((profile) => new Set(profile.toolKeys)))), map(([buttons, userToolKeySet]) => buttons.filter((b) => userToolKeySet.has(b.toolKey))));
        this.displayedColumns = [];
        this.isLoading = true;
        this.showExport = false;
        this.subscriptions = [];
        this.formGroup = this.formBuilder.group({
            selectedExport: new FormControl('', [Validators.required]),
        });
    }
    ngOnInit() {
        setTimeout(() => {
            this.columns = [
                {
                    field: 'fullname',
                    header: this.translocoService.translate('ADMINISTRATION.NAME'),
                },
                {
                    field: 'username',
                    header: this.translocoService.translate('ADMINISTRATION.USERNAME'),
                },
                {
                    field: 'lastLogin',
                    header: this.translocoService.translate('ADMINISTRATION.LASTLOGIN'),
                },
            ];
        }, 0);
        this.displayedColumns = ['fullname', 'username', 'lastLogin'];
        this.paging = {
            sizes: [25, 50, 75, 100],
            page: { first: 0, rows: 25 },
            records: 250,
        };
        this.searchUsers({ filters: { searchText: null } });
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    searchUsers($event) {
        this.isLoading = true;
        this.searchText = $event.filters.searchText;
        this.users$ = forkJoin([
            this.store.select(selectors.userProfile).pipe(first(), map((profile) => profile.userInfo.DateTypeFormat)),
            this.userService.searchUser({ name: this.searchText }).pipe(map((response) => response.userDetailsResponse || []), tap((users) => (this.paging.records = users.length))),
        ]).pipe(map(([dateFormat, users]) => users.map((user) => (Object.assign(Object.assign({}, user), { lastLogin: this.datePipe.transform(user.lastLogin, dateFormat) })))), tap(() => (this.isLoading = false)));
    }
    deleteUsers(users, clearSelection) {
        this.confirmSrv.confirm({
            message: this.translocoService.translate('ADMINISTRATION.DELETE_CONFIRMATION_TEXT'),
            header: this.translocoService.translate('ADMINISTRATION.DELETE_DIALOG_HEADER'),
            acceptLabel: this.translocoService.translate('ACTIONS.YES'),
            rejectLabel: this.translocoService.translate('ACTIONS.NO'),
            icon: 'pi pi-info-circle',
            accept: () => {
                this.spinnerService.on();
                this.subscriptions.push(this.userService
                    .deleteUser(this.buildDeleteRequest(users))
                    .pipe(finalize(() => this.spinnerService.off()))
                    .subscribe((response) => {
                    this.loggerService.info('DeleteUserResponse', 'DeleteusersService.getUsers', JSON.stringify(response));
                    this.toastrSrv.successNotify(this.translocoService.translate('ADMINISTRATION.DELETE_USER_SUCCESS'));
                    clearSelection();
                }, (error) => {
                    this.loggerService.error('DeleteUserResponse', 'DeleteusersService.getUsers', error);
                    this.toastrSrv.errorNotify(this.translocoService.translate('ADMINISTRATION.DELETE_USER_FAILURE'));
                }));
            },
            reject: () => {
                this.toastrSrv.infoNotify('Delete option rejected');
            },
        });
    }
    exportUsers() {
        if (this.formGroup.valid) {
            this.showExport = false;
            const exportRequest = {
                searchWord: this.searchText,
                selectionType: this.formGroup.get('selectedExport').value.value,
                selectedUserIds: this.selectedIds,
            };
            this.spinnerService.on();
            this.subscriptions.push(this.userService
                .exportUsers(exportRequest)
                .pipe(finalize(() => this.spinnerService.off()))
                .subscribe((resp) => {
                // get filename from server headers
                const cd = resp.headers.get('content-disposition');
                const fn = cd.split(';')[1];
                const fname = fn.substring(fn.indexOf('=') + 1);
                saveAs(resp.body, fname);
            }));
        }
    }
    clear() {
        this.searchUsers({ filters: {} });
    }
    //#region  Helpers
    buildDeleteRequest(users) {
        const request = {
            userKeys: '[' +
                users
                    .map((x) => {
                    return x.userKey;
                })
                    .toString() +
                ']',
        };
        return request;
    }
    onToolbarClick({ command, selection, clearSelection }) {
        const [firstSelection] = selection;
        this.selectedIds = selection.map((u) => u.userKey);
        switch (command) {
            case 'new':
                this.router.navigate(['add'], {
                    relativeTo: this.route,
                });
                break;
            case 'copy':
                this.router.navigate(['copy'], {
                    relativeTo: this.route,
                    queryParams: { id: firstSelection.userKey },
                });
                break;
            case 'edit':
                this.router.navigate(['update'], {
                    relativeTo: this.route,
                    queryParams: { id: firstSelection.userKey },
                });
                break;
            case 'delete':
                this.deleteUsers(selection, clearSelection);
                break;
            case 'export':
                if (this.selectedIds.length !== 0) {
                    this.exports = [
                        {
                            label: this.translocoService.translate('EXPORT_TYPES.SELECTED_ITEMS'),
                            value: 1,
                        },
                        {
                            label: this.translocoService.translate('EXPORT_TYPES.ALL_PAGES'),
                            value: 2,
                        },
                    ];
                }
                else {
                    this.exports = [
                        {
                            label: this.translocoService.translate('EXPORT_TYPES.ALL_PAGES'),
                            value: 2,
                        },
                    ];
                }
                this.showExport = true;
                break;
            default:
                break;
        }
    }
};
ViewusersComponent.ctorParameters = () => [
    { type: Router },
    { type: UserService },
    { type: LoggerService },
    { type: SpinnerService },
    { type: ToastrNotificationService },
    { type: DatePipe },
    { type: ConfirmationService$2 },
    { type: TranslocoService },
    { type: ActivatedRoute },
    { type: Store },
    { type: FormBuilder }
];
ViewusersComponent = __decorate([
    Component({
        selector: 'lib-viewusers',
        template: "<div class=\"vertical-flow space-between-200\">\r\n  <h2>{{ 'NAV.USER_ADMINISTRATION' | transloco }}</h2>\r\n  <lib-search-container\r\n    *ngIf=\"columns && columns.length !== 0; else columnsNotAvailable\"\r\n    i18nSearchField=\"{{ 'ACTIONS.SEARCH' | transloco }}\"\r\n    name=\"viewUsers\"\r\n    [columns]=\"columns\"\r\n    [columnsToDisplay]=\"displayedColumns\"\r\n    [results]=\"users$\"\r\n    (clear)=\"clear()\"\r\n    [buttons]=\"buttons$ | async\"\r\n    (query)=\"searchUsers($event)\"\r\n    searchProperty=\"searchText\"\r\n    (toolbar)=\"onToolbarClick($event)\"\r\n    [paging]=\"paging\"\r\n    [disableAdvancedSearch]=\"true\"\r\n    [loading]=\"isLoading\"\r\n    [resetSelectionOnDestroy]=\"true\"\r\n    data-testid=\"searchContainer\"\r\n  >\r\n  </lib-search-container>\r\n  <ng-template #columnsNotAvailable>\r\n    <div class=\"position-relative\" style=\"min-height: 50vh\">\r\n      <lib-working-spinner-component\r\n        [visible]=\"true\"\r\n      ></lib-working-spinner-component>\r\n    </div>\r\n  </ng-template>\r\n  <p-confirmDialog [closeOnEscape]=\"false\" [closable]=\"false\"></p-confirmDialog>\r\n  <p-dialog\r\n    [(visible)]=\"showExport\"\r\n    [modal]=\"true\"\r\n    [style]=\"{ width: '520px' }\"\r\n    [showHeader]=\"false\"\r\n    [baseZIndex]=\"10000\"\r\n    [draggable]=\"false\"\r\n    [resizable]=\"false\"\r\n    [closable]=\"false\"\r\n    position=\"center\"\r\n    data-testid=\"exportDialog\"\r\n  >\r\n    <form [formGroup]=\"formGroup\" (ngSubmit)=\"exportUsers()\">\r\n      <div class=\"vertical-flow space-between-050 export-user\">\r\n        <h2 class=\"center\">{{ 'ADMINISTRATION.EXPORT_HEADER' | transloco }}</h2>\r\n        <div class=\"vertical-flow space-before-75\">\r\n          <label>{{ 'ADMINISTRATION.EXPORT_SELECTION' | transloco }}</label>\r\n          <p-dropdown\r\n            [options]=\"exports\"\r\n            formControlName=\"selectedExport\"\r\n            autoWidth=\"false\"\r\n            optionLabel=\"label\"\r\n            placeholder=\"Select\"\r\n            data-testid=\"selectExportDropdown\"\r\n          ></p-dropdown>\r\n        </div>\r\n        <div\r\n          class=\"horizontal-flow form-controls space-between-050 space-before-300\"\r\n        >\r\n          <button\r\n            pButton\r\n            type=\"button\"\r\n            class=\"ds secondary\"\r\n            label=\"{{ 'ACTIONS.CANCEL' | transloco }}\"\r\n            (click)=\"showExport = false\"\r\n            data-testid=\"cancelButton\"\r\n          ></button>\r\n          <button\r\n            pButton\r\n            type=\"submit\"\r\n            class=\"ds primary\"\r\n            label=\"{{ 'ACTIONS.SAVE' | transloco }}\"\r\n            [disabled]=\"!formGroup.valid\"\r\n            data-testid=\"saveButton\"\r\n          ></button>\r\n        </div>\r\n      </div>\r\n    </form>\r\n  </p-dialog>\r\n</div>\r\n",
        styles: [""]
    })
], ViewusersComponent);

let AuthGuardService = class AuthGuardService {
    constructor(router, store) {
        this.router = router;
        this.store = store;
    }
    canActivateChild(_, state) {
        const [modulePath, ...path] = state.url
            .split('?')[0]
            .split('/')
            .filter((x) => x !== '');
        const permissionKey = this.urlToPermissionKey(path);
        return this.store.pipe(select(selectors.isAuthorized, routePermissions), switchMap((permissions) => {
            return of(permissions[permissionKey] || this.router.parseUrl(`/${modulePath}`));
        }), catchError(() => of(this.router.parseUrl(`/${modulePath}`))));
    }
    urlToPermissionKey(url) {
        return url.filter((path) => isNaN(parseInt(path, 10))).join('_');
    }
};
AuthGuardService.ctorParameters = () => [
    { type: Router },
    { type: Store }
];
AuthGuardService.ɵprov = ɵɵdefineInjectable({ factory: function AuthGuardService_Factory() { return new AuthGuardService(ɵɵinject(Router), ɵɵinject(Store)); }, token: AuthGuardService, providedIn: "root" });
AuthGuardService = __decorate([
    Injectable({
        providedIn: 'root',
    })
], AuthGuardService);

function fromFormValues(data) {
    return Object.entries(data).reduce((total, [key, value]) => (Object.assign(Object.assign({}, total), { [key]: { Value: value !== '' ? value : null } })), {});
}

let PayConfigurationComponent = class PayConfigurationComponent {
    constructor(route, translocoService, toast, spinner, adminService, http, searchContainerLoaderService) {
        this.route = route;
        this.translocoService = translocoService;
        this.toast = toast;
        this.spinner = spinner;
        this.adminService = adminService;
        this.http = http;
        this.searchContainerLoaderService = searchContainerLoaderService;
        this._shouldDestroy = new Subject();
        // search container loader states
        this.searchContainerName = 'accountingConfigurationPayable';
        this.i18nSearchField = 'COMPANY.SEARCH';
        this.toolbarActionsDispatcher = {
            edit: (selection) => {
                var _a;
                this.editRequest = {
                    endpoint: `/administration/accounts-payable/${this.supplierKey}/pay-configuration/form/${(_a = selection[0]) === null || _a === void 0 ? void 0 : _a.accountKey_Partner}`,
                    httpMethod: HttpMethod$1.GET,
                };
                this.showDialog = true;
                this.showEdit = true;
            },
            bulkUpdate: (selection) => {
                this.bulkKeys = [...selection].map((_a) => {
                    var { accountKey_Partner } = _a, _ = __rest(_a, ["accountKey_Partner"]);
                    return accountKey_Partner;
                });
                this.bulkRequest = {
                    endpoint: `/administration/accounts-payable/${this.supplierKey}/pay-configuration/bulk-update/form`,
                    httpMethod: HttpMethod$1.POST,
                    body: {
                        keys: this.bulkKeys,
                    },
                };
                this.showDialog = true;
                this.showBulkUpdate = true;
            },
        };
        this.showDialog = false;
        this.showEdit = false;
        this.showView = false;
        this.showBulkUpdate = false;
        this.baseUrl = '';
        this.columnActions = {};
        this.templateTypes = TemplateTypes;
        http.baseUrl = adminService.getConfig().getAccountRootURL;
    }
    ngOnInit() {
        this.bulkBaseUrl = this.adminService.getConfig().getAccountRootURL;
        this.route.queryParams.subscribe((param) => {
            this.supplierKey = param['key'];
        });
        this.baseUrl = `${this.adminService.getConfig().getAccountRootURL}/administration/accounts-payable/${this.supplierKey}/pay-configuration`;
        this.translocoService
            .selectTranslate('ADMINISTRATION')
            .pipe(tap((translate) => (this.translate = translate)))
            .subscribe();
    }
    ngOnDestroy() {
        this._shouldDestroy.next(true);
    }
    closeDialog() {
        this.showDialog = false;
        this.showBulkUpdate = false;
    }
    saveBulkUpdate(values) {
        const formValues = fromFormValues(values[0]);
        const _a = this.searchContainerLoaderService.getCurrentSearchDetails(), { filters } = _a, pagination = __rest(_a, ["filters"]);
        this.spinner.on();
        this.http
            .fetchWithFqn({
            endpoint: `${this.baseUrl}/bulk-update`,
            httpMethod: 'POST',
            body: Object.assign(Object.assign({}, formValues), { keys: this.bulkKeys, search: {
                    page: { offset: pagination === null || pagination === void 0 ? void 0 : pagination.first, limit: pagination === null || pagination === void 0 ? void 0 : pagination.rows },
                    sort: {
                        field: pagination === null || pagination === void 0 ? void 0 : pagination.sortField,
                        order: pagination === null || pagination === void 0 ? void 0 : pagination.sortOrder,
                    },
                    search: {
                        filters: this.searchContainerLoaderService.filters,
                        term: (filters === null || filters === void 0 ? void 0 : filters.term) ? filters === null || filters === void 0 ? void 0 : filters.term : '',
                    },
                } }),
        })
            .pipe(tap((response) => {
            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => {
            this.spinner.off();
        }), takeUntil(this._shouldDestroy))
            .subscribe();
    }
    saveEdit(values) {
        var _a, _b, _c;
        this.http
            .fetchWithFqn({
            endpoint: `${this.baseUrl}`,
            httpMethod: 'POST',
            body: Object.assign({}, Object.assign({
                accountKey_Partner: (_b = (_a = values[0]) === null || _a === void 0 ? void 0 : _a.accountKey_Partner) !== null && _b !== void 0 ? _b : null,
                startDate: values[0].startDate.toISOString(),
            }, ((_c = values[0]) === null || _c === void 0 ? void 0 : _c.endDate) && { endDate: values[0].endDate.toISOString() })),
        })
            .pipe(tap((response) => {
            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => {
            this.spinner.off();
        }), takeUntil(this._shouldDestroy))
            .subscribe();
    }
};
PayConfigurationComponent.ctorParameters = () => [
    { type: ActivatedRoute },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: SpinnerService },
    { type: AdministrationService },
    { type: BaseHttpService },
    { type: SearchContainerLoaderService }
];
PayConfigurationComponent = __decorate([
    Component({
        selector: 'lib-pay-configuration',
        template: "<h2>{{ 'ADMINISTRATION.PAYMENT_CONFIGURATION' | transloco }}</h2>\r\n<p>\r\n  {{ 'ADMINISTRATION.PAYMENT_CONFIGURATION_INFORMATION' | transloco }}\r\n</p>\r\n<div style=\"padding-top: 2rem\">\r\n  <lib-search-container-loader\r\n    [searchContainerName]=\"searchContainerName\"\r\n    [i18nSearchField]=\"i18nSearchField\"\r\n    [toolbarActionsDispatcher]=\"toolbarActionsDispatcher\"\r\n    [baseUrl]=\"baseUrl\"\r\n    [columnActions]=\"columnActions\"\r\n  ></lib-search-container-loader>\r\n\r\n  <p-dialog\r\n    *ngIf=\"showDialog\"\r\n    [visible]=\"true\"\r\n    [modal]=\"true\"\r\n    [style]=\"{ width: '600px' }\"\r\n    [baseZIndex]=\"10000\"\r\n    [draggable]=\"false\"\r\n    [resizable]=\"false\"\r\n    [showHeader]=\"false\"\r\n    [focusOnShow]=\"false\"\r\n    position=\"center\"\r\n    [styleClass]=\"'visible-dropdown'\"\r\n    data-testid=\"payConfigurationDialog\"\r\n  >\r\n    <lui-wizard\r\n      *ngIf=\"showEdit\"\r\n      [wizardConfig]=\"editRequest\"\r\n      [baseUrl]=\"bulkBaseUrl\"\r\n      (submit)=\"saveEdit($event); showDialog = false; showEdit = false\"\r\n      (cancel)=\"showDialog = false; showEdit = false\"\r\n      data-testid=\"editWizard\"\r\n    >\r\n      <ng-template [luiWidget]=\"templateTypes.READY\">\r\n        <div class=\"center ready\"></div>\r\n      </ng-template>\r\n      <ng-template [luiWidget]=\"templateTypes.LOADING\">\r\n        <div class=\"spinner-background\">\r\n          <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n        </div>\r\n      </ng-template>\r\n      <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n        <div\r\n          class=\"error\"\r\n          style=\"\r\n            min-height: 30vh;\r\n            display: flex;\r\n            justify-content: center;\r\n            align-items: center;\r\n          \"\r\n        >\r\n          <div>\r\n            <span>\r\n              <i class=\"pi pi-times-circle\"></i>\r\n              {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n            </span>\r\n          </div>\r\n        </div>\r\n        <button\r\n          pButton\r\n          (click)=\"showDialog = false; showEdit = false\"\r\n          class=\"ds secondary\"\r\n        >\r\n          {{ 'ACTIONS.CANCEL' | transloco }}\r\n        </button>\r\n      </ng-template></lui-wizard\r\n    >\r\n    <lui-wizard\r\n      *ngIf=\"showBulkUpdate\"\r\n      [wizardConfig]=\"bulkRequest\"\r\n      [baseUrl]=\"bulkBaseUrl\"\r\n      (submit)=\"\r\n        saveBulkUpdate($event); showDialog = false; showBulkUpdate = false\r\n      \"\r\n      (cancel)=\"showDialog = false; showBulkUpdate = false\"\r\n      data-testid=\"updateWizard\"\r\n    >\r\n      <ng-template [luiWidget]=\"templateTypes.READY\">\r\n        <div class=\"center ready\">\r\n          <h1>rdy msg</h1>\r\n        </div>\r\n      </ng-template>\r\n      <ng-template [luiWidget]=\"templateTypes.LOADING\">\r\n        <div class=\"spinner-background\">\r\n          <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n        </div>\r\n      </ng-template>\r\n      <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n        <div\r\n          class=\"error\"\r\n          style=\"\r\n            min-height: 30vh;\r\n            display: flex;\r\n            justify-content: center;\r\n            align-items: center;\r\n          \"\r\n        >\r\n          <div>\r\n            <span>\r\n              <i class=\"pi pi-times-circle\"></i>\r\n              {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n            </span>\r\n          </div>\r\n        </div>\r\n        <button\r\n          pButton\r\n          (click)=\"showDialog = false; showBulkUpdate = false\"\r\n          class=\"ds secondary\"\r\n        >\r\n          {{ 'ACTIONS.CANCEL' | transloco }}\r\n        </button>\r\n      </ng-template></lui-wizard\r\n    >\r\n  </p-dialog>\r\n</div>\r\n",
        providers: [SearchContainerLoaderService]
    })
], PayConfigurationComponent);

let DataCrossReferenceComponent = class DataCrossReferenceComponent {
    constructor(translocoService, toast, spinner, router, route, adminService, http, searchContainerLoaderService) {
        this.translocoService = translocoService;
        this.toast = toast;
        this.spinner = spinner;
        this.router = router;
        this.route = route;
        this.adminService = adminService;
        this.http = http;
        this.searchContainerLoaderService = searchContainerLoaderService;
        this.templateTypes = TemplateTypes;
        // new states
        this.showNewDialog = false;
        // edit states
        this.showEditDialog = false;
        // export states
        this.showExportDialog = false;
        this.searchContainerName = 'dataCrossReferenceSearch';
        this.i18nSearchField = 'ACTIONS.SEARCH';
        this.toolbarActionsDispatcher = {
            new: (selection) => {
                this.showNewDialog = true;
                this.newXrefWizard = {
                    endpoint: 'form/data-cross-reference/new',
                    httpMethod: HttpMethod$1.POST,
                };
            },
            edit: (selection) => {
                this.showEditDialog = true;
                this.editXrefWizard = {
                    endpoint: `form/data-cross-reference/${selection[0].compositeKey}/edit`,
                    httpMethod: HttpMethod$1.POST,
                };
            },
            export: (selection) => {
                this.showExportDialog = true;
                this.exportXrefWizard = {
                    endpoint: `DataCrossReference/export`,
                    httpMethod: HttpMethod$1.POST,
                    body: {
                        crossReferenceExportKeys: [...selection].map((_a) => {
                            var { compositeKey } = _a, _ = __rest(_a, ["compositeKey"]);
                            return compositeKey;
                        }),
                    },
                };
            },
        };
        this.baseUrl = `${this.adminService.getConfig().getConfiguration}/DataCrossReference/data-cross-reference`;
        this.wizardUrl = `${this.adminService.getConfig().getConfiguration}`;
        this.columnActions = {};
        http.baseUrl = this.adminService.getConfig().getConfiguration;
    }
    closeNew() {
        this.showNewDialog = false;
    }
    submitNew(event) {
        this.showNewDialog = false;
        this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
        this.searchContainerLoaderService.refreshSearch();
    }
    closeEdit() {
        this.showEditDialog = false;
    }
    submitEdit(event) {
        this.showEditDialog = false;
        this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
        this.searchContainerLoaderService.refreshSearch();
    }
    closeExport() {
        this.showExportDialog = false;
    }
    submitExport(event) {
        this.showExportDialog = false;
        this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
        this.searchContainerLoaderService.refreshSearch();
    }
};
DataCrossReferenceComponent.ctorParameters = () => [
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: SpinnerService },
    { type: Router },
    { type: ActivatedRoute },
    { type: AdministrationService },
    { type: BaseHttpService$1 },
    { type: SearchContainerLoaderService }
];
DataCrossReferenceComponent = __decorate([
    Component({
        selector: 'lib-data-cross-reference',
        template: "<div style=\"padding-top: 2rem\">\r\n  <lib-search-container-loader\r\n    [searchContainerName]=\"searchContainerName\"\r\n    [i18nSearchField]=\"i18nSearchField\"\r\n    [toolbarActionsDispatcher]=\"toolbarActionsDispatcher\"\r\n    [baseUrl]=\"baseUrl\"\r\n    [columnActions]=\"columnActions\"\r\n  ></lib-search-container-loader>\r\n</div>\r\n\r\n<p-dialog\r\n  *ngIf=\"showNewDialog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '600px' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n  data-testid=\"newCrossReferenceDialog\"\r\n>\r\n  <lui-wizard-v3\r\n    [baseUrl]=\"wizardUrl\"\r\n    [wizardConfig]=\"newXrefWizard\"\r\n    (submit)=\"submitNew($event)\"\r\n    (cancel)=\"closeNew()\"\r\n  >\r\n    <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n      <div\r\n        class=\"error\"\r\n        style=\"\r\n          min-height: 30vh;\r\n          display: flex;\r\n          justify-content: center;\r\n          align-items: center;\r\n        \"\r\n      >\r\n        <div>\r\n          <span>\r\n            <i class=\"pi pi-times-circle\"></i>\r\n            {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n          </span>\r\n        </div>\r\n      </div>\r\n      <button\r\n        pButton\r\n        (click)=\"closeNew()\"\r\n        class=\"ds secondary\"\r\n        data-testid=\"cancelButton\"\r\n      >\r\n        {{ 'ACTIONS.CANCEL' | transloco }}\r\n      </button>\r\n    </ng-template>\r\n  </lui-wizard-v3>\r\n</p-dialog>\r\n\r\n<p-dialog\r\n  *ngIf=\"showEditDialog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '600px' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n  data-testid=\"editDialog\"\r\n>\r\n  <lui-wizard-v3\r\n    [baseUrl]=\"wizardUrl\"\r\n    [wizardConfig]=\"editXrefWizard\"\r\n    (submit)=\"submitEdit($event)\"\r\n    (cancel)=\"closeEdit()\"\r\n  >\r\n    <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n      <div\r\n        class=\"error\"\r\n        style=\"\r\n          min-height: 30vh;\r\n          display: flex;\r\n          justify-content: center;\r\n          align-items: center;\r\n        \"\r\n      >\r\n        <div>\r\n          <span>\r\n            <i class=\"pi pi-times-circle\"></i>\r\n            {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n          </span>\r\n        </div>\r\n      </div>\r\n      <button\r\n        pButton\r\n        (click)=\"closeEdit()\"\r\n        class=\"ds secondary\"\r\n        data-testid=\"cancelButton\"\r\n      >\r\n        {{ 'ACTIONS.CANCEL' | transloco }}\r\n      </button>\r\n    </ng-template>\r\n  </lui-wizard-v3>\r\n</p-dialog>\r\n\r\n<p-dialog\r\n  *ngIf=\"showExportDialog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '600px' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n  data-testid=\"exportDialog\"\r\n>\r\n  <lui-wizard-v3\r\n    [baseUrl]=\"wizardUrl\"\r\n    [wizardConfig]=\"exportXrefWizard\"\r\n    (submit)=\"submitExport($event)\"\r\n    (cancel)=\"closeExport()\"\r\n  >\r\n    <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n      <div\r\n        class=\"error\"\r\n        style=\"\r\n          min-height: 30vh;\r\n          display: flex;\r\n          justify-content: center;\r\n          align-items: center;\r\n        \"\r\n      >\r\n        <div>\r\n          <span>\r\n            <i class=\"pi pi-times-circle\"></i>\r\n            {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n          </span>\r\n        </div>\r\n      </div>\r\n      <button\r\n        pButton\r\n        (click)=\"closeExport()\"\r\n        class=\"ds secondary\"\r\n        data-testid=\"cancelButton\"\r\n      >\r\n        {{ 'ACTIONS.CANCEL' | transloco }}\r\n      </button>\r\n    </ng-template>\r\n  </lui-wizard-v3>\r\n</p-dialog>\r\n",
        providers: [SearchContainerLoaderService]
    })
], DataCrossReferenceComponent);

let UserDefinedTagsComponent = class UserDefinedTagsComponent {
    constructor(translocoService, confirmationService, toast, spinner, router, route, http, searchContainerLoaderService, store, adminService, popupSrv) {
        this.translocoService = translocoService;
        this.confirmationService = confirmationService;
        this.toast = toast;
        this.spinner = spinner;
        this.router = router;
        this.route = route;
        this.http = http;
        this.searchContainerLoaderService = searchContainerLoaderService;
        this.store = store;
        this.adminService = adminService;
        this.popupSrv = popupSrv;
        this.searchContainerName = 'userDefinedTagsSearch';
        this.templateTypes = TemplateTypes;
        // new wizard states
        this.showNewDialog = false;
        // edit wizard states
        this.showEditDialog = false;
        // delete wizard states
        this.showDeleteDialog = false;
        this.i18nSearchField = 'ACTIONS.SEARCH';
        this.params = {};
        this.toolbarActionsDispatcher = {
            new: () => {
                this.newWizardConfig = {
                    endpoint: '/tagging/form/tag/new',
                    httpMethod: HttpMethod$1.POST,
                    body: {},
                };
                this.popupSrv
                    .openWizard(this.newWizardConfig)
                    .pipe(tap(() => {
                    this.searchContainerLoaderService.refreshSearch();
                }))
                    .subscribe();
            },
            edit: (selection) => {
                var _a;
                this.editWizardConfig = {
                    endpoint: 'tagging/form/tag/upsert',
                    httpMethod: HttpMethod$1.POST,
                    body: {
                        tagKey: (_a = selection[0]) === null || _a === void 0 ? void 0 : _a.tagKey,
                    },
                };
                this.popupSrv
                    .openWizard(this.editWizardConfig)
                    .pipe(tap(() => {
                    this.searchContainerLoaderService.refreshSearch();
                }))
                    .subscribe();
            },
            delete: (selection) => {
                this.deleteWizardConfig = {
                    endpoint: 'tagging/form/tag/delete',
                    httpMethod: HttpMethod$1.POST,
                    body: {
                        tagKeys: [...selection].map((_a) => {
                            var { tagKey } = _a, _ = __rest(_a, ["tagKey"]);
                            return tagKey;
                        }),
                    },
                };
                this.popupSrv
                    .openWizard(this.deleteWizardConfig)
                    .pipe(tap(() => {
                    this.searchContainerLoaderService.refreshSearch();
                }))
                    .subscribe();
            },
        };
        this.columnActions = {};
        this.baseUrl = `${this.adminService.getConfig().taggingEndpoint}`;
        http.baseUrl = adminService.getConfig().taggingEndpoint;
    }
    searchContainerEvent({ data, eventType }) {
        const { tags } = data;
        switch (eventType) {
            default:
                break;
        }
    }
    closeNew() {
        this.showNewDialog = false;
    }
    submitNew(event) {
        this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
        this.showNewDialog = false;
        this.searchContainerLoaderService.refreshSearch();
    }
    closeEdit() {
        this.showEditDialog = false;
    }
    submitEdit(event) {
        this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
        this.showEditDialog = false;
        this.searchContainerLoaderService.refreshSearch();
    }
    closeDelete() {
        this.showDeleteDialog = false;
    }
    submitDelete(event) {
        this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
        this.showDeleteDialog = false;
        this.searchContainerLoaderService.refreshSearch();
    }
};
UserDefinedTagsComponent.ctorParameters = () => [
    { type: TranslocoService },
    { type: ConfirmationService },
    { type: ToastrNotificationService },
    { type: SpinnerService },
    { type: Router },
    { type: ActivatedRoute },
    { type: BaseHttpService$1 },
    { type: SearchContainerLoaderService },
    { type: Store },
    { type: AdministrationService },
    { type: PopupService }
];
UserDefinedTagsComponent = __decorate([
    Component({
        selector: 'lib-user-defined-tags',
        template: "<h2>{{ 'BREADCRUMB.TAG_MANAGEMENT' | transloco }}</h2>\r\n<lib-search-container-loader\r\n  [searchContainerName]=\"searchContainerName\"\r\n  [i18nSearchField]=\"i18nSearchField\"\r\n  [toolbarActionsDispatcher]=\"toolbarActionsDispatcher\"\r\n  [params]=\"params\"\r\n  [disableAdvancedSearch]=\"false\"\r\n  [baseUrl]=\"baseUrl\"\r\n></lib-search-container-loader>\r\n<p-dialog\r\n  *ngIf=\"showNewDialog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '600px' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n  data-testid=\"newTagDialog\"\r\n>\r\n  <lui-wizard-v3\r\n    [baseUrl]=\"baseUrl\"\r\n    [wizardConfig]=\"newWizardConfig\"\r\n    (submit)=\"submitNew($event)\"\r\n    (cancel)=\"closeNew()\"\r\n  >\r\n    <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n      <div\r\n        class=\"error\"\r\n        style=\"\r\n          min-height: 30vh;\r\n          display: flex;\r\n          justify-content: center;\r\n          align-items: center;\r\n        \"\r\n      >\r\n        <div>\r\n          <span>\r\n            <i class=\"pi pi-times-circle\"></i>\r\n            {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n          </span>\r\n        </div>\r\n      </div>\r\n      <button\r\n        pButton\r\n        (click)=\"closeNew()\"\r\n        class=\"ds secondary\"\r\n        data-testid=\"cancelButton\"\r\n      >\r\n        {{ 'ACTIONS.CANCEL' | transloco }}\r\n      </button>\r\n    </ng-template>\r\n  </lui-wizard-v3>\r\n</p-dialog>\r\n\r\n<p-dialog\r\n  *ngIf=\"showEditDialog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '600px' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n  data-testid=\"editTagDialog\"\r\n>\r\n  <lui-wizard-v3\r\n    [baseUrl]=\"baseUrl\"\r\n    [wizardConfig]=\"editWizardConfig\"\r\n    (submit)=\"submitEdit($event)\"\r\n    (cancel)=\"closeEdit()\"\r\n  >\r\n    <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n      <div\r\n        class=\"error\"\r\n        style=\"\r\n          min-height: 30vh;\r\n          display: flex;\r\n          justify-content: center;\r\n          align-items: center;\r\n        \"\r\n      >\r\n        <div>\r\n          <span>\r\n            <i class=\"pi pi-times-circle\"></i>\r\n            {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n          </span>\r\n        </div>\r\n      </div>\r\n      <button\r\n        pButton\r\n        (click)=\"closeEdit()\"\r\n        class=\"ds secondary\"\r\n        data-testid=\"cancelButton\"\r\n      >\r\n        {{ 'ACTIONS.CANCEL' | transloco }}\r\n      </button>\r\n    </ng-template>\r\n  </lui-wizard-v3>\r\n</p-dialog>\r\n\r\n<p-dialog\r\n  *ngIf=\"showDeleteDialog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '600px' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n  data-testid=\"deleteTagDialog\"\r\n>\r\n  <lui-wizard-v3\r\n    [baseUrl]=\"baseUrl\"\r\n    [wizardConfig]=\"deleteWizardConfig\"\r\n    (submit)=\"submitDelete($event)\"\r\n    (cancel)=\"closeDelete()\"\r\n  >\r\n    <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n      <div\r\n        class=\"error\"\r\n        style=\"\r\n          min-height: 30vh;\r\n          display: flex;\r\n          justify-content: center;\r\n          align-items: center;\r\n        \"\r\n      >\r\n        <div>\r\n          <span>\r\n            <i class=\"pi pi-times-circle\"></i>\r\n            {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n          </span>\r\n        </div>\r\n      </div>\r\n      <button\r\n        pButton\r\n        (click)=\"closeDelete()\"\r\n        class=\"ds secondary\"\r\n        data-testid=\"cancelButton\"\r\n      >\r\n        {{ 'ACTIONS.CANCEL' | transloco }}\r\n      </button>\r\n    </ng-template>\r\n  </lui-wizard-v3>\r\n</p-dialog>\r\n\r\n<p-confirmDialog [closeOnEscape]=\"false\" [closable]=\"false\"></p-confirmDialog>\r\n",
        providers: [SearchContainerLoaderService]
    })
], UserDefinedTagsComponent);

let UserDetailsWrapperComponent = class UserDetailsWrapperComponent {
    constructor(store, http, adminService, route) {
        this.store = store;
        this.http = http;
        this.adminService = adminService;
        this.route = route;
        this.userFeature = '';
        this.baseUrl = this.adminService.getConfig().apiBaseUrl;
        this.ready = false;
        this.useNewPermissionsModel = false;
        this.showLegacy = false;
        this.http.baseUrl = this.baseUrl;
        this.store
            .pipe(select(selectors.userFeature), map((userState) => {
            this.userFeature = userState.profile.sub;
        }))
            .subscribe();
    }
    ngOnInit() {
        this.route.queryParams
            .pipe(tap((params) => {
            this.showLegacy = JSON.parse((params === null || params === void 0 ? void 0 : params.legacy) || false);
        }))
            .subscribe();
        this.http
            .fetch({
            endpoint: 'security/Auth/permissions-model',
            httpMethod: 'GET',
        })
            .pipe(tap((resp) => {
            this.useNewPermissionsModel = resp.record;
        }), finalize(() => {
            if (this.showLegacy === true) {
                this.ready = false;
            }
            else {
                this.ready = true;
            }
        }))
            .subscribe();
    }
};
UserDetailsWrapperComponent.ctorParameters = () => [
    { type: Store },
    { type: BaseHttpService$2 },
    { type: AdministrationService },
    { type: ActivatedRoute }
];
UserDetailsWrapperComponent = __decorate([
    Component({
        selector: 'lib-user-details-wrapper',
        template: "<div *ngIf=\"ready; else showLegacyModal\">\r\n  <div *ngIf=\"useNewPermissionsModel; else newVersion\">\r\n    <lib-user-details-wizard></lib-user-details-wizard>\r\n  </div>\r\n\r\n  <ng-template #newVersion>\r\n    <lib-user-details-v2></lib-user-details-v2>\r\n  </ng-template>\r\n</div>\r\n\r\n<ng-template #showLegacyModal>\r\n  <div *ngIf=\"showLegacy\">\r\n    <lib-user-details-v2></lib-user-details-v2>\r\n  </div>\r\n</ng-template>\r\n"
    })
], UserDetailsWrapperComponent);

const ɵ0$3 = { breadcrumb: { label: 'BREADCRUMB.ADMINISTRATION', disable: true } }, ɵ1$3 = { breadcrumb: 'BREADCRUMB.ADMINISTRATION_USER_ADMINISTRATION' }, ɵ2$3 = { breadcrumb: 'BREADCRUMB.ADD' }, ɵ3 = { breadcrumb: 'BREADCRUMB.COPY' }, ɵ4 = { breadcrumb: 'BREADCRUMB.UPDATE' }, ɵ5 = { breadcrumb: 'BREADCRUMB.MARKETPLACE_CONTROLS' }, ɵ6 = { breadcrumb: 'BREADCRUMB.DATA_CROSS_REFERENCES' }, ɵ7 = { breadcrumb: 'NAV.ACCOUNTS_PAYABLE' }, ɵ8 = { breadcrumb: 'ADMINISTRATION.PAYMENT_CONFIGURATION' }, ɵ9 = { breadcrumb: 'BREADCRUMB.TAG_MANAGEMENT' };
const appRoutes = [
    {
        path: '',
        data: ɵ0$3,
        component: AdministrationComponent,
        canActivateChild: [AuthGuardService],
        children: [
            {
                path: '',
                redirectTo: 'user',
            },
            {
                path: 'user',
                data: ɵ1$3,
                children: [
                    {
                        path: '',
                        component: ViewusersComponent,
                    },
                    {
                        path: 'add',
                        component: UserDetailsWrapperComponent,
                        data: ɵ2$3,
                    },
                    {
                        path: 'copy',
                        component: UserDetailsWrapperComponent,
                        data: ɵ3,
                    },
                    {
                        path: 'update',
                        component: UserDetailsWrapperComponent,
                        data: ɵ4,
                    },
                ],
            },
            {
                path: 'marketplace-controls',
                component: MarketplaceControlComponent,
                data: ɵ5,
            },
            {
                path: 'data-cross-reference',
                component: DataCrossReferenceComponent,
                data: ɵ6,
            },
            {
                path: 'accounts-payable',
                data: ɵ7,
                children: [
                    {
                        path: '',
                        redirectTo: 'user',
                    },
                    {
                        path: 'pay-configuration',
                        component: PayConfigurationComponent,
                        data: ɵ8,
                    },
                ],
            },
            ...routes,
            ...routes$1,
        ],
    },
    {
        path: 'tagging',
        component: UserDefinedTagsComponent,
        data: ɵ9,
    },
];
let AdministrationRoutingModule = class AdministrationRoutingModule {
};
AdministrationRoutingModule = __decorate([
    NgModule({
        imports: [RouterModule.forChild(appRoutes)],
        exports: [RouterModule],
    })
], AdministrationRoutingModule);

let UserDetailsComponent = class UserDetailsComponent {
    constructor(route, formBuilder, loggerService, spinnerService, userService, router, translocoService, validationService, toastSrv, store) {
        this.route = route;
        this.formBuilder = formBuilder;
        this.loggerService = loggerService;
        this.spinnerService = spinnerService;
        this.userService = userService;
        this.router = router;
        this.translocoService = translocoService;
        this.validationService = validationService;
        this.toastSrv = toastSrv;
        this.store = store;
        this.title = '';
        this.activatePagePermissions = false;
        this.activateUserInformation = true;
        this.allPermissions = [];
        this.selectedPermissions = [];
        this.languageTypes = [];
        this.timeZoneTypes = [];
        this.dateFormatTypes = [];
        this.countries = [];
        this.subscriptions = [];
        this.showUpdatePassword = false;
        this.passwordEmpty = true;
        this.userInfoButtonLabel = '';
        this.extension = {
            extension: () => this.translocoService.translate('VALIDATION_MESSAGE.PHONE_EXTENSION'),
        };
        this.message = {
            confirmPassword: () => this.translocoService.translate('COMMON.PASSWORD_MUST_MATCH'),
        };
        this.userForm = this.formBuilder.group({
            FirstName: ['', [Validators.required]],
            LastName: ['', [Validators.required]],
            Username: ['', [Validators.required, Validators.email]],
            Password: [
                '',
                Validators.compose([
                    this.validationService.patternValidator('number'),
                    this.validationService.patternValidator('upperCase'),
                    this.validationService.patternValidator('lowerCase'),
                    this.validationService.specialCharacterValidator(),
                    this.validationService.minimumLength(8),
                ]),
            ],
            ConfirmPassword: [''],
            Language: ['', [Validators.required]],
            TimeZone: ['', [Validators.required]],
            DateFormat: ['', [Validators.required]],
        }, {
            validator: this.validationService.MustMatch('Password', 'ConfirmPassword'),
        });
        this.phoneForm = this.formBuilder.group({
            PhoneCountry: [''],
            PhoneExtension: [
                '',
                Validators.compose([
                    Validators.pattern('^[0-9]*$'),
                    Validators.maxLength(10),
                ]),
            ],
            Phone: [
                '',
                Validators.compose([
                    Validators.required,
                    this.validatePhoneNumber(parsePhoneNumber),
                ]),
            ],
        }, {
            validators: this.validatePhoneForm('Phone', 'PhoneExtension'),
        });
        this.permissionsForm = this.formBuilder.group({});
    }
    ngOnInit() {
        this.activatePagePermissions = false;
        this.activateUserInformation = true;
        this.spinnerService.on();
        if (this.route.snapshot.url[0].path === 'update') {
            this.subscriptions.push(this.getUpdateSubscription());
            this.getUserInfoButtonLabel();
            this.isUpdating = true;
            this.userForm.controls.Password.enable();
            this.userForm.controls.ConfirmPassword.enable();
            this.userForm.controls.Language.enable();
            this.userForm.controls.TimeZone.enable();
            this.userForm.controls.DateFormat.enable();
            this.phoneForm.enable();
            this.subscriptions.push(this.translocoService
                .selectTranslate('ADMINISTRATION.UPDATE_USER_PAGE_TITLE')
                .pipe(first(), tap((title) => (this.title = title)))
                .subscribe());
        }
        else {
            if (this.route.snapshot.url[0].path === 'copy') {
                this.subscriptions.push(this.getCopySubscription());
            }
            else {
                this.subscriptions.push(this.getToolPermissions()
                    .pipe(finalize(() => this.spinnerService.off()))
                    .subscribe((permissions) => {
                    this.allPermissions = permissions;
                }));
            }
            this.isUpdating = false;
            this.getUserInfoButtonLabel(false);
            this.userForm.controls.Password.disable();
            this.userForm.controls.ConfirmPassword.disable();
            this.userForm.controls.Language.disable();
            this.userForm.controls.TimeZone.disable();
            this.userForm.controls.DateFormat.disable();
            this.phoneForm.disable();
            this.subscriptions.push(this.translocoService
                .selectTranslate('ADMINISTRATION.ADD_USER_PAGE_TITLE')
                .pipe(first(), tap((title) => (this.title = title)))
                .subscribe());
        }
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    getUpdateSubscription() {
        return forkJoin([
            this.getUser(),
            this.getToolPermissions(),
            this.getLanguageTypes(),
            this.getTimeZoneTypes(),
            this.getDateFormatTypes(),
            this.getCountries(),
            this.getAccount(),
        ])
            .pipe(finalize(() => this.spinnerService.off()))
            .subscribe(([user, permissions, languages, timeZones, dateFormats, countries, account,]) => {
            var _a;
            this.user = user;
            this.allPermissions = permissions;
            this.languageTypes = languages;
            this.timeZoneTypes = timeZones;
            this.dateFormatTypes = dateFormats;
            this.countries = countries;
            this.defaultCountryCode = (_a = account === null || account === void 0 ? void 0 : account.details) === null || _a === void 0 ? void 0 : _a.country;
            this.selectedPermissions = this.userService.checkNodes(this.allPermissions, this.user);
            this.prefillForm();
        });
    }
    getCopySubscription() {
        return forkJoin([this.getUser(), this.getToolPermissions()])
            .pipe(finalize(() => this.spinnerService.off()))
            .subscribe(([user, permissions]) => {
            this.user = user;
            this.allPermissions = permissions;
            this.selectedPermissions = this.userService.checkNodes(this.allPermissions, this.user);
        });
    }
    getLanguageTypes() {
        return this.userService.getLanguageTypes().pipe(map((lt) => lt.map(({ languageCode, languageDescription }) => ({
            label: languageDescription,
            value: languageCode,
        }))));
    }
    getTimeZoneTypes() {
        return this.userService.getTimeZoneTypes().pipe(map((tz) => tz.map(({ timeZoneCode, timeZoneDescription }) => ({
            label: timeZoneDescription,
            value: timeZoneCode,
        }))));
    }
    getDateFormatTypes() {
        return this.userService.getDateFormatTypes().pipe(map((df) => df.map(({ dateTypeKey, description }) => ({
            label: description,
            value: dateTypeKey,
        }))));
    }
    getCountries() {
        // update
        return this.userService.getCountries().pipe(map((countries) => countries === null || countries === void 0 ? void 0 : countries.map((country) => {
            return {
                label: `${country === null || country === void 0 ? void 0 : country.countryName} (${alpha3ToAlpha2(country === null || country === void 0 ? void 0 : country.countryCode)})`,
                value: alpha3ToAlpha2(country === null || country === void 0 ? void 0 : country.countryCode),
            };
        })));
    }
    getToolPermissions() {
        return this.userService
            .getPermissionsList()
            .pipe(map(({ records }) => this.userService.restructureList(records)));
    }
    getAccount() {
        return this.userService.getAccount();
    }
    getUser() {
        return this.route.queryParams
            .pipe(first(), switchMap((params) => this.userService.searchUser({ id: parseInt(params.id, 10) })))
            .pipe(map((res) => res.userDetails));
    }
    prefillForm() {
        try {
            // update
            this.phoneForm.controls.PhoneExtension.setValue(this.user.phoneExtension);
            this.phoneForm.controls.PhoneCountry.setValue(alpha3ToAlpha2(this.user.phoneCountry));
            this.phoneForm.controls.Phone.setValue(parsePhoneNumber(this.user.phone, alpha3ToAlpha2(this.user.phoneCountry)).formatInternational());
        }
        catch (_a) {
            this.phoneForm.controls.PhoneCountry.setValue(alpha3ToAlpha2(this.defaultCountryCode || 'CAN'));
            this.phoneForm.controls.Phone.setValue('');
            this.phoneForm.controls.PhoneExtension.setValue('');
        }
        this.userForm.controls.FirstName.setValue(this.user.firstName);
        this.userForm.controls.LastName.setValue(this.user.lastName);
        this.userForm.controls.Username.setValue(this.user.username);
        this.userForm.controls.Language.setValue(this.user.languageCode);
        this.userForm.controls.TimeZone.setValue(this.user.timeZoneCode);
        this.userForm.controls.DateFormat.setValue(this.user.dateTypeKey);
    }
    submit() {
        this.activatePagePermissions = true;
        this.activateUserInformation = false;
    }
    save() {
        if (this.isUpdating) {
            this.updateUser();
        }
        else {
            this.addUser();
        }
    }
    updateUser() {
        this.spinnerService.on();
        this.subscriptions.push(this.userService
            .updateUser(this.buildUpdateRequest())
            .pipe(finalize(() => this.spinnerService.off()))
            .subscribe((response) => {
            this.loggerService.info('UpdateUserResponse', 'UpdateuserService.updateUser', JSON.stringify(response));
            if (response.status === 'Success') {
                this.store.dispatch(actions.updateUser());
                this.toastSrv.successNotify(this.translocoService.translate('ADMINISTRATION.UPDATE_USER_SUCCESS'), null, 5000);
                this.router.navigate(['/AdministrationModule/user']);
            }
        }, (error) => {
            this.toastSrv.errorNotify(this.translocoService.translate('ADMINISTRATION.UPDATE_USER_FAILURE'));
            this.loggerService.error('UpdateUserResponse', 'UpdateusersService.updateUser', JSON.stringify(error));
        }));
    }
    addUser() {
        this.spinnerService.on();
        this.subscriptions.push((this.route.snapshot.url[0].path === 'copy'
            ? this.userService.copyUser(this.buildCopyRequest())
            : this.userService.addUser(this.buildAddRequest()))
            .pipe(finalize(() => this.spinnerService.off()))
            .subscribe((response) => {
            this.loggerService.info('AddUserResponse', 'AdduserService.addUser', JSON.stringify(response));
            if (response.status === 'Success') {
                this.toastSrv.successNotify(this.translocoService.translate('ADMINISTRATION.ADD_USER_SUCCESS'), null, 5000);
                this.router.navigate(['/AdministrationModule/user']);
            }
        }, (error) => {
            if (error.error != null && error.error.errorCode === 3) {
                this.toastSrv.warnNotify(this.translocoService.translate('ADMINISTRATION.USER_ALREADY_EXIST'), null, 5000);
            }
            else if (error.error != null && error.error.errorCode) {
                this.toastSrv.warnNotify(this.translocoService.translate('COMMON.UNKNOWN_ERROR'), null, 5000);
            }
            else {
                this.toastSrv.errorNotify(this.translocoService.translate('ADMINISTRATION.ADD_USER_FAILURE'), null, 5000);
            }
            this.loggerService.error('AddUserResponse', 'AddusersService.addUser', JSON.stringify(error));
        }));
    }
    buildUpdateRequest() {
        let phoneCountry;
        let phone;
        let phoneExtension;
        try {
            phoneCountry = alpha2ToAlpha3(this.phoneForm.controls.PhoneCountry.value);
            phoneExtension = this.phoneForm.value.PhoneExtension;
            phone = parsePhoneNumber(this.phoneForm.controls.Phone.value, alpha3ToAlpha2(this.phoneForm.controls.PhoneCountry.value)).format('E.164');
        }
        catch (_a) {
            phoneCountry = this.defaultCountryCode || 'CAN';
            phone = '';
            phoneExtension = '';
        }
        return {
            userKey: this.user.userKey,
            username: this.userForm.value.Username,
            fullName: this.userForm.value.FirstName + ' ' + this.userForm.value.LastName,
            firstName: this.userForm.value.FirstName,
            lastName: this.userForm.value.LastName,
            password: this.showUpdatePassword
                ? this.userForm.value.Password
                : undefined,
            toolPermissions: this.getToolKeys(),
            timeZoneCode: this.userForm.value.TimeZone,
            dateType: this.userForm.value.DateFormat,
            languageCode: this.userForm.value.Language,
            phoneCountry,
            phone,
            phoneExtension,
            isTermsSigned: this.user.isTermsSigned,
        };
    }
    buildAddRequest() {
        return {
            fullname: this.userForm.value.FirstName + ' ' + this.userForm.value.LastName,
            username: this.userForm.value.Username,
            firstName: this.userForm.value.FirstName,
            lastName: this.userForm.value.LastName,
            toolPermissions: this.getToolKeys(),
        };
    }
    buildCopyRequest() {
        return this.buildAddRequest();
    }
    //#endregion
    /*Handling Password Checkbox  Click */
    handleUpdatePassword(status) {
        if (status.checked) {
            this.showUpdatePassword = true;
            this.userForm.controls.Password.enable();
            this.userForm.controls.ConfirmPassword.enable();
        }
        else {
            this.showUpdatePassword = false;
            this.userForm.controls.Password.disable();
            this.userForm.controls.ConfirmPassword.disable();
        }
    }
    /** Function to check whether password field is empty or not  */
    passwordFieldEmptyCheck(passwordStatus) {
        this.passwordEmpty = !passwordStatus;
    }
    // bound to Phone control's input event
    formatPhoneNumber() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        try {
            if (((_d = (_c = (_b = (_a = this.phoneForm) === null || _a === void 0 ? void 0 : _a.controls) === null || _b === void 0 ? void 0 : _b.Phone) === null || _c === void 0 ? void 0 : _c.value) === null || _d === void 0 ? void 0 : _d.length) < 1) {
                this.phoneForm.controls.PhoneCountry.setValue(alpha3ToAlpha2(this.defaultCountryCode || 'CAN'));
            }
            (_g = (_f = (_e = this.phoneForm) === null || _e === void 0 ? void 0 : _e.controls) === null || _f === void 0 ? void 0 : _f.Phone) === null || _g === void 0 ? void 0 : _g.setValue(parsePhoneNumber(this.phoneForm.controls.Phone.value, (_j = (_h = this.phoneForm.controls) === null || _h === void 0 ? void 0 : _h.PhoneCountry) === null || _j === void 0 ? void 0 : _j.value).formatInternational());
        }
        catch (_k) {
            /*empty*/
        }
    }
    resetPhoneNumber() {
        var _a, _b, _c;
        (_c = (_b = (_a = this.phoneForm) === null || _a === void 0 ? void 0 : _a.controls) === null || _b === void 0 ? void 0 : _b.Phone) === null || _c === void 0 ? void 0 : _c.setValue('');
    }
    getToolKeys() {
        return ('[' +
            Array.from(new Set(this.userService.getAllSelectedToolKeys(this.selectedPermissions))) +
            ']');
    }
    getUserInfoButtonLabel(update = true) {
        this.translocoService
            .selectTranslate(update ? 'ACTIONS.SAVE' : 'ACTIONS.SUBMIT')
            .pipe(first(), tap((label) => (this.userInfoButtonLabel = label)))
            .subscribe();
    }
    validatePhoneForm(phoneNumberControlName, ExtensionControlName) {
        return (formGroup) => {
            try {
                const phoneNumberControl = formGroup.controls[phoneNumberControlName];
                const extensionControl = formGroup.controls[ExtensionControlName];
                return extensionControl &&
                    extensionControl.value &&
                    extensionControl.value.length > 0 &&
                    phoneNumberControl.value.length === 0
                    ? { invalidPhoneNumber: true }
                    : null;
            }
            catch (error) {
                return error;
            }
        };
    }
    validatePhoneNumber(parser) {
        return (control) => {
            var _a, _b, _c, _d;
            try {
                const phoneNumber = parser(control.value.toString());
                return (phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.isValid()) &&
                    isValidNumberForRegion(control.value.toString(), (_c = (_b = (_a = this.phoneForm) === null || _a === void 0 ? void 0 : _a.controls) === null || _b === void 0 ? void 0 : _b.PhoneCountry) === null || _c === void 0 ? void 0 : _c.value)
                    ? null
                    : {
                        invalidPhoneNumber: true,
                    };
            }
            catch (_e) {
                return ((_d = control === null || control === void 0 ? void 0 : control.value) === null || _d === void 0 ? void 0 : _d.length) < 1
                    ? null
                    : {
                        invalidPhoneNumber: true,
                    };
            }
        };
    }
};
UserDetailsComponent.ctorParameters = () => [
    { type: ActivatedRoute },
    { type: FormBuilder },
    { type: LoggerService },
    { type: SpinnerService },
    { type: UserService },
    { type: Router },
    { type: TranslocoService },
    { type: ValidationService },
    { type: ToastrNotificationService },
    { type: Store }
];
UserDetailsComponent = __decorate([
    Component({
        selector: 'lib-user-details',
        template: "<div class=\"administration-form-container\">\r\n  <div class=\"vertical-flow\">\r\n    <h2>{{ title }}</h2>\r\n    <p-tabView class=\"width-100\" data-testid=\"updateUserTabs\">\r\n      <p-tabPanel\r\n        header=\"{{ 'ADMINISTRATION.USER_INFORMATION_TAB' | transloco }}\"\r\n        [selected]=\"activateUserInformation\"\r\n        data-testid=\"userInformationTab\"\r\n      >\r\n        <form [formGroup]=\"userForm\" class=\"vertical-flow\">\r\n          <div class=\"vertical-flow space-between-025 space-before-025\">\r\n            <label for=\"FirstName\">{{\r\n              'ADMINISTRATION.FIRSTNAME' | transloco\r\n            }}</label>\r\n            <div>\r\n              <input\r\n                pInputText\r\n                id=\"FirstName\"\r\n                type=\"text\"\r\n                placeholder=\"{{ 'ADMINISTRATION.FIRSTNAME' | transloco }}\"\r\n                formControlName=\"FirstName\"\r\n                data-testid=\"firstNameInput\"\r\n              />\r\n            </div>\r\n            <span class=\"feedback\">\r\n              <lib-control-message\r\n                [control]=\"userForm.get('FirstName')\"\r\n                data-testid=\"firstNameFeedback\"\r\n              ></lib-control-message\r\n            ></span>\r\n          </div>\r\n          <div class=\"vertical-flow space-between-025\">\r\n            <label for=\"LastName\">{{\r\n              'ADMINISTRATION.LASTNAME' | transloco\r\n            }}</label>\r\n            <div>\r\n              <input\r\n                pInputText\r\n                id=\"LastName\"\r\n                type=\"text\"\r\n                placeholder=\"{{ 'ADMINISTRATION.LASTNAME' | transloco }}\"\r\n                formControlName=\"LastName\"\r\n                data-testid=\"lastNameInput\"\r\n              />\r\n            </div>\r\n            <span class=\"feedback\">\r\n              <lib-control-message\r\n                [control]=\"userForm.get('LastName')\"\r\n                data-testid=\"lastNameFeedback\"\r\n              ></lib-control-message\r\n            ></span>\r\n          </div>\r\n          <div class=\"vertical-flow space-between-025\">\r\n            <label for=\"Username\">{{\r\n              'ADMINISTRATION.USERNAME' | transloco\r\n            }}</label>\r\n            <div>\r\n              <input\r\n                pInputText\r\n                id=\"Username\"\r\n                type=\"text\"\r\n                placeholder=\"{{ 'ADMINISTRATION.USERNAME' | transloco }}\"\r\n                formControlName=\"Username\"\r\n                data-testid=\"usernameInput\"\r\n              />\r\n            </div>\r\n            <span class=\"feedback\">\r\n              <lib-control-message\r\n                [control]=\"userForm.get('Username')\"\r\n                data-testid=\"usernameFeedback\"\r\n              ></lib-control-message\r\n            ></span>\r\n          </div>\r\n          <ng-container *ngIf=\"isUpdating\">\r\n            <div\r\n              class=\"vertical-flow\"\r\n              [ngClass]=\"\r\n                passwordEmpty ? 'space-between-050' : 'space-between-025'\r\n              \"\r\n            >\r\n              <div>\r\n                <p-checkbox\r\n                  id=\"showPassword\"\r\n                  label=\"{{ 'COMMON.UPDATE_PASSWORD' | transloco }}\"\r\n                  (onChange)=\"handleUpdatePassword($event)\"\r\n                  data-testid=\"showPasswordCheckbox\"\r\n                >\r\n                </p-checkbox>\r\n              </div>\r\n              <div\r\n                class=\"vertical-flow space-between-025\"\r\n                *ngIf=\"showUpdatePassword\"\r\n              >\r\n                <label for=\"Password\">\r\n                  {{ 'ADMINISTRATION.PASSWORD' | transloco }}</label\r\n                >\r\n                <div class=\"strongPasswordHint\">\r\n                  {{ 'COMMON.STRONG_PASSWORD_MESSAGE' | transloco }}\r\n                </div>\r\n\r\n                <input\r\n                  [feedback]=\"false\"\r\n                  pPassword\r\n                  id=\"Password\"\r\n                  type=\"password\"\r\n                  placeholder=\"{{ 'ADMINISTRATION.PASSWORD' | transloco }}\"\r\n                  formControlName=\"Password\"\r\n                  data-testid=\"passwordInput\"\r\n                />\r\n                <div class=\"vertical-flow space-between-050\">\r\n                  <span class=\"password-feedback\">\r\n                    <lib-password-validation\r\n                      [passwordToCheck]=\"userForm.value.Password\"\r\n                      (hasPassword)=\"passwordFieldEmptyCheck($event)\"\r\n                      data-testid=\"passwordFeedback\"\r\n                    >\r\n                    </lib-password-validation>\r\n                  </span>\r\n                  <label\r\n                    for=\"ConfirmPassword\"\r\n                    [ngClass]=\"passwordEmpty ? 'space-before-075' : 'no-margin'\"\r\n                    >{{ 'ADMINISTRATION.CONFIRM_PASSWORD' | transloco }}</label\r\n                  >\r\n                </div>\r\n                <input\r\n                  [feedback]=\"false\"\r\n                  pPassword\r\n                  id=\"ConfirmPassword\"\r\n                  type=\"password\"\r\n                  placeholder=\"{{\r\n                    'ADMINISTRATION.CONFIRM_PASSWORD' | transloco\r\n                  }}\"\r\n                  formControlName=\"ConfirmPassword\"\r\n                  data-testid=\"confirmPasswordInput\"\r\n                />\r\n                <span class=\"feedback\">\r\n                  <lib-control-message\r\n                    id=\"message\"\r\n                    [control]=\"userForm.get('ConfirmPassword')\"\r\n                    [errorMsg]=\"message.confirmPassword\"\r\n                    data-testid=\"confirmPasswordFeedback\"\r\n                  >\r\n                  </lib-control-message\r\n                ></span>\r\n              </div>\r\n\r\n              <div\r\n                [formGroup]=\"phoneForm\"\r\n                class=\"vertical-flow space-between-025 space-before-200\"\r\n              >\r\n                <label>\r\n                  {{ 'ADMINISTRATION.PHONE' | transloco }}\r\n                </label>\r\n\r\n                <p-dropdown\r\n                  [options]=\"countries\"\r\n                  (onChange)=\"resetPhoneNumber()\"\r\n                  styleClass=\"width-100 height-46\"\r\n                  formControlName=\"PhoneCountry\"\r\n                  filter=\"true\"\r\n                  placeholder=\"{{ 'ACTIONS.SELECT' | transloco }}\"\r\n                  data-testid=\"countryDropdown\"\r\n                >\r\n                </p-dropdown>\r\n\r\n                <input\r\n                  pInputText\r\n                  id=\"Phone\"\r\n                  type=\"text\"\r\n                  (input)=\"formatPhoneNumber()\"\r\n                  placeholder=\"{{ 'COMMON.PHONE_NUMBER' | transloco }}\"\r\n                  formControlName=\"Phone\"\r\n                  class=\"space-before-200\"\r\n                  data-testid=\"phoneInput\"\r\n                />\r\n                <span class=\"feedback\">\r\n                  <lib-control-message\r\n                    [control]=\"phoneForm?.get('Phone')\"\r\n                    data-testid=\"phoneFeedback\"\r\n                  ></lib-control-message>\r\n                </span>\r\n                <input\r\n                  pInputText\r\n                  id=\"PhoneExtension\"\r\n                  type=\"text\"\r\n                  placeholder=\"{{ 'COMMON.PHONE_EXTENSION' | transloco }}\"\r\n                  formControlName=\"PhoneExtension\"\r\n                  data-testid=\"phoneExtensionInput\"\r\n                />\r\n                <span class=\"feedback\">\r\n                  <lib-control-message\r\n                    [control]=\"phoneForm?.get('PhoneExtension')\"\r\n                    [errorMsg]=\"extension.extension\"\r\n                    data-testid=\"phoneExtensionFeedback\"\r\n                  ></lib-control-message>\r\n                  <lib-control-message\r\n                    [control]=\"phoneForm\"\r\n                    data-testid=\"phoneFormFeedback\"\r\n                  ></lib-control-message>\r\n                </span>\r\n              </div>\r\n            </div>\r\n            <div class=\"vertical-flow space-between-025\">\r\n              <label for=\"Language\" class=\"space-before-075\">{{\r\n                'ADMINISTRATION.LANGUAGE' | transloco\r\n              }}</label>\r\n              <div>\r\n                <p-dropdown\r\n                  [options]=\"languageTypes\"\r\n                  id=\"Language\"\r\n                  formControlName=\"Language\"\r\n                  filter=\"true\"\r\n                  placeholder=\"{{\r\n                    'ADMINISTRATION.SELECT_LANGUAGE' | transloco\r\n                  }}\"\r\n                  data-testid=\"languageDropdown\"\r\n                >\r\n                </p-dropdown>\r\n              </div>\r\n              <span class=\"feedback\">\r\n                <lib-control-message\r\n                  [control]=\"userForm.get('Language')\"\r\n                  data-testid=\"languageFeedback\"\r\n                ></lib-control-message>\r\n              </span>\r\n            </div>\r\n            <div class=\"vertical-flow space-between-025\">\r\n              <label for=\"TimeZone\">\r\n                {{ 'ADMINISTRATION.TIMEZONE' | transloco }}</label\r\n              >\r\n              <div>\r\n                <p-dropdown\r\n                  [options]=\"timeZoneTypes\"\r\n                  id=\"TimeZone\"\r\n                  formControlName=\"TimeZone\"\r\n                  filter=\"true\"\r\n                  placeholder=\"{{\r\n                    'ADMINISTRATION.SELECT_TIMEZONE' | transloco\r\n                  }}\"\r\n                  data-testid=\"timeZoneDropdown\"\r\n                >\r\n                </p-dropdown>\r\n              </div>\r\n              <span class=\"feedback\">\r\n                <lib-control-message\r\n                  [control]=\"userForm.get('TimeZone')\"\r\n                  data-testid=\"timeZoneFeedback\"\r\n                ></lib-control-message\r\n              ></span>\r\n            </div>\r\n\r\n            <div class=\"vertical-flow space-between-025\">\r\n              <label for=\"DateFormat\">{{\r\n                'ADMINISTRATION.DATE_FORMAT' | transloco\r\n              }}</label>\r\n              <div>\r\n                <p-dropdown\r\n                  [options]=\"dateFormatTypes\"\r\n                  id=\"DateFormat\"\r\n                  formControlName=\"DateFormat\"\r\n                  placeholder=\"{{\r\n                    'ADMINISTRATION.SELECT_DATE_FORMAT' | transloco\r\n                  }}\"\r\n                  data-testid=\"dateFormatDropdown\"\r\n                >\r\n                </p-dropdown>\r\n              </div>\r\n              <span class=\"feedback\">\r\n                <lib-control-message\r\n                  [control]=\"userForm.get('DateFormat')\"\r\n                  data-testid=\"dateFormatFeedback\"\r\n                ></lib-control-message>\r\n              </span>\r\n            </div>\r\n          </ng-container>\r\n          <div\r\n            class=\"\r\n              horizontal-flow\r\n              form-controls\r\n              space-between-050 space-before-200\r\n            \"\r\n          >\r\n            <button\r\n              pButton\r\n              type=\"button\"\r\n              id=\"cancelButton1\"\r\n              label=\"{{ 'ACTIONS.CANCEL' | transloco }}\"\r\n              class=\"ds secondary\"\r\n              [routerLink]=\"['/AdministrationModule']\"\r\n              data-testid=\"cancelButton\"\r\n            ></button>\r\n            <button\r\n              pButton\r\n              type=\"button\"\r\n              id=\"submitButton\"\r\n              label=\"{{ userInfoButtonLabel }}\"\r\n              class=\"ds primary\"\r\n              (click)=\"isUpdating ? save() : submit()\"\r\n              [disabled]=\"userForm.invalid || phoneForm.invalid\"\r\n              data-testid=\"submitButton\"\r\n            ></button>\r\n          </div>\r\n        </form>\r\n      </p-tabPanel>\r\n\r\n      <p-tabPanel\r\n        header=\"{{ 'ADMINISTRATION.PAGE_PERMISSIONS_TAB' | transloco }}\"\r\n        [selected]=\"activatePagePermissions\"\r\n        data-testid=\"permissionsTab\"\r\n      >\r\n        <form [formGroup]=\"permissionsForm\">\r\n          <p>\r\n            {{ 'ADMINISTRATION.PAGE_PERMISSIONS_LABEL' | transloco }}\r\n          </p>\r\n          <p-tree\r\n            [value]=\"allPermissions\"\r\n            [(selection)]=\"selectedPermissions\"\r\n            selectionMode=\"checkbox\"\r\n            id=\"permissionsTree\"\r\n            [propagateSelectionUp]=\"false\"\r\n            [propagateSelectionDown]=\"true\"\r\n            data-testid=\"permissionsTree\"\r\n          ></p-tree>\r\n          <div\r\n            class=\"\r\n              horizontal-flow\r\n              form-controls\r\n              space-between-050 space-before-300\r\n            \"\r\n          >\r\n            <button\r\n              pButton\r\n              type=\"button\"\r\n              id=\"cancelButton2\"\r\n              label=\"{{ 'ACTIONS.CANCEL' | transloco }}\"\r\n              class=\"ds secondary\"\r\n              [routerLink]=\"['/AdministrationModule']\"\r\n              data-testid=\"cancelButton\"\r\n            ></button>\r\n            <button\r\n              pButton\r\n              type=\"button\"\r\n              id=\"saveButton\"\r\n              label=\"{{ 'ACTIONS.SAVE' | transloco }}\"\r\n              class=\"ds primary\"\r\n              (click)=\"save()\"\r\n              [disabled]=\"userForm.invalid || phoneForm.invalid\"\r\n              data-testid=\"submitButton\"\r\n            ></button>\r\n          </div>\r\n        </form>\r\n      </p-tabPanel>\r\n    </p-tabView>\r\n  </div>\r\n</div>\r\n",
        styles: [""]
    })
], UserDetailsComponent);

var Status;
(function (Status) {
    Status[Status["ERROR"] = -1] = "ERROR";
    Status[Status["READY"] = 0] = "READY";
    Status[Status["LOADING"] = 1] = "LOADING";
    Status[Status["DONE"] = 2] = "DONE";
})(Status || (Status = {}));
const defaultScreenState = {
    page: 0,
    screens: {},
    status: Status.LOADING,
};
const ɵ0$4 = (_, state) => {
    const status = state.status < 0 ? state.status : Status.DONE;
    return { status };
}, ɵ1$4 = (status) => ({ status }), ɵ2$4 = (screens) => ({ screens }), ɵ3$1 = (_, { page }) => ({
    status: Status.LOADING,
    page: page + 1,
}), ɵ4$1 = (_, { page }) => ({
    status: Status.LOADING,
    page: page - 1,
}), ɵ5$1 = ({ screen, index }, { screens }) => {
    return { screens: Object.assign(Object.assign({}, screens), { [index]: screen }) };
};
const screenSchema = {
    finalize: {
        command: ɵ0$4,
    },
    setStatus: { command: ɵ1$4 },
    setScreens: { command: ɵ2$4 },
    nextPage: {
        command: ɵ3$1,
    },
    previousPage: {
        command: ɵ4$1,
    },
    addScreen: {
        command: ɵ5$1,
    },
};
const ɵ6$1 = () => ({
    fetchUrl: '/connectors/type',
    fetchMethod: 'GET',
    title: 'New Connector',
    form: (options) => ({
        fields: {
            description: { type: 'text', required: true },
            connectorType: { type: 'pDropdown', options, required: true },
        },
    }),
    response: ({ screenConfig, response }) => {
        const { form } = screenConfig;
        return form(response);
    },
}), ɵ7$1 = ({ screens }) => ({
    fetchUrl: `/connectors/type/${screens[0].connectorType}`,
    fetchMethod: 'GET',
    title: `Configuration`,
    response: ({ response }) => {
        return response;
    },
}), ɵ8$1 = ({ screens }) => ({
    fetchUrl: `/connectors/type/${screens[0].connectorType}/form`,
    fetchMethod: 'POST',
    title: `Actions`,
    response: ({ response }) => {
        return response;
    },
});
const wizardConfig$1 = [
    ɵ6$1,
    ɵ7$1,
    ɵ8$1,
];

var DefaultButtons;
(function (DefaultButtons) {
    DefaultButtons["CANCEL"] = "cancel";
    DefaultButtons["NEXT"] = "next";
    DefaultButtons["PREVIOUS"] = "previous";
    DefaultButtons["SUBMIT"] = "submit";
})(DefaultButtons || (DefaultButtons = {}));
const defaultButtonProperties = {
    icon: '',
    iconPos: 'left',
    style: {},
};
const ɵ0$5 = ({ events }) => {
    events.cancel.emit();
}, ɵ1$5 = (state, form) => false, ɵ2$5 = ({ actions, state, form }) => {
    actions.addScreen.dispatch({
        screen: form.values,
        index: state.page,
    });
    actions.nextPage.dispatch();
}, ɵ3$2 = (state, form) => !(form === null || form === void 0 ? void 0 : form.valid), ɵ4$2 = ({ actions }) => {
    actions.previousPage.dispatch();
}, ɵ5$2 = (state, form) => state.page === 0, ɵ6$2 = ({ actions, form, state, events }) => {
    actions.addScreen.dispatch({
        screen: form.values,
        index: state.page,
    });
    events.submit.emit();
}, ɵ7$2 = (state, form) => !(form === null || form === void 0 ? void 0 : form.valid), ɵ8$2 = (_) => { }, ɵ9$1 = (state, form) => false;
const buttonDefaults = {
    cancel: {
        label: '',
        componentProperties: defaultButtonProperties,
        role: 'secondary',
        callback: ɵ0$5,
        disabled: ɵ1$5,
    },
    next: {
        label: '',
        componentProperties: defaultButtonProperties,
        role: 'primary',
        callback: ɵ2$5,
        disabled: ɵ3$2,
    },
    previous: {
        label: '',
        componentProperties: defaultButtonProperties,
        role: 'secondary',
        callback: ɵ4$2,
        disabled: ɵ5$2,
    },
    submit: {
        label: '',
        componentProperties: defaultButtonProperties,
        role: 'primary',
        callback: ɵ6$2,
        disabled: ɵ7$2,
    },
    default: {
        label: '',
        componentProperties: defaultButtonProperties,
        role: 'primary',
        callback: ɵ8$2,
        disabled: ɵ9$1,
    },
};

let ScreenComponent = class ScreenComponent {
    constructor(actionUi, formGenerator, http) {
        this.actionUi = actionUi;
        this.formGenerator = formGenerator;
        this.http = http;
        this.screenSubmit = new EventEmitter();
        this.screenCancel = new EventEmitter();
        this.fetch = new Subject();
        this.statusEnum = Status;
        this.isValid = false;
        this.actionUi.state
            .pipe(tap((state) => (this.state = Object.assign({}, state))), tap((state) => (this.status = state.status)), tap((_) => { var _a; return (this.isValid = ((_a = this.form) === null || _a === void 0 ? void 0 : _a.valid) || false); }), takeUntil(this.actionUi.shouldDestroy))
            .subscribe();
        this.fetch
            .pipe(exhaustMap(() => this.request.pipe(catchError((err) => {
            this.actions.setStatus.dispatch(Status.ERROR);
            return of(err);
        }), finalize(() => this.actions.finalize.dispatch()))), tap((form) => {
            this.form = this.formGenerator.init(this.screen.response({
                screenConfig: this.screen,
                response: form,
            }), this.state.screens[this.state.page] || {});
        }), takeUntil(this.actionUi.shouldDestroy))
            .subscribe();
    }
    buildRequest() {
        this.request = this.http.fetch({
            endpoint: this.screen.fetchUrl,
            httpMethod: this.screen.fetchMethod,
            responseField: this.screen.responseField,
            body: this.screen.body,
        });
    }
    ngOnInit() {
        this.screen = this.config(this.state);
        this.buttons = this.addButtonDefaults(this.screen.buttons);
        this.buildRequest();
        this.fetch.next();
    }
    submit() {
        this.actions.setStatus.dispatch(Status.LOADING);
        this.actions.addScreen.dispatch({
            screen: this.form.values,
            index: this.state.page,
        });
        this.actions.nextPage.dispatch();
        this.screenSubmit.emit();
    }
    previous() {
        this.actions.setStatus.dispatch(Status.LOADING);
        this.actions.previousPage.dispatch();
    }
    addButtonDefaults(buttons) {
        return Object.entries(buttons).reduce((controlSchema, [key, button]) => {
            const newButton = button.componentProperties
                ? Object.assign(Object.assign({}, button), { componentProperties: Object.assign(Object.assign({}, defaultButtonProperties), button.componentProperties) }) : Object.assign(Object.assign({}, button), { componentProperties: Object.assign({}, defaultButtonProperties) });
            switch (key) {
                case DefaultButtons.CANCEL:
                    return Object.assign(Object.assign({}, controlSchema), { [key]: Object.assign(Object.assign({}, buttonDefaults.cancel), newButton) });
                case DefaultButtons.NEXT:
                    return Object.assign(Object.assign({}, controlSchema), { [key]: Object.assign(Object.assign({}, buttonDefaults.next), newButton) });
                case DefaultButtons.PREVIOUS:
                    return Object.assign(Object.assign({}, controlSchema), { [key]: Object.assign(Object.assign({}, buttonDefaults.previous), newButton) });
                case DefaultButtons.SUBMIT:
                    return Object.assign(Object.assign({}, controlSchema), { [key]: Object.assign(Object.assign({}, buttonDefaults.submit), newButton) });
                default:
                    return Object.assign(Object.assign({}, controlSchema), { [key]: Object.assign(Object.assign({}, buttonDefaults.default), newButton) });
            }
        }, {});
    }
    get screenControls() {
        return {
            actions: this.actions,
            state: this.state,
            form: this.form,
            events: { submit: this.screenSubmit, cancel: this.screenCancel },
        };
    }
    preserveOrder() {
        return 0;
    }
};
ScreenComponent.ctorParameters = () => [
    { type: ActionUiService },
    { type: GenerateFormService },
    { type: BaseHttpService }
];
__decorate([
    Input()
], ScreenComponent.prototype, "config", void 0);
__decorate([
    Input()
], ScreenComponent.prototype, "actions", void 0);
__decorate([
    Output()
], ScreenComponent.prototype, "screenSubmit", void 0);
__decorate([
    Output()
], ScreenComponent.prototype, "screenCancel", void 0);
ScreenComponent = __decorate([
    Component({
        selector: 'lib-screen',
        template: "<div class=\"screen\" style=\"display: flex; flex-direction: column\">\r\n  <div style=\"flex-grow: 1; position: relative\">\r\n    <ng-container *ngIf=\"status === statusEnum.ERROR\">\r\n      <div\r\n        class=\"error\"\r\n        style=\"\r\n          min-height: 30vh;\r\n          display: flex;\r\n          justify-content: center;\r\n          align-items: center;\r\n        \"\r\n      >\r\n        <div>\r\n          <span>\r\n            <i class=\"pi pi-times-circle\"></i>\r\n            {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n          </span>\r\n        </div>\r\n      </div>\r\n    </ng-container>\r\n    <ng-container *ngIf=\"status === statusEnum.READY\"> ready</ng-container>\r\n    <ng-container *ngIf=\"status === statusEnum.LOADING\">\r\n      <div\r\n        class=\"spinner-background\"\r\n        style=\"min-height: 30vh; position: relative\"\r\n      >\r\n        <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n      </div>\r\n    </ng-container>\r\n    <ng-container *ngIf=\"status === statusEnum.DONE\">\r\n      <div style=\"display: flex; justify-content: center\">\r\n        <h2>{{ screen.title }}</h2>\r\n      </div>\r\n      <lui-form *ngIf=\"form\" [form]=\"form\"></lui-form>\r\n    </ng-container>\r\n  </div>\r\n  <div\r\n    class=\"contols\"\r\n    style=\"display: flex; gap: 0.5em; padding-top: 1em; margin-bottom: 5em\"\r\n  >\r\n    <button\r\n      *ngFor=\"let button of buttons | keyvalue : preserveOrder\"\r\n      pButton\r\n      (click)=\"button.value.callback(screenControls)\"\r\n      [disabled]=\"button.value.disabled(state, form)\"\r\n      [icon]=\"button.value.componentProperties.icon\"\r\n      [iconPos]=\"button.value.componentProperties.iconPos\"\r\n      [label]=\"button.value.label\"\r\n      [ngStyle]=\"button.value.componentProperties.style\"\r\n      class=\"ds {{ button.value.role }}\"\r\n    ></button>\r\n  </div>\r\n</div>\r\n",
        styles: [".controls{display:flex;flex-direction:row}"]
    })
], ScreenComponent);

let WizardComponent = class WizardComponent {
    constructor(actionUi) {
        this.actionUi = actionUi;
        this.defaultState = {};
        this.finalize = new EventEmitter();
        this.cancel = new EventEmitter();
        this.actions = Action.createDispatcher(screenSchema);
    }
    ngOnInit() {
        this.actionUi.initialize(Object.assign(Object.assign({}, defaultScreenState), this.defaultState), this.actions);
        this.actionUi.state
            .pipe(tap((state) => (this.state = Object.assign({}, state))), takeUntil(this.actionUi.shouldDestroy))
            .subscribe();
    }
    screenSubmit() {
        this.finalize.emit(Object.values(this.state.screens));
    }
};
WizardComponent.ctorParameters = () => [
    { type: ActionUiService }
];
__decorate([
    Input()
], WizardComponent.prototype, "wizardConfig", void 0);
__decorate([
    Input()
], WizardComponent.prototype, "defaultState", void 0);
__decorate([
    Output()
], WizardComponent.prototype, "finalize", void 0);
__decorate([
    Output()
], WizardComponent.prototype, "cancel", void 0);
WizardComponent = __decorate([
    Component({
        selector: 'lib-wizard',
        template: "<div class=\"wizard\">\r\n  <ng-container *ngFor=\"let screen of wizardConfig; index as i\">\r\n    <lib-screen\r\n      *ngIf=\"state.page === i\"\r\n      appScreen\r\n      [config]=\"screen\"\r\n      [actions]=\"actions\"\r\n      (screenCancel)=\"cancel.emit()\"\r\n      (screenSubmit)=\"screenSubmit()\"\r\n    ></lib-screen>\r\n  </ng-container>\r\n</div>\r\n",
        providers: [ActionUiService]
    })
], WizardComponent);

let WizardModule = class WizardModule {
};
WizardModule = __decorate([
    NgModule({
        declarations: [WizardComponent, ScreenComponent],
        imports: [
            CommonModule,
            PerFormPrimengModule,
            PerFormModule,
            ButtonModule,
            ProgressSpinnerModule,
            TranslocoModule,
        ],
        exports: [WizardComponent],
    })
], WizardModule);

let MarketplaceConnectorModule = class MarketplaceConnectorModule {
};
MarketplaceConnectorModule = __decorate([
    NgModule({
        declarations: [
            MarketplaceConnectorComponent,
            ViewMarketplaceConnectorsComponent,
            NewConnectionWizardComponent,
            EditConnectionWizardComponent,
        ],
        imports: [
            CommonModule,
            ButtonModule$1,
            CheckboxModule,
            ConfirmDialogModule,
            DropdownModule,
            FormsModule,
            MultiSelectModule,
            RadioButtonModule,
            ReactiveFormsModule,
            RouterModule,
            SearchContainerModule,
            TabViewModule,
            ToolbarModule,
            TranslocoModule,
            TreeTableModule,
            ProgressSpinnerModule$1,
            UtilsModule,
            DialogModule,
            TableModule,
            CalendarModule,
            InputNumberModule,
            SearchContainerLoaderModule,
            PerFormPrimengModule,
            WizardModule,
            LuiWizardV3Module,
            LuiWidgetWrapperModule,
        ],
        providers: [ConfirmationService$3],
    })
], MarketplaceConnectorModule);

let ViewFormComponent = class ViewFormComponent {
    constructor(adminService) {
        this.adminService = adminService;
        this.closeDialog = new EventEmitter();
        this.state = {};
        this.templateTypes = TemplateTypes;
        this.baseUrl = this.adminService.getConfig().getAccountRootURL;
    }
    set dataSetter(data) {
        this.data = data;
    }
    ngOnInit() {
        this.wizardConfig = {
            endpoint: `administration/accounts-payable/view/form/${this.data.accountRelationshipKey}`,
            httpMethod: HttpMethod$1.GET,
        };
        // this.form = this.formGenerator.init(
        //   schemaDefinition(this.translate),
        //   toFormValues(this.data)
        // );
    }
    close() {
        this.closeDialog.emit();
    }
};
ViewFormComponent.ctorParameters = () => [
    { type: AdministrationService }
];
__decorate([
    Input('data')
], ViewFormComponent.prototype, "dataSetter", null);
__decorate([
    Input()
], ViewFormComponent.prototype, "translate", void 0);
__decorate([
    Output()
], ViewFormComponent.prototype, "closeDialog", void 0);
ViewFormComponent = __decorate([
    Component({
        selector: 'lib-view-form',
        template: "<div\r\n  class=\"crossrefrences-dialogue\"\r\n  style=\"display: flex; flex-direction: column\"\r\n>\r\n  <lui-wizard\r\n    [wizardConfig]=\"wizardConfig\"\r\n    [baseUrl]=\"baseUrl\"\r\n    (submit)=\"close()\"\r\n    (cancel)=\"close()\"\r\n  >\r\n    <ng-template [luiWidget]=\"templateTypes.READY\">\r\n      <div class=\"center ready\">\r\n        <h1>rdy msg</h1>\r\n      </div>\r\n    </ng-template>\r\n    <ng-template [luiWidget]=\"templateTypes.LOADING\">\r\n      <div class=\"spinner-background\">\r\n        <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n      </div>\r\n    </ng-template>\r\n    <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n      <div\r\n        class=\"error\"\r\n        style=\"\r\n          min-height: 30vh;\r\n          display: flex;\r\n          justify-content: center;\r\n          align-items: center;\r\n        \"\r\n      >\r\n        <div>\r\n          <span>\r\n            <i class=\"pi pi-times-circle\"></i>\r\n            {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n          </span>\r\n        </div>\r\n      </div>\r\n      <button pButton (click)=\"close()\" class=\"ds secondary\">\r\n        {{ 'ACTIONS.CANCEL' | transloco }}\r\n      </button>\r\n    </ng-template>\r\n  </lui-wizard>\r\n  <!-- <h2 class=\"dialog-title\">\r\n    {{ 'ADMINISTRATION.VIEW_ACCOUNTING_CONFIGURATION_PAYABLE' | transloco }}\r\n  </h2>\r\n  <div style=\"flex-grow: 1; position: relative\">\r\n    <lui-form *ngIf=\"form; else formNotAvailable\" [form]=\"form\"></lui-form>\r\n    <ng-template #formNotAvailable>\r\n      <div\r\n        class=\"spinner-background\"\r\n        style=\"min-height: 30vh; position: relative\"\r\n      >\r\n        <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n      </div>\r\n    </ng-template>\r\n  </div>\r\n\r\n  <div style=\"display: flex; column-gap: 0.5em\">\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.CLOSE' | transloco }}\"\r\n      class=\"ds secondary\"\r\n      style=\"flex-grow: 1\"\r\n      (click)=\"close()\"\r\n    ></button>\r\n  </div> -->\r\n</div>\r\n"
    })
], ViewFormComponent);

let EditFormComponent = class EditFormComponent {
    constructor(adminService) {
        this.adminService = adminService;
        this.closeDialog = new EventEmitter();
        this.saveDialog = new EventEmitter();
        this.state = {};
        this.templateTypes = TemplateTypes;
        this.baseUrl = this.adminService.getConfig().getAccountRootURL;
    }
    set dataSetter(data) {
        this.data = data;
    }
    ngOnInit() {
        this.wizardConfig = {
            endpoint: `administration/accounts-payable/edit/form/${this.data.accountRelationshipKey}`,
            httpMethod: HttpMethod$1.GET,
        };
        // const formData = toFormValues(this.data);
        // this.form = this.formGenerator.init(
        //   schemaDefinition(this.translate, formData),
        //   formData
        // );
        // this.checkFormValidity();
        // this.form.values$
        //   .pipe(
        //     queryChange('billingType'),
        //     tap((value) => {
        //       value === 2 ? this.disableFields() : this.enableFields();
        //     })
        //   )
        //   .subscribe();
    }
    save(data) {
        this.saveDialog.emit(data[0]);
    }
    close() {
        this.closeDialog.emit();
    }
};
EditFormComponent.ctorParameters = () => [
    { type: AdministrationService }
];
__decorate([
    Input('data')
], EditFormComponent.prototype, "dataSetter", null);
__decorate([
    Input()
], EditFormComponent.prototype, "translate", void 0);
__decorate([
    Output()
], EditFormComponent.prototype, "closeDialog", void 0);
__decorate([
    Output()
], EditFormComponent.prototype, "saveDialog", void 0);
EditFormComponent = __decorate([
    Component({
        selector: 'lib-edit-form',
        template: "<div\r\n  class=\"crossrefrences-dialogue\"\r\n  style=\"display: flex; flex-direction: column\"\r\n>\r\n  <lui-wizard\r\n    [wizardConfig]=\"wizardConfig\"\r\n    [baseUrl]=\"baseUrl\"\r\n    (submit)=\"save($event)\"\r\n    (cancel)=\"close()\"\r\n  >\r\n    <ng-template [luiWidget]=\"templateTypes.READY\">\r\n      <div class=\"center ready\">\r\n        <h1>rdy msg</h1>\r\n      </div>\r\n    </ng-template>\r\n    <ng-template [luiWidget]=\"templateTypes.LOADING\">\r\n      <div class=\"spinner-background\">\r\n        <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n      </div>\r\n    </ng-template>\r\n    <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n      <div\r\n        class=\"error\"\r\n        style=\"\r\n          min-height: 30vh;\r\n          display: flex;\r\n          justify-content: center;\r\n          align-items: center;\r\n        \"\r\n      >\r\n        <div>\r\n          <span>\r\n            <i class=\"pi pi-times-circle\"></i>\r\n            {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n          </span>\r\n        </div>\r\n      </div>\r\n      <button pButton (click)=\"close()\" class=\"ds secondary\">\r\n        {{ 'ACTIONS.CANCEL' | transloco }}\r\n      </button>\r\n    </ng-template>\r\n  </lui-wizard>\r\n  <!-- <h2 class=\"dialog-title\">\r\n    {{ 'ADMINISTRATION.EDIT_ACCOUNTING_CONFIGURATION_PAYABLE' | transloco }}\r\n  </h2>\r\n  <div style=\"flex-grow: 1; position: relative\">\r\n    <lui-form *ngIf=\"form; else formNotAvailable\" [form]=\"form\"></lui-form>\r\n    <ng-template #formNotAvailable>\r\n      <div\r\n        class=\"spinner-background\"\r\n        style=\"min-height: 30vh; position: relative\"\r\n      >\r\n        <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n      </div>\r\n    </ng-template>\r\n  </div>\r\n\r\n  <div\r\n    class=\"contols\"\r\n    style=\"display: flex; gap: 0.5em; padding-top: 1em; padding-bottom: 5em\"\r\n  >\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.CANCEL' | transloco }}\"\r\n      class=\"ds secondary\"\r\n      (click)=\"close()\"\r\n    ></button>\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.SAVE' | transloco }}\"\r\n      class=\"ds\"\r\n      (click)=\"save()\"\r\n      [disabled]=\"!form?.valid\"\r\n      style=\"flex-grow: 1\"\r\n    ></button>\r\n  </div> -->\r\n</div>\r\n"
    })
], EditFormComponent);

let ReceivableEditFormComponent = class ReceivableEditFormComponent {
    constructor(adminService) {
        this.adminService = adminService;
        this.closeDialog = new EventEmitter();
        this.saveDialog = new EventEmitter();
        this.state = {};
        this.templateTypes = TemplateTypes;
        this.baseUrl = this.adminService.getConfig().getAccountRootURL;
    }
    set dataSetter(data) {
        this.data = data;
    }
    ngOnInit() {
        this.wizardConfig = {
            endpoint: `administration/accounts-receivable/edit/form/${this.data.accountRelationshipKey}`,
            httpMethod: HttpMethod$1.GET,
        };
        // const formData = toFormValues(this.data);
        // this.form = this.formGenerator.init(
        //   schemaDefinition(this.translate, formData),
        //   formData
        // );
        // this.checkFormValidity();
        // this.form.values$
        //   .pipe(
        //     queryChange('billingType'),
        //     tap((value) => {
        //       value === 2 ? this.disableFields() : this.enableFields();
        //     })
        //   )
        //   .subscribe();
    }
    save(data) {
        this.saveDialog.emit(data[0]);
    }
    close() {
        this.closeDialog.emit();
    }
};
ReceivableEditFormComponent.ctorParameters = () => [
    { type: AdministrationService }
];
__decorate([
    Input('data')
], ReceivableEditFormComponent.prototype, "dataSetter", null);
__decorate([
    Input()
], ReceivableEditFormComponent.prototype, "translate", void 0);
__decorate([
    Output()
], ReceivableEditFormComponent.prototype, "closeDialog", void 0);
__decorate([
    Output()
], ReceivableEditFormComponent.prototype, "saveDialog", void 0);
ReceivableEditFormComponent = __decorate([
    Component({
        selector: 'lib-receivable-edit-form',
        template: "<div\r\n  class=\"crossrefrences-dialogue\"\r\n  style=\"display: flex; flex-direction: column\"\r\n>\r\n  <lui-wizard\r\n    [wizardConfig]=\"wizardConfig\"\r\n    [baseUrl]=\"baseUrl\"\r\n    (submit)=\"save($event)\"\r\n    (cancel)=\"close()\"\r\n  >\r\n    <ng-template [luiWidget]=\"templateTypes.READY\">\r\n      <div class=\"center ready\">\r\n        <h1>rdy msg</h1>\r\n      </div>\r\n    </ng-template>\r\n    <ng-template [luiWidget]=\"templateTypes.LOADING\">\r\n      <div class=\"spinner-background\">\r\n        <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n      </div>\r\n    </ng-template>\r\n    <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n      <div\r\n        class=\"error\"\r\n        style=\"\r\n          min-height: 30vh;\r\n          display: flex;\r\n          justify-content: center;\r\n          align-items: center;\r\n        \"\r\n      >\r\n        <div>\r\n          <span>\r\n            <i class=\"pi pi-times-circle\"></i>\r\n            {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n          </span>\r\n        </div>\r\n      </div>\r\n      <button pButton (click)=\"close()\" class=\"ds secondary\">\r\n        {{ 'ACTIONS.CANCEL' | transloco }}\r\n      </button>\r\n    </ng-template>\r\n  </lui-wizard>\r\n  <!-- <h2 class=\"dialog-title\">\r\n    {{ 'ADMINISTRATION.EDIT_ACCOUNTING_CONFIGURATION_RECEIVABLE' | transloco }}\r\n  </h2>\r\n  <div style=\"flex-grow: 1; position: relative\">\r\n    <lui-form *ngIf=\"form; else formNotAvailable\" [form]=\"form\"></lui-form>\r\n    <ng-template #formNotAvailable>\r\n      <div\r\n        class=\"spinner-background\"\r\n        style=\"min-height: 30vh; position: relative\"\r\n      >\r\n        <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n      </div>\r\n    </ng-template>\r\n  </div>\r\n\r\n  <div\r\n    class=\"contols\"\r\n    style=\"display: flex; gap: 0.5em; padding-top: 1em; padding-bottom: 5em\"\r\n  >\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.CANCEL' | transloco }}\"\r\n      class=\"ds secondary\"\r\n      (click)=\"close()\"\r\n    ></button>\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.SAVE' | transloco }}\"\r\n      class=\"ds\"\r\n      (click)=\"save()\"\r\n      [disabled]=\"!form?.valid\"\r\n      style=\"flex-grow: 1\"\r\n    ></button>\r\n  </div> -->\r\n</div>\r\n"
    })
], ReceivableEditFormComponent);

let ReceivableViewFormComponent = class ReceivableViewFormComponent {
    constructor(adminService) {
        this.adminService = adminService;
        this.closeDialog = new EventEmitter();
        this.state = {};
        this.templateTypes = TemplateTypes;
        this.baseUrl = this.adminService.getConfig().getAccountRootURL;
    }
    set dataSetter(data) {
        this.data = data;
    }
    ngOnInit() {
        this.wizardConfig = {
            endpoint: `administration/accounts-receivable/view/form/${this.data.accountRelationshipKey}`,
            httpMethod: HttpMethod$1.GET,
        };
        // this.form = this.formGenerator.init(
        //   schemaDefinition(this.translate),
        //   toFormValues(this.data)
        // );
    }
    close() {
        this.closeDialog.emit();
    }
};
ReceivableViewFormComponent.ctorParameters = () => [
    { type: AdministrationService }
];
__decorate([
    Input('data')
], ReceivableViewFormComponent.prototype, "dataSetter", null);
__decorate([
    Input()
], ReceivableViewFormComponent.prototype, "translate", void 0);
__decorate([
    Output()
], ReceivableViewFormComponent.prototype, "closeDialog", void 0);
ReceivableViewFormComponent = __decorate([
    Component({
        selector: 'lib-receivable-view-form',
        template: "<div\r\n  class=\"crossrefrences-dialogue\"\r\n  style=\"display: flex; flex-direction: column\"\r\n>\r\n  <lui-wizard\r\n    [wizardConfig]=\"wizardConfig\"\r\n    [baseUrl]=\"baseUrl\"\r\n    (submit)=\"close()\"\r\n    (cancel)=\"close()\"\r\n  >\r\n    <ng-template [luiWidget]=\"templateTypes.READY\">\r\n      <div class=\"center ready\">\r\n        <h1>rdy msg</h1>\r\n      </div>\r\n    </ng-template>\r\n    <ng-template [luiWidget]=\"templateTypes.LOADING\">\r\n      <div class=\"spinner-background\">\r\n        <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n      </div>\r\n    </ng-template>\r\n    <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n      <div\r\n        class=\"error\"\r\n        style=\"\r\n          min-height: 30vh;\r\n          display: flex;\r\n          justify-content: center;\r\n          align-items: center;\r\n        \"\r\n      >\r\n        <div>\r\n          <span>\r\n            <i class=\"pi pi-times-circle\"></i>\r\n            {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n          </span>\r\n        </div>\r\n      </div>\r\n      <button pButton (click)=\"close()\" class=\"ds secondary\">\r\n        {{ 'ACTIONS.CANCEL' | transloco }}\r\n      </button>\r\n    </ng-template>\r\n  </lui-wizard>\r\n  <!-- <h2 class=\"dialog-title\">\r\n    {{ 'ADMINISTRATION.VIEW_ACCOUNTING_CONFIGURATION_RECEIVABLE' | transloco }}\r\n  </h2>\r\n  <div style=\"flex-grow: 1; position: relative\">\r\n    <lui-form *ngIf=\"form; else formNotAvailable\" [form]=\"form\"></lui-form>\r\n    <ng-template #formNotAvailable>\r\n      <div\r\n        class=\"spinner-background\"\r\n        style=\"min-height: 30vh; position: relative\"\r\n      >\r\n        <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n      </div>\r\n    </ng-template>\r\n  </div>\r\n  <div style=\"display: flex; column-gap: 0.5em\">\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.CLOSE' | transloco }}\"\r\n      class=\"ds secondary\"\r\n      style=\"flex-grow: 1\"\r\n      (click)=\"close()\"\r\n    ></button>\r\n  </div> -->\r\n</div>\r\n"
    })
], ReceivableViewFormComponent);

function fromFormValues$1(data) {
    return Object.entries(data).reduce((total, [key, value]) => (Object.assign(Object.assign({}, total), { [key]: { Value: value !== '' ? value : null } })), {});
}

let AccountingReceivableBulkUpdateComponent = class AccountingReceivableBulkUpdateComponent {
    constructor() {
        this.closeDialog = new EventEmitter();
        this.saveDialog = new EventEmitter();
    }
    set formSetter(form) {
        this.form = form;
    }
    ngOnInit() { }
    save() {
        this.saveDialog.emit(fromFormValues$1(this.form.values));
    }
    close() {
        this.closeDialog.emit();
    }
};
__decorate([
    Input('form')
], AccountingReceivableBulkUpdateComponent.prototype, "formSetter", null);
__decorate([
    Output()
], AccountingReceivableBulkUpdateComponent.prototype, "closeDialog", void 0);
__decorate([
    Output()
], AccountingReceivableBulkUpdateComponent.prototype, "saveDialog", void 0);
AccountingReceivableBulkUpdateComponent = __decorate([
    Component({
        selector: 'lib-ar-bulk-update',
        template: "<div\r\n  class=\"crossrefrences-dialogue\"\r\n  style=\"display: flex; flex-direction: column\"\r\n>\r\n  <h2 class=\"dialog-title\">\r\n    {{\r\n      'ADMINISTRATION.BULK_UPDATE_ACCOUNTING_CONFIGURATION_RECEIVABLE'\r\n        | transloco\r\n    }}\r\n  </h2>\r\n  <div style=\"flex-grow: 1; position: relative\">\r\n    <lui-form *ngIf=\"form; else formNotAvailable\" [form]=\"form\"></lui-form>\r\n    <ng-template #formNotAvailable>\r\n      <div\r\n        class=\"spinner-background\"\r\n        style=\"min-height: 30vh; position: relative\"\r\n      >\r\n        <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n      </div>\r\n    </ng-template>\r\n  </div>\r\n\r\n  <div\r\n    class=\"contols\"\r\n    style=\"display: flex; gap: 0.5em; padding-top: 1em; padding-bottom: 5em\"\r\n  >\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.CANCEL' | transloco }}\"\r\n      class=\"ds secondary\"\r\n      (click)=\"close()\"\r\n    ></button>\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.SAVE' | transloco }}\"\r\n      class=\"ds\"\r\n      (click)=\"save()\"\r\n      [disabled]=\"!form?.valid\"\r\n      style=\"flex-grow: 1\"\r\n    ></button>\r\n  </div>\r\n</div>\r\n"
    })
], AccountingReceivableBulkUpdateComponent);

let AccountingReceivableBulkUpdateContainerComponent = class AccountingReceivableBulkUpdateContainerComponent {
    constructor(http, translocoService, toast, formGenerator) {
        this.http = http;
        this.translocoService = translocoService;
        this.toast = toast;
        this.formGenerator = formGenerator;
        this.closeDialog = new EventEmitter();
        this.saveDialog = new EventEmitter();
        this.updatePrintOptions = new EventEmitter();
        this._shouldDestroy = new Subject();
    }
    ngOnInit() {
        this.http
            .fetchWithFqn({
            endpoint: `${this.baseUrl}/bulk-update/form`,
            httpMethod: 'POST',
            body: {
                keys: this.selectedAccounts,
            },
        })
            .pipe(tap(({ fields }) => {
            this.form = this.formGenerator.init({ fields });
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), takeUntil(this._shouldDestroy))
            .subscribe();
    }
    ngOnDestroy() {
        this._shouldDestroy.next(true);
    }
};
AccountingReceivableBulkUpdateContainerComponent.ctorParameters = () => [
    { type: BaseHttpService$2 },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: GenerateFormService }
];
__decorate([
    Input()
], AccountingReceivableBulkUpdateContainerComponent.prototype, "baseUrl", void 0);
__decorate([
    Input()
], AccountingReceivableBulkUpdateContainerComponent.prototype, "selectedAccounts", void 0);
__decorate([
    Input()
], AccountingReceivableBulkUpdateContainerComponent.prototype, "translate", void 0);
__decorate([
    Output()
], AccountingReceivableBulkUpdateContainerComponent.prototype, "closeDialog", void 0);
__decorate([
    Output()
], AccountingReceivableBulkUpdateContainerComponent.prototype, "saveDialog", void 0);
__decorate([
    Output()
], AccountingReceivableBulkUpdateContainerComponent.prototype, "updatePrintOptions", void 0);
AccountingReceivableBulkUpdateContainerComponent = __decorate([
    Component({
        selector: 'lib-ar-bulk-update-container',
        template: ` <lib-ar-bulk-update
    [form]="form"
    (closeDialog)="closeDialog.emit()"
    (saveDialog)="saveDialog.emit($event)"
  ></lib-ar-bulk-update>`
    })
], AccountingReceivableBulkUpdateContainerComponent);

function fromFormValues$2(data) {
    return Object.entries(data).reduce((total, [key, value]) => (Object.assign(Object.assign({}, total), { [key]: { Value: value !== '' ? value : null } })), {});
}

let AccountingPayableBulkUpdateComponent = class AccountingPayableBulkUpdateComponent {
    constructor() {
        this.closeDialog = new EventEmitter();
        this.saveDialog = new EventEmitter();
    }
    set formSetter(form) {
        this.form = form;
    }
    ngOnInit() { }
    save() {
        this.saveDialog.emit(fromFormValues$2(this.form.values));
    }
    close() {
        this.closeDialog.emit();
    }
};
__decorate([
    Input('form')
], AccountingPayableBulkUpdateComponent.prototype, "formSetter", null);
__decorate([
    Output()
], AccountingPayableBulkUpdateComponent.prototype, "closeDialog", void 0);
__decorate([
    Output()
], AccountingPayableBulkUpdateComponent.prototype, "saveDialog", void 0);
AccountingPayableBulkUpdateComponent = __decorate([
    Component({
        selector: 'lib-ap-bulk-update',
        template: "<div\r\n  class=\"crossrefrences-dialogue\"\r\n  style=\"display: flex; flex-direction: column\"\r\n>\r\n  <h2 class=\"dialog-title\">\r\n    {{\r\n      'ADMINISTRATION.BULK_UPDATE_ACCOUNTING_CONFIGURATION_PAYABLE' | transloco\r\n    }}\r\n  </h2>\r\n  <div style=\"flex-grow: 1; position: relative\">\r\n    <lui-form *ngIf=\"form; else formNotAvailable\" [form]=\"form\"></lui-form>\r\n    <ng-template #formNotAvailable>\r\n      <div\r\n        class=\"spinner-background\"\r\n        style=\"min-height: 30vh; position: relative\"\r\n      >\r\n        <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n      </div>\r\n    </ng-template>\r\n  </div>\r\n\r\n  <div\r\n    class=\"contols\"\r\n    style=\"display: flex; gap: 0.5em; padding-top: 1em; padding-bottom: 5em\"\r\n  >\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.CANCEL' | transloco }}\"\r\n      class=\"ds secondary\"\r\n      (click)=\"close()\"\r\n    ></button>\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.SAVE' | transloco }}\"\r\n      class=\"ds\"\r\n      (click)=\"save()\"\r\n      [disabled]=\"!form?.valid\"\r\n      style=\"flex-grow: 1\"\r\n    ></button>\r\n  </div>\r\n</div>\r\n"
    })
], AccountingPayableBulkUpdateComponent);

let AccountingPayableBulkUpdateContainerComponent = class AccountingPayableBulkUpdateContainerComponent {
    constructor(http, spinner, translocoService, toast, formGenerator) {
        this.http = http;
        this.spinner = spinner;
        this.translocoService = translocoService;
        this.toast = toast;
        this.formGenerator = formGenerator;
        this.closeDialog = new EventEmitter();
        this.saveDialog = new EventEmitter();
        this.updatePrintOptions = new EventEmitter();
        this._shouldDestroy = new Subject();
    }
    ngOnInit() {
        this.http
            .fetchWithFqn({
            endpoint: `${this.baseUrl}/bulk-update/form`,
            httpMethod: 'POST',
            body: {
                keys: this.selectedAccounts,
            },
        })
            .pipe(tap(({ fields }) => {
            this.form = this.formGenerator.init({ fields });
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), takeUntil(this._shouldDestroy))
            .subscribe();
    }
    ngOnDestroy() {
        this._shouldDestroy.next(true);
    }
};
AccountingPayableBulkUpdateContainerComponent.ctorParameters = () => [
    { type: BaseHttpService$2 },
    { type: SpinnerService },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: GenerateFormService }
];
__decorate([
    Input()
], AccountingPayableBulkUpdateContainerComponent.prototype, "baseUrl", void 0);
__decorate([
    Input()
], AccountingPayableBulkUpdateContainerComponent.prototype, "selectedAccounts", void 0);
__decorate([
    Input()
], AccountingPayableBulkUpdateContainerComponent.prototype, "translate", void 0);
__decorate([
    Output()
], AccountingPayableBulkUpdateContainerComponent.prototype, "closeDialog", void 0);
__decorate([
    Output()
], AccountingPayableBulkUpdateContainerComponent.prototype, "saveDialog", void 0);
__decorate([
    Output()
], AccountingPayableBulkUpdateContainerComponent.prototype, "updatePrintOptions", void 0);
AccountingPayableBulkUpdateContainerComponent = __decorate([
    Component({
        selector: 'lib-ap-bulk-update-container',
        template: ` <lib-ap-bulk-update
    [form]="form"
    (closeDialog)="closeDialog.emit()"
    (saveDialog)="saveDialog.emit($event)"
  ></lib-ap-bulk-update>`
    })
], AccountingPayableBulkUpdateContainerComponent);

function fromFormValues$3(data) {
    return Object.entries(data).reduce((total, [key, value]) => (Object.assign(Object.assign({}, total), { [key]: { Value: value !== '' ? value : null } })), {});
}

let PayConfigBulkUpdateComponent = class PayConfigBulkUpdateComponent {
    constructor() {
        this.closeDialog = new EventEmitter();
        this.saveDialog = new EventEmitter();
    }
    set formSetter(form) {
        this.form = form;
    }
    ngOnInit() { }
    save() {
        this.saveDialog.emit(fromFormValues$3(this.form.values));
    }
    close() {
        this.closeDialog.emit();
    }
};
__decorate([
    Input('form')
], PayConfigBulkUpdateComponent.prototype, "formSetter", null);
__decorate([
    Output()
], PayConfigBulkUpdateComponent.prototype, "closeDialog", void 0);
__decorate([
    Output()
], PayConfigBulkUpdateComponent.prototype, "saveDialog", void 0);
PayConfigBulkUpdateComponent = __decorate([
    Component({
        selector: 'lib-pay-config-bulk-update',
        template: "<div\r\n  class=\"crossrefrences-dialogue\"\r\n  style=\"display: flex; flex-direction: column\"\r\n>\r\n  <h2 class=\"dialog-title\">\r\n    {{\r\n      'ADMINISTRATION.BULK_UPDATE_ACCOUNTING_CONFIGURATION_PAYABLE' | transloco\r\n    }}\r\n  </h2>\r\n  <div style=\"flex-grow: 1; position: relative\">\r\n    <lui-form *ngIf=\"form; else formNotAvailable\" [form]=\"form\"></lui-form>\r\n    <ng-template #formNotAvailable>\r\n      <div\r\n        class=\"spinner-background\"\r\n        style=\"min-height: 30vh; position: relative\"\r\n      >\r\n        <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n      </div>\r\n    </ng-template>\r\n  </div>\r\n\r\n  <div\r\n    class=\"contols\"\r\n    style=\"display: flex; gap: 0.5em; padding-top: 1em; padding-bottom: 5em\"\r\n  >\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.CANCEL' | transloco }}\"\r\n      class=\"ds secondary\"\r\n      (click)=\"close()\"\r\n      data-testid=\"cancelButton\"\r\n    ></button>\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.SAVE' | transloco }}\"\r\n      class=\"ds\"\r\n      (click)=\"save()\"\r\n      [disabled]=\"!form?.valid\"\r\n      style=\"flex-grow: 1\"\r\n      data-testid=\"saveButton\"\r\n    ></button>\r\n  </div>\r\n</div>\r\n"
    })
], PayConfigBulkUpdateComponent);

let PayConfigBulkUpdateContainerComponent = class PayConfigBulkUpdateContainerComponent {
    constructor(http, spinner, translocoService, toast, formGenerator) {
        this.http = http;
        this.spinner = spinner;
        this.translocoService = translocoService;
        this.toast = toast;
        this.formGenerator = formGenerator;
        this.closeDialog = new EventEmitter();
        this.saveDialog = new EventEmitter();
        this.updatePrintOptions = new EventEmitter();
        this._shouldDestroy = new Subject();
    }
    ngOnInit() {
        this.http
            .fetchWithFqn({
            endpoint: `${this.baseUrl}/bulk-update/form`,
            httpMethod: 'GET',
        })
            .pipe(tap(({ fields }) => {
            this.form = this.formGenerator.init({ fields }, {
                optionType: this.selectedAccounts.length > 0 ? '3' : null,
            });
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), takeUntil(this._shouldDestroy))
            .subscribe();
    }
    ngOnDestroy() {
        this._shouldDestroy.next(true);
    }
};
PayConfigBulkUpdateContainerComponent.ctorParameters = () => [
    { type: BaseHttpService$2 },
    { type: SpinnerService },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: GenerateFormService }
];
__decorate([
    Input()
], PayConfigBulkUpdateContainerComponent.prototype, "baseUrl", void 0);
__decorate([
    Input()
], PayConfigBulkUpdateContainerComponent.prototype, "selectedAccounts", void 0);
__decorate([
    Input()
], PayConfigBulkUpdateContainerComponent.prototype, "translate", void 0);
__decorate([
    Output()
], PayConfigBulkUpdateContainerComponent.prototype, "closeDialog", void 0);
__decorate([
    Output()
], PayConfigBulkUpdateContainerComponent.prototype, "saveDialog", void 0);
__decorate([
    Output()
], PayConfigBulkUpdateContainerComponent.prototype, "updatePrintOptions", void 0);
PayConfigBulkUpdateContainerComponent = __decorate([
    Component({
        selector: 'lib-pay-config-bulk-update-container',
        template: ` <lib-pay-config-bulk-update
    [form]="form"
    (closeDialog)="closeDialog.emit()"
    (saveDialog)="saveDialog.emit($event)"
  ></lib-pay-config-bulk-update>`
    })
], PayConfigBulkUpdateContainerComponent);

let AccountingConfigurationModule = class AccountingConfigurationModule {
};
AccountingConfigurationModule = __decorate([
    NgModule({
        declarations: [
            AccountingConfigurationComponent,
            ReceivableComponent,
            PayableComponent,
            ReceivableEditFormComponent,
            ReceivableViewFormComponent,
            ViewFormComponent,
            EditFormComponent,
            AccountingReceivableBulkUpdateComponent,
            AccountingReceivableBulkUpdateContainerComponent,
            AccountingPayableBulkUpdateComponent,
            AccountingPayableBulkUpdateContainerComponent,
            PayConfigurationComponent,
            PayConfigBulkUpdateComponent,
            PayConfigBulkUpdateContainerComponent,
        ],
        imports: [
            CommonModule,
            DialogModule$1,
            RouterModule,
            TabMenuModule,
            SearchContainerLoaderModule,
            TranslocoModule,
            UtilsModule,
            PerFormPrimengModule,
            ButtonModule$2,
            ProgressSpinnerModule$2,
            LuiWizardModule,
            LuiWidgetWrapperModule,
            LuiWizardV3Module,
        ],
    })
], AccountingConfigurationModule);

let MarketplaceControlViewComponent = class MarketplaceControlViewComponent {
    constructor(formBuilder, transloco, toast, spinner, confirmationService, accountControlService) {
        this.formBuilder = formBuilder;
        this.transloco = transloco;
        this.toast = toast;
        this.spinner = spinner;
        this.confirmationService = confirmationService;
        this.accountControlService = accountControlService;
        this.uploadImageUrl = '';
        this.imageSource = '';
        this.update = new EventEmitter();
        this.marketplaceImgName = '';
        this.welcomeMessage = {
            welcomeMessage: () => this.transloco.translate('VALIDATION_MESSAGE.WELCOME_MESSAGE'),
        };
        this.welcomeNews = {
            welcomeNews: () => this.transloco.translate('VALIDATION_MESSAGE.WELCOME_NEWS'),
        };
        this.imagePresent = false;
        this.subscriptions = [];
    }
    set accountMessageSetter(accountMessage) {
        this.set(accountMessage);
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    handleUpload(event) {
        var _a;
        const image = (_a = event === null || event === void 0 ? void 0 : event.originalEvent) === null || _a === void 0 ? void 0 : _a.body[0];
        this.newImage = image;
        this.marketplaceImgName = image.fileName;
        this.marketplaceImgAccountAssetKey = image.id;
        if (this.imagePresent) {
            this.showImage(event.files[0]);
        }
        this.turnOffSpinner();
    }
    handleError() {
        if (this.marketplaceImgName.length < 1) {
            this.imagePresent = false;
        }
        this.turnOffSpinner();
        this.toast.errorNotify(this.transloco.translate('COMPANY.COMPANY_LOGO_UPDATE_FAILURE'));
    }
    handleSelect(event) {
        this.spinner.on();
        try {
            const file = event.files[0];
            if (this.validExtension(file) && this.validFileSize(file)) {
                this.imagePresent = true;
            }
        }
        catch (_a) {
            this.turnOffSpinner();
            this.toast.errorNotify(this.transloco.translate('ADMINISTRATION.INVALID_FORMAT_MSG'));
        }
    }
    showImage(file) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (_) => {
            this.imageSource = `${reader.result}`;
        };
        this.marketplaceImgName = file.name;
    }
    save() {
        try {
            this.update.emit(this.getLatest());
        }
        catch (_a) {
            this.update.emit(this.getDefault());
        }
    }
    validateWelcomeMessage() {
        return (control) => {
            try {
                const welcomeMessage = new DOMParser().parseFromString(control.value.toString(), 'text/html');
                return (welcomeMessage.body.textContent || '').trim().length < 101
                    ? null
                    : {
                        invalidWelcomeMessage: true,
                    };
            }
            catch (_a) {
                return null;
            }
        };
    }
    validateMarketplaceNews() {
        return (control) => {
            try {
                const marketplaceNews = new DOMParser().parseFromString(control.value.toString(), 'text/html');
                return (marketplaceNews.body.textContent || '').trim().length < 1001
                    ? null
                    : {
                        invalidWelcomeNews: true,
                    };
            }
            catch (_a) {
                return null;
            }
        };
    }
    initializeForm(accountMessage) {
        var _a, _b, _c;
        this.form = this.formBuilder.group({
            welcomeMessage: [
                (_a = accountMessage === null || accountMessage === void 0 ? void 0 : accountMessage.accountControl) === null || _a === void 0 ? void 0 : _a.welcomeMessage,
                [this.validateWelcomeMessage()],
            ],
            welcomeNews: [
                (_b = accountMessage === null || accountMessage === void 0 ? void 0 : accountMessage.accountControl) === null || _b === void 0 ? void 0 : _b.welcomeNews,
                [this.validateMarketplaceNews()],
            ],
            imgAccountAssetKey: [(_c = accountMessage === null || accountMessage === void 0 ? void 0 : accountMessage.accountControl) === null || _c === void 0 ? void 0 : _c.imgAccountAssetKey],
        });
    }
    validExtension(file) {
        const extension = file.type.split('/').pop().toLocaleLowerCase();
        const extensions = ['jpg', 'png', 'jpeg'];
        if (!extensions.includes(extension)) {
            this.toast.errorNotify(this.transloco.translate('ADMINISTRATION.INVALID_FORMAT_MSG'));
            this.turnOffSpinner();
            return false;
        }
        return true;
    }
    validFileSize(file) {
        if (file.size > 5000000) {
            this.toast.errorNotify(this.transloco.translate('ADMINISTRATION.IMAGE_UPLOAD_MAX_SIZE'));
            this.turnOffSpinner();
            return false;
        }
        return true;
    }
    turnOffSpinner() {
        this.spinner.off();
    }
    getLatest() {
        var _a, _b, _c, _d;
        return Object.assign(Object.assign({}, this.form.value), { accountKey: (_b = (_a = this.accountMessage) === null || _a === void 0 ? void 0 : _a.accountControl) === null || _b === void 0 ? void 0 : _b.accountKey, accountControlKey: (_d = (_c = this.accountMessage) === null || _c === void 0 ? void 0 : _c.accountControl) === null || _d === void 0 ? void 0 : _d.accountControlKey, welcomeMessage: this.ensureDefaultValue('welcomeMessage'), welcomeNews: this.ensureDefaultValue('welcomeNews'), imgAccountAssetKey: this.newImage.id });
    }
    ensureDefaultValue(controlName) {
        return (new DOMParser()
            .parseFromString(this.form.get(controlName).value, 'text/html')
            .body.textContent.trim() || '').length < 1
            ? null
            : this.form.get(controlName).value;
    }
    getDefault() {
        var _a, _b, _c, _d;
        return Object.assign(Object.assign({}, this.form.value), { accountKey: (_b = (_a = this.accountMessage) === null || _a === void 0 ? void 0 : _a.accountControl) === null || _b === void 0 ? void 0 : _b.accountKey, accountControlKey: (_d = (_c = this.accountMessage) === null || _c === void 0 ? void 0 : _c.accountControl) === null || _d === void 0 ? void 0 : _d.accountControlKey, welcomeMessage: this.ensureDefaultValue('welcomeMessage'), welcomeNews: this.ensureDefaultValue('welcomeNews') });
    }
    set(accountMessage) {
        var _a, _b;
        this.accountMessage = accountMessage || {};
        this.initializeForm(accountMessage || {});
        this.marketplaceImgAccountAssetKey = (_b = (_a = this.accountMessage) === null || _a === void 0 ? void 0 : _a.accountControl) === null || _b === void 0 ? void 0 : _b.imgAccountAssetKey;
        try {
            this.accountMessage.accountControl.imgAccountAssetKey > 0
                ? (this.imagePresent = true)
                : (this.imagePresent = false);
            this.marketplaceImgName = this.accountMessage.accountControl.fileName
                ? this.accountMessage.accountControl.fileName
                : '';
        }
        catch (_c) {
            this.imagePresent = false;
        }
    }
    confirmMarketplaceImgDelete() {
        var _a, _b;
        const accountControl = (_b = (_a = this.accountMessage) === null || _a === void 0 ? void 0 : _a.accountControl) === null || _b === void 0 ? void 0 : _b.accountControlKey;
        this.confirmationService.confirm({
            message: this.transloco.translate('PIM.DELETE_ASSET_CONFIRM'),
            header: this.transloco.translate('ADMINISTRATION.DELETE_DIALOG_HEADER'),
            icon: 'pi pi-info-circle',
            acceptLabel: this.transloco.translate('ACTIONS.YES'),
            rejectLabel: this.transloco.translate('ACTIONS.NO'),
            accept: () => {
                this.spinner.on();
                if (accountControl) {
                    this.deleteMarketplaceImageAllEntries(accountControl);
                }
                else {
                    this.deleteMarketplaceImage(this.marketplaceImgAccountAssetKey);
                }
            },
            reject: () => {
                /** empty block */
            },
        });
    }
    deleteMarketplaceImageAllEntries(accountControl) {
        this.subscriptions.push(this.accountControlService
            .deleteMarketplaceAssetKey(accountControl, this.buildRequest())
            .pipe(tap((res) => {
            this.newImage = { fileName: '', id: null };
            this.imageSource = '';
            this.marketplaceImgName = '';
            this.imagePresent = false;
            this.deleteMarketplaceImage(this.marketplaceImgAccountAssetKey);
            this.marketplaceImgAccountAssetKey = null;
        }), catchError(() => {
            this.toast.errorNotify(this.transloco.translate('MESSAGES.GENERIC_ERROR'));
            this.turnOffSpinner();
            return of();
        }))
            .subscribe());
    }
    deleteMarketplaceImage(accountAssetKey) {
        this.subscriptions.push(this.accountControlService
            .deleteMarketplaceImage(accountAssetKey)
            .subscribe((res) => {
            this.marketplaceImgAccountAssetKey = null;
            this.newImage = { fileName: '', id: null };
            this.imageSource = '';
            this.marketplaceImgName = '';
            this.imagePresent = false;
            this.toast.successNotify(this.transloco.translate('PIM.DELETE_SUCCESS'));
            this.turnOffSpinner();
        }, (error) => {
            this.toast.errorNotify(this.transloco.translate('MESSAGES.GENERIC_ERROR'));
            this.turnOffSpinner();
        }));
    }
    buildRequest() {
        try {
            return this.getLatest();
        }
        catch (_a) {
            return this.getDefault();
        }
    }
};
MarketplaceControlViewComponent.ctorParameters = () => [
    { type: FormBuilder },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: SpinnerService },
    { type: ConfirmationService$2 },
    { type: AccountControlService }
];
__decorate([
    Input('accountMessage')
], MarketplaceControlViewComponent.prototype, "accountMessageSetter", null);
__decorate([
    Input()
], MarketplaceControlViewComponent.prototype, "uploadImageUrl", void 0);
__decorate([
    Input()
], MarketplaceControlViewComponent.prototype, "imageSource", void 0);
__decorate([
    Output()
], MarketplaceControlViewComponent.prototype, "update", void 0);
MarketplaceControlViewComponent = __decorate([
    Component({
        selector: 'lib-marketplace-control-view',
        template: "<form\r\n  [formGroup]=\"form\"\r\n  class=\"vertical-flow\"\r\n  data-testid=\"marketplaceControlsForm\"\r\n>\r\n  <section>\r\n    <br />\r\n    <H4 class=\"no-margin-top no-margin-bottom\">{{\r\n      'ADMINISTRATION.WELCOME_MESSAGE' | transloco\r\n    }}</H4>\r\n  </section>\r\n\r\n  <p-editor\r\n    [style]=\"{ height: '320px' }\"\r\n    class=\"editor\"\r\n    id=\"welcomeMessage\"\r\n    formControlName=\"welcomeMessage\"\r\n    data-testid=\"welcomeMessageEditor\"\r\n  >\r\n    <p-header>\r\n      <span class=\"ql-formats ql-formats-textsize\">\r\n        <select class=\"ql-size\" data-testid=\"fontSizeSelect\">\r\n          <option value=\"small\">Small</option>\r\n          <option selected>Normal</option>\r\n          <option value=\"large\">Subheading</option>\r\n          <option value=\"huge\">Heading</option>\r\n        </select>\r\n      </span>\r\n      <span class=\"ql-formats\">\r\n        <select class=\"ql-font\" data-testid=\"fontSelect\"></select>\r\n      </span>\r\n      <span class=\"ql-formats\">\r\n        <button\r\n          class=\"ql-bold\"\r\n          aria-label=\"Bold\"\r\n          data-testid=\"boldButton\"\r\n        ></button>\r\n        <button\r\n          class=\"ql-italic\"\r\n          aria-label=\"Italic\"\r\n          data-testid=\"italicButton\"\r\n        ></button>\r\n        <button\r\n          class=\"ql-underline\"\r\n          aria-label=\"Underline\"\r\n          data-testid=\"underlineButton\"\r\n        ></button>\r\n      </span>\r\n      <span class=\"ql-formats\">\r\n        <select\r\n          title=\"Text Alignment\"\r\n          class=\"ql-align\"\r\n          data-testid=\"alignmentSelect\"\r\n        >\r\n          <option selected>Left</option>\r\n          <option value=\"center\" label=\"Center\"></option>\r\n          <option value=\"right\" label=\"Right\"></option>\r\n          <option value=\"justify\" label=\"Justify\"></option>\r\n        </select>\r\n      </span>\r\n      <span class=\"ql-formats\">\r\n        <button\r\n          aria-label=\"Link\"\r\n          class=\"ql-link\"\r\n          data-testid=\"linkButton\"\r\n        ></button>\r\n      </span>\r\n    </p-header>\r\n  </p-editor>\r\n  <span class=\"feedback\">\r\n    <lib-control-message\r\n      [control]=\"form.controls.welcomeMessage\"\r\n      [errorMsg]=\"welcomeMessage.welcomeMessage\"\r\n    ></lib-control-message>\r\n  </span>\r\n  <br />\r\n  <br />\r\n\r\n  <H4>{{ 'ADMINISTRATION.MARKETPLACE_IMAGE' | transloco }}</H4>\r\n  <div *ngIf=\"imagePresent; else logoMissing\" class=\"img-container header\">\r\n    <img\r\n      id=\"marketplaceImage\"\r\n      class=\"target\"\r\n      [src]=\"imageSource\"\r\n      data-testid=\"marketplaceImagePreview\"\r\n    />\r\n    <button\r\n      pButton\r\n      class=\"ds tertiary small control\"\r\n      type=\"button\"\r\n      (click)=\"confirmMarketplaceImgDelete()\"\r\n      data-testid=\"deleteMarketplaceImageButton\"\r\n    >\r\n      {{ 'ACTIONS.DELETE' | transloco }}\r\n    </button>\r\n  </div>\r\n  <div class=\"horizontal-flow space-between-100\">\r\n    <div>\r\n      <span>{{ marketplaceImgName }}</span>\r\n    </div>\r\n  </div>\r\n  <ng-template #logoMissing>\r\n    <span>\r\n      {{ 'ADMINISTRATION.CHOOSE_MARKETPLACE_IMAGE' | transloco }}<br />{{\r\n        'ADMINISTRATION.SUPPORTED_FILE_TYPES' | transloco\r\n      }}\r\n    </span>\r\n  </ng-template>\r\n  <p-fileUpload\r\n    id=\"imageUpload\"\r\n    chooseLabel=\"{{ 'ACTIONS.CHOOSE' | transloco }}\"\r\n    styleClass=\"ds primary image-upload\"\r\n    [url]=\"uploadImageUrl\"\r\n    mode=\"basic\"\r\n    accept=\".jpg,.png,.jpeg\"\r\n    maxFileSize=\"5000000\"\r\n    [auto]=\"true\"\r\n    (onError)=\"handleError()\"\r\n    (onSelect)=\"handleSelect($event)\"\r\n    (onUpload)=\"handleUpload($event)\"\r\n    withCredentials=\"true\"\r\n    data-testid=\"marketplaceImageUpload\"\r\n  >\r\n  </p-fileUpload>\r\n  <br />\r\n  <br />\r\n\r\n  <section>\r\n    <br />\r\n    <H4 class=\"no-margin-top no-margin-bottom\">{{\r\n      'ADMINISTRATION.MARKETPLACE_NEWS' | transloco\r\n    }}</H4>\r\n  </section>\r\n  <p-editor\r\n    [style]=\"{ height: '320px' }\"\r\n    class=\"editor\"\r\n    id=\"welcomeNews\"\r\n    formControlName=\"welcomeNews\"\r\n    data-testid=\"welcomeNewsEditor\"\r\n  >\r\n    <p-header>\r\n      <span class=\"ql-formats ql-formats-textsize\">\r\n        <select class=\"ql-size\" data-testid=\"fontSizeSelect\">\r\n          <option value=\"small\">Small</option>\r\n          <option selected>Normal</option>\r\n          <option value=\"large\">Subheading</option>\r\n          <option value=\"huge\">Heading</option>\r\n        </select>\r\n      </span>\r\n      <span class=\"ql-formats\">\r\n        <select class=\"ql-font\" data-testid=\"fontSelect\"></select>\r\n      </span>\r\n      <span class=\"ql-formats\">\r\n        <button\r\n          class=\"ql-bold\"\r\n          aria-label=\"Bold\"\r\n          data-testid=\"boldButton\"\r\n        ></button>\r\n        <button\r\n          class=\"ql-italic\"\r\n          aria-label=\"Italic\"\r\n          data-testid=\"italicButton\"\r\n        ></button>\r\n        <button\r\n          class=\"ql-underline\"\r\n          aria-label=\"Underline\"\r\n          data-testid=\"underlineButton\"\r\n        ></button>\r\n      </span>\r\n      <span class=\"ql-formats\">\r\n        <select\r\n          title=\"Text Alignment\"\r\n          class=\"ql-align\"\r\n          data-testid=\"alignmentSelect\"\r\n        >\r\n          <option selected>Left</option>\r\n          <option value=\"center\" label=\"Center\"></option>\r\n          <option value=\"right\" label=\"Right\"></option>\r\n          <option value=\"justify\" label=\"Justify\"></option>\r\n        </select>\r\n      </span>\r\n      <span class=\"ql-formats\">\r\n        <button\r\n          aria-label=\"Link\"\r\n          class=\"ql-link\"\r\n          data-testid=\"linkButton\"\r\n        ></button>\r\n      </span>\r\n    </p-header>\r\n  </p-editor>\r\n  <span class=\"feedback\">\r\n    <lib-control-message\r\n      [control]=\"form.controls.welcomeNews\"\r\n      [errorMsg]=\"welcomeNews.welcomeNews\"\r\n    ></lib-control-message>\r\n  </span>\r\n\r\n  <div class=\"space-between-025\">\r\n    <button\r\n      pButton\r\n      [disabled]=\"form.invalid\"\r\n      type=\"button\"\r\n      id=\"saveButton\"\r\n      label=\"{{ 'ACTIONS.SAVE' | transloco }}\"\r\n      (click)=\"save()\"\r\n      class=\"ds primary\"\r\n      data-testid=\"saveButton\"\r\n    ></button>\r\n  </div>\r\n</form>\r\n<p-confirmDialog [closeOnEscape]=\"false\" [closable]=\"false\"></p-confirmDialog>\r\n"
    })
], MarketplaceControlViewComponent);

let UserService$1 = class UserService {
    constructor(baseApiService, adminService) {
        this.baseApiService = baseApiService;
        this.adminService = adminService;
        this.selectedNodes = [];
    }
    searchUser(request) {
        this.baseApiService.set(this.adminService.getConfig().searchUserEndpoint);
        return this.baseApiService.post(request);
    }
    addUser(request) {
        this.baseApiService.set(this.adminService.getConfig().addUserEndpoint + '/v2');
        return this.baseApiService.post(request);
    }
    copyUser(request) {
        this.baseApiService.set(this.adminService.getConfig().copyUserEndpoint + '/v2');
        return this.baseApiService.post(request);
    }
    updateUser(request) {
        this.baseApiService.set(this.adminService.getConfig().updateUserEndpoint);
        return this.baseApiService.post(request);
    }
    updateUserPermissions(request, userKey) {
        this.baseApiService.set(urlJoin$1(this.adminService.getConfig().updateUserPermissionsEndpoint, userKey, '/permissions'));
        return this.baseApiService.post(request);
    }
    addUserPermissions(request) {
        this.baseApiService.set(urlJoin$1(this.adminService.getConfig().updateUserPermissionsEndpoint, '/permissions'));
        return this.baseApiService.post(request);
    }
    deleteUser(request) {
        this.baseApiService.set(this.adminService.getConfig().deleteUserEndpoint);
        return this.baseApiService.post(request);
    }
    exportUsers(request) {
        this.baseApiService.set(this.adminService.getConfig().exportUsersEndpoint);
        return this.baseApiService.post(request, {
            responseType: 'blob',
            observe: 'response',
        });
    }
    getPermissionsList(userKey) {
        this.baseApiService.set(urlJoin$1(this.adminService.getConfig().updateUserPermissionsEndpoint, userKey, '/permissions'));
        return this.baseApiService.get();
    }
    getLanguageTypes() {
        this.baseApiService.set(this.adminService.getConfig().languageTypesEndpoint);
        return this.baseApiService
            .get()
            .pipe(map((response) => response.languageTypes));
    }
    getTimeZoneTypes() {
        this.baseApiService.set(this.adminService.getConfig().timeZoneTypesEndpoint);
        return this.baseApiService
            .get()
            .pipe(map((response) => response.timeZoneTypeResponse));
    }
    getDateFormatTypes() {
        this.baseApiService.set(this.adminService.getConfig().dateFormatTypesEndpoint);
        return this.baseApiService
            .get()
            .pipe(map((response) => response.dateFormatTypeResponse));
    }
    getCountries() {
        this.baseApiService.set(`${this.adminService.getConfig().getConfigEndpoint}/country`);
        return this.baseApiService.get();
    }
    getAccount() {
        this.baseApiService.set(this.adminService.getConfig().getAccountEndpoint);
        return this.baseApiService.get().pipe(map((accountResponse) => {
            return Object.assign(Object.assign({}, accountResponse.account), { details: accountResponse.account.details[0] });
        }));
    }
    convertListToTree(permissions) {
        const permissionsAsNodes = permissions
            .filter((permission) => permission.toolKey !== 1)
            .map((permission) => ({
            label: permission.description,
            data: permission,
            children: [],
        }));
        const nodeMap = permissionsAsNodes.reduce(
        // tslint:disable-next-line: no-shadowed-variable
        (map, node) => {
            var _a;
            const toolKeyMap = (_a = map.get(node.data.marketplaceKey)) !== null && _a !== void 0 ? _a : map
                .set(node.data.marketplaceKey, new Map())
                .get(node.data.marketplaceKey);
            toolKeyMap.set(node.data.toolKey, node);
            return map;
        }, new Map());
        return permissionsAsNodes
            .reduce((tree, node) => {
            var _a;
            const { data } = node;
            // Attach to a parent node corresponding to toolKey_Parent or marketplaceKey_Parent
            // (toolKey of 0 is a root node)
            const parent = !data.toolKey
                ? { children: tree }
                : (_a = nodeMap.get(data.marketplaceKey).get(data.toolKey_Parent)) !== null && _a !== void 0 ? _a : tree.find(
                // tslint:disable-next-line: no-shadowed-variable
                (node) => node.data.marketplaceKey === data.marketplaceKey_Parent);
            parent === null || parent === void 0 ? void 0 : parent.children.push(node);
            return tree;
        }, [])
            .sort((a, b) => 
        // The purchased products node (marketplaceKey: -1) should always be last
        a.data.marketplaceKey === -1
            ? Number.POSITIVE_INFINITY
            : b.data.marketplaceKey === -1
                ? Number.NEGATIVE_INFINITY
                : a.label.localeCompare(b.label));
    }
    checkNodes(nodes, user) {
        this.selectedNodes = [];
        this.checkNodesHelper(nodes, user);
        return this.selectedNodes;
    }
    checkNodesHelper(nodes, user) {
        nodes.forEach((node) => {
            if (this.isNodeSelected(node, user)) {
                this.selectedNodes.push(node);
            }
            this.checkNodesHelper(node.children, user);
        });
    }
    isNodeSelected(currentNode, user) {
        return currentNode.data.selected; // user.permissions.includes(currentNode.data.toolKey);
    }
    getAllSelectedToolKeys(selectedNodes) {
        const finalToolKeyList = [];
        selectedNodes.map((node) => {
            finalToolKeyList.push(node.data.toolKey);
        });
        return finalToolKeyList.sort((a, b) => (a > b ? 1 : -1));
    }
};
UserService$1.ctorParameters = () => [
    { type: BaseAPIService },
    { type: AdministrationService }
];
UserService$1.ɵprov = ɵɵdefineInjectable({ factory: function UserService_Factory() { return new UserService$1(ɵɵinject(BaseAPIService), ɵɵinject(AdministrationService)); }, token: UserService$1, providedIn: "root" });
UserService$1 = __decorate([
    Injectable({
        providedIn: 'root',
    })
], UserService$1);

let UserDetailsV2Component = class UserDetailsV2Component {
    constructor(route, formBuilder, loggerService, spinnerService, userService, router, translocoService, validationService, toastSrv, store) {
        this.route = route;
        this.formBuilder = formBuilder;
        this.loggerService = loggerService;
        this.spinnerService = spinnerService;
        this.userService = userService;
        this.router = router;
        this.translocoService = translocoService;
        this.validationService = validationService;
        this.toastSrv = toastSrv;
        this.store = store;
        this.title = '';
        this.activatePagePermissions = false;
        this.activateUserInformation = true;
        this.allPermissions = [];
        this.selectedPermissions = [];
        this.languageTypes = [];
        this.timeZoneTypes = [];
        this.dateFormatTypes = [];
        this.countries = [];
        this.subscriptions = [];
        this.showUpdatePassword = false;
        this.passwordEmpty = true;
        this.userInfoButtonLabel = '';
        this.extension = {
            extension: () => this.translocoService.translate('VALIDATION_MESSAGE.PHONE_EXTENSION'),
        };
        this.message = {
            confirmPassword: () => this.translocoService.translate('COMMON.PASSWORD_MUST_MATCH'),
        };
        this.userForm = this.formBuilder.group({
            FirstName: ['', [Validators.required]],
            LastName: ['', [Validators.required]],
            Username: ['', [Validators.required, Validators.email]],
            Password: [
                '',
                Validators.compose([
                    this.validationService.patternValidator('number'),
                    this.validationService.patternValidator('upperCase'),
                    this.validationService.patternValidator('lowerCase'),
                    this.validationService.specialCharacterValidator(),
                    this.validationService.minimumLength(8),
                ]),
            ],
            ConfirmPassword: [''],
            Language: ['', [Validators.required]],
            TimeZone: ['', [Validators.required]],
            DateFormat: ['', [Validators.required]],
        }, {
            validator: this.validationService.MustMatch('Password', 'ConfirmPassword'),
        });
        this.phoneForm = this.formBuilder.group({
            PhoneCountry: [''],
            PhoneExtension: [
                '',
                Validators.compose([
                    Validators.pattern('^[0-9]*$'),
                    Validators.maxLength(10),
                ]),
            ],
            Phone: [
                '',
                Validators.compose([
                    Validators.required,
                    this.validatePhoneNumber(parsePhoneNumber),
                ]),
            ],
        }, {
            validators: this.validatePhoneForm('Phone', 'PhoneExtension'),
        });
        this.permissionsForm = this.formBuilder.group({});
        this.getToolKeys = () => Array.from(new Set(this.userService.getAllSelectedToolKeys(this.selectedPermissions))
        // tslint:disable-next-line: semicolon
        ).toString();
    }
    ngOnInit() {
        this.activatePagePermissions = false;
        this.activateUserInformation = true;
        this.spinnerService.on();
        if (this.route.snapshot.url[0].path === 'update') {
            this.subscriptions.push(this.getUpdateSubscription());
            this.getUserInfoButtonLabel();
            this.isUpdating = true;
            this.userForm.controls.Password.enable();
            this.userForm.controls.ConfirmPassword.enable();
            this.userForm.controls.Language.enable();
            this.userForm.controls.TimeZone.enable();
            this.userForm.controls.DateFormat.enable();
            this.phoneForm.enable();
            this.subscriptions.push(this.translocoService
                .selectTranslate('ADMINISTRATION.UPDATE_USER_PAGE_TITLE')
                .pipe(first(), tap((title) => (this.title = title)))
                .subscribe());
        }
        else {
            if (this.route.snapshot.url[0].path === 'copy') {
                this.subscriptions.push(this.getCopySubscription());
            }
            else {
                this.subscriptions.push(this.getToolPermissions()
                    .pipe(finalize(() => this.spinnerService.off()))
                    .subscribe((permissions) => {
                    this.allPermissions = permissions;
                }));
            }
            this.isUpdating = false;
            this.getUserInfoButtonLabel(false);
            this.userForm.controls.Password.disable();
            this.userForm.controls.ConfirmPassword.disable();
            this.userForm.controls.Language.disable();
            this.userForm.controls.TimeZone.disable();
            this.userForm.controls.DateFormat.disable();
            this.phoneForm.disable();
            this.subscriptions.push(this.translocoService
                .selectTranslate('ADMINISTRATION.ADD_USER_PAGE_TITLE')
                .pipe(first(), tap((title) => (this.title = title)))
                .subscribe());
        }
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    getUpdateSubscription() {
        return forkJoin([
            this.getUser(),
            this.getToolPermissions(),
            this.getLanguageTypes(),
            this.getTimeZoneTypes(),
            this.getDateFormatTypes(),
            this.getCountries(),
            this.getAccount(),
        ])
            .pipe(finalize(() => this.spinnerService.off()))
            .subscribe(([user, permissions, languages, timeZones, dateFormats, countries, account,]) => {
            var _a;
            this.user = user;
            this.allPermissions = permissions;
            this.languageTypes = languages;
            this.timeZoneTypes = timeZones;
            this.dateFormatTypes = dateFormats;
            this.countries = countries;
            this.defaultCountryCode = (_a = account === null || account === void 0 ? void 0 : account.details) === null || _a === void 0 ? void 0 : _a.country;
            this.selectedPermissions = this.userService.checkNodes(this.allPermissions, this.user);
            this.prefillForm();
        });
    }
    getCopySubscription() {
        return forkJoin([this.getUser(), this.getToolPermissions()])
            .pipe(finalize(() => this.spinnerService.off()))
            .subscribe(([user, permissions]) => {
            this.user = user;
            this.allPermissions = permissions;
            this.selectedPermissions = this.userService.checkNodes(this.allPermissions, this.user);
        });
    }
    getLanguageTypes() {
        return this.userService.getLanguageTypes().pipe(map((lt) => lt.map(({ languageCode, languageDescription }) => ({
            label: languageDescription,
            value: languageCode,
        }))));
    }
    getTimeZoneTypes() {
        return this.userService.getTimeZoneTypes().pipe(map((tz) => tz.map(({ timeZoneCode, timeZoneDescription }) => ({
            label: timeZoneDescription,
            value: timeZoneCode,
        }))));
    }
    getDateFormatTypes() {
        return this.userService.getDateFormatTypes().pipe(map((df) => df.map(({ dateTypeKey, description }) => ({
            label: description,
            value: dateTypeKey,
        }))));
    }
    getCountries() {
        // update
        return this.userService.getCountries().pipe(map((countries) => countries === null || countries === void 0 ? void 0 : countries.map((country) => {
            return {
                label: `${country === null || country === void 0 ? void 0 : country.countryName} (${alpha3ToAlpha2(country === null || country === void 0 ? void 0 : country.countryCode)})`,
                value: alpha3ToAlpha2(country === null || country === void 0 ? void 0 : country.countryCode),
            };
        })));
    }
    getToolPermissions() {
        const userKey = this.route.snapshot.queryParams['id'];
        return this.userService
            .getPermissionsList(userKey)
            .pipe(map(({ records }) => this.userService.convertListToTree(records)));
    }
    getAccount() {
        return this.userService.getAccount();
    }
    getUser() {
        return this.route.queryParams
            .pipe(first(), switchMap((params) => this.userService.searchUser({ id: parseInt(params.id, 10) })))
            .pipe(map((res) => res.userDetails));
    }
    prefillForm() {
        try {
            // update
            this.phoneForm.controls.PhoneExtension.setValue(this.user.phoneExtension);
            this.phoneForm.controls.PhoneCountry.setValue(alpha3ToAlpha2(this.user.phoneCountry));
            this.phoneForm.controls.Phone.setValue(parsePhoneNumber(this.user.phone, alpha3ToAlpha2(this.user.phoneCountry)).formatInternational());
        }
        catch (_a) {
            this.phoneForm.controls.PhoneCountry.setValue(alpha3ToAlpha2(this.defaultCountryCode || 'CAN'));
            this.phoneForm.controls.Phone.setValue('');
            this.phoneForm.controls.PhoneExtension.setValue('');
        }
        this.userForm.controls.FirstName.setValue(this.user.firstName);
        this.userForm.controls.LastName.setValue(this.user.lastName);
        this.userForm.controls.Username.setValue(this.user.username);
        this.userForm.controls.Language.setValue(this.user.languageCode);
        this.userForm.controls.TimeZone.setValue(this.user.timeZoneCode);
        this.userForm.controls.DateFormat.setValue(this.user.dateTypeKey);
    }
    submit() {
        this.activatePagePermissions = true;
        this.activateUserInformation = false;
    }
    save() {
        if (this.isUpdating) {
            this.updateUser();
        }
        else {
            this.addUser();
        }
    }
    buildV2PermissionPayload(tree, selected = {}) {
        tree.map(({ children, data }) => {
            selected[data.marketplaceKey] = [
                ...(selected[data.marketplaceKey] || []),
                data.toolKey,
            ];
        });
        return selected;
    }
    updateUser() {
        this.spinnerService.on();
        this.subscriptions.push(this.userService
            .updateUser(this.buildUpdateRequest())
            .pipe(concatMap(() => this.userService.updateUserPermissions(this.buildV2PermissionPayload(this.selectedPermissions), this.user.userKey.toString())), finalize(() => this.spinnerService.off()))
            .subscribe((response) => {
            this.loggerService.info('UpdateUserResponse', 'UpdateuserService.updateUser', JSON.stringify(response));
            if (response.errorCode === 0) {
                this.store.dispatch(actions.updateUser());
                this.toastSrv.successNotify(this.translocoService.translate('ADMINISTRATION.UPDATE_USER_SUCCESS'), null, 5000);
                this.router.navigate(['/AdministrationModule/user']);
            }
        }, (error) => {
            this.toastSrv.errorNotify(this.translocoService.translate('ADMINISTRATION.UPDATE_USER_FAILURE'));
            this.loggerService.error('UpdateUserResponse', 'UpdateusersService.updateUser', JSON.stringify(error));
        }));
    }
    addUser() {
        let userKey = 0;
        this.spinnerService.on();
        this.subscriptions.push((this.route.snapshot.url[0].path === 'copy'
            ? this.userService.copyUser(this.buildCopyRequest())
            : this.userService.addUser(this.buildAddRequest()))
            .pipe(tap((response) => {
            userKey = response.userKey;
        }), concatMap((response) => this.userService.updateUserPermissions(this.buildV2PermissionPayload(this.selectedPermissions), userKey.toString())), finalize(() => this.spinnerService.off()))
            .subscribe((response) => {
            this.loggerService.info('AddUserResponse', 'AdduserService.addUser', JSON.stringify(response));
            if (response.errorCode === 0) {
                this.toastSrv.successNotify(this.translocoService.translate('ADMINISTRATION.ADD_USER_SUCCESS'), null, 5000);
                this.router.navigate(['/AdministrationModule/user']);
            }
        }, (error) => {
            if (error.error != null && error.error.errorCode === 3) {
                this.toastSrv.warnNotify(this.translocoService.translate('ADMINISTRATION.USER_ALREADY_EXIST'), null, 5000);
            }
            else if (error.error != null && error.error.errorCode) {
                this.toastSrv.warnNotify(this.translocoService.translate('COMMON.UNKNOWN_ERROR'), null, 5000);
            }
            else {
                this.toastSrv.errorNotify(this.translocoService.translate('ADMINISTRATION.ADD_USER_FAILURE'), null, 5000);
            }
            this.loggerService.error('AddUserResponse', 'AddusersService.addUser', JSON.stringify(error));
        }));
    }
    updateUserPermissions() {
        this.spinnerService.on();
        this.subscriptions.push(this.userService
            .updateUserPermissions(this.buildUpdatePermissionsRequest(), this.user.userKey.toString())
            .pipe(finalize(() => this.spinnerService.off()))
            .subscribe((response) => {
            this.loggerService.info('UpdateUserResponse', 'UpdateuserService.updateUser', JSON.stringify(response));
            if (response.errorCode === 0) {
                this.store.dispatch(actions.updateUser());
                this.toastSrv.successNotify(this.translocoService.translate('ADMINISTRATION.UPDATE_USER_SUCCESS'), null, 5000);
                this.router.navigate(['/AdministrationModule/user']);
            }
        }, (error) => {
            this.toastSrv.errorNotify(this.translocoService.translate('ADMINISTRATION.UPDATE_USER_FAILURE'));
            this.loggerService.error('UpdateUserResponse', 'UpdateusersService.updateUser', JSON.stringify(error));
        }));
    }
    buildUpdateRequest() {
        let phoneCountry;
        let phone;
        let phoneExtension;
        try {
            phoneCountry = alpha2ToAlpha3(this.phoneForm.controls.PhoneCountry.value);
            phoneExtension = this.phoneForm.value.PhoneExtension;
            phone = parsePhoneNumber(this.phoneForm.controls.Phone.value, alpha3ToAlpha2(this.phoneForm.controls.PhoneCountry.value)).format('E.164');
        }
        catch (_a) {
            phoneCountry = this.defaultCountryCode || 'CAN';
            phone = '';
            phoneExtension = '';
        }
        return {
            userKey: this.user.userKey,
            username: this.userForm.value.Username,
            fullName: this.userForm.value.FirstName + ' ' + this.userForm.value.LastName,
            firstName: this.userForm.value.FirstName,
            lastName: this.userForm.value.LastName,
            password: this.showUpdatePassword
                ? this.userForm.value.Password
                : undefined,
            toolPermissions: Array().toString(),
            timeZoneCode: this.userForm.value.TimeZone,
            dateType: this.userForm.value.DateFormat,
            languageCode: this.userForm.value.Language,
            phoneCountry,
            phone,
            phoneExtension,
            isTermsSigned: this.user.isTermsSigned,
        };
    }
    buildAddRequest() {
        return {
            fullname: this.userForm.value.FirstName + ' ' + this.userForm.value.LastName,
            username: this.userForm.value.Username,
            firstName: this.userForm.value.FirstName,
            lastName: this.userForm.value.LastName,
            toolPermissions: Array().toString(),
        };
    }
    buildCopyRequest() {
        return this.buildAddRequest();
    }
    buildUpdatePermissionsRequest() {
        return {
            userKey: this.user.userKey,
            toolPermissions: this.getToolKeys(),
        };
    }
    //#endregion
    /*Handling Password Checkbox  Click */
    handleUpdatePassword(status) {
        if (status.checked) {
            this.showUpdatePassword = true;
            this.userForm.controls.Password.enable();
            this.userForm.controls.ConfirmPassword.enable();
        }
        else {
            this.showUpdatePassword = false;
            this.userForm.controls.Password.disable();
            this.userForm.controls.ConfirmPassword.disable();
        }
    }
    /** Function to check whether password field is empty or not  */
    passwordFieldEmptyCheck(passwordStatus) {
        this.passwordEmpty = !passwordStatus;
    }
    // bound to Phone control's input event
    formatPhoneNumber() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        try {
            if (((_d = (_c = (_b = (_a = this.phoneForm) === null || _a === void 0 ? void 0 : _a.controls) === null || _b === void 0 ? void 0 : _b.Phone) === null || _c === void 0 ? void 0 : _c.value) === null || _d === void 0 ? void 0 : _d.length) < 1) {
                this.phoneForm.controls.PhoneCountry.setValue(alpha3ToAlpha2(this.defaultCountryCode || 'CAN'));
            }
            (_g = (_f = (_e = this.phoneForm) === null || _e === void 0 ? void 0 : _e.controls) === null || _f === void 0 ? void 0 : _f.Phone) === null || _g === void 0 ? void 0 : _g.setValue(parsePhoneNumber(this.phoneForm.controls.Phone.value, (_j = (_h = this.phoneForm.controls) === null || _h === void 0 ? void 0 : _h.PhoneCountry) === null || _j === void 0 ? void 0 : _j.value).formatInternational());
        }
        catch (_k) {
            /*empty*/
        }
    }
    resetPhoneNumber() {
        var _a, _b, _c;
        (_c = (_b = (_a = this.phoneForm) === null || _a === void 0 ? void 0 : _a.controls) === null || _b === void 0 ? void 0 : _b.Phone) === null || _c === void 0 ? void 0 : _c.setValue('');
    }
    getUserInfoButtonLabel(update = true) {
        this.translocoService
            .selectTranslate(update ? 'ACTIONS.SAVE' : 'ACTIONS.SUBMIT')
            .pipe(first(), tap((label) => (this.userInfoButtonLabel = label)))
            .subscribe();
    }
    validatePhoneForm(phoneNumberControlName, ExtensionControlName) {
        return (formGroup) => {
            try {
                const phoneNumberControl = formGroup.controls[phoneNumberControlName];
                const extensionControl = formGroup.controls[ExtensionControlName];
                return extensionControl &&
                    extensionControl.value &&
                    extensionControl.value.length > 0 &&
                    phoneNumberControl.value.length === 0
                    ? { invalidPhoneNumber: true }
                    : null;
            }
            catch (error) {
                return error;
            }
        };
    }
    validatePhoneNumber(parser) {
        return (control) => {
            var _a, _b, _c, _d;
            try {
                const phoneNumber = parser(control.value.toString());
                return (phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.isValid()) &&
                    isValidNumberForRegion(control.value.toString(), (_c = (_b = (_a = this.phoneForm) === null || _a === void 0 ? void 0 : _a.controls) === null || _b === void 0 ? void 0 : _b.PhoneCountry) === null || _c === void 0 ? void 0 : _c.value)
                    ? null
                    : {
                        invalidPhoneNumber: true,
                    };
            }
            catch (_e) {
                return ((_d = control === null || control === void 0 ? void 0 : control.value) === null || _d === void 0 ? void 0 : _d.length) < 1
                    ? null
                    : {
                        invalidPhoneNumber: true,
                    };
            }
        };
    }
};
UserDetailsV2Component.ctorParameters = () => [
    { type: ActivatedRoute },
    { type: FormBuilder },
    { type: LoggerService },
    { type: SpinnerService },
    { type: UserService$1 },
    { type: Router },
    { type: TranslocoService },
    { type: ValidationService },
    { type: ToastrNotificationService },
    { type: Store }
];
UserDetailsV2Component = __decorate([
    Component({
        selector: 'lib-user-details-v2',
        template: "<div class=\"administration-form-container\">\r\n  <div class=\"vertical-flow\">\r\n    <h2>{{ title }}</h2>\r\n    <p-tabView class=\"width-100\" data-testid=\"updateUserTabs\">\r\n      <p-tabPanel\r\n        header=\"{{ 'ADMINISTRATION.USER_INFORMATION_TAB' | transloco }}\"\r\n        [selected]=\"activateUserInformation\"\r\n        data-testid=\"userInformationTab\"\r\n      >\r\n        <form [formGroup]=\"userForm\" class=\"vertical-flow\">\r\n          <div class=\"vertical-flow space-between-025 space-before-025\">\r\n            <label for=\"FirstName\">{{\r\n              'ADMINISTRATION.FIRSTNAME' | transloco\r\n            }}</label>\r\n            <div>\r\n              <input\r\n                pInputText\r\n                id=\"FirstName\"\r\n                type=\"text\"\r\n                placeholder=\"{{ 'ADMINISTRATION.FIRSTNAME' | transloco }}\"\r\n                formControlName=\"FirstName\"\r\n                data-testid=\"firstNameInput\"\r\n              />\r\n            </div>\r\n            <span class=\"feedback\">\r\n              <lib-control-message\r\n                [control]=\"userForm.get('FirstName')\"\r\n                data-testid=\"firstNameFeedback\"\r\n              ></lib-control-message\r\n            ></span>\r\n          </div>\r\n          <div class=\"vertical-flow space-between-025\">\r\n            <label for=\"LastName\">{{\r\n              'ADMINISTRATION.LASTNAME' | transloco\r\n            }}</label>\r\n            <div>\r\n              <input\r\n                pInputText\r\n                id=\"LastName\"\r\n                type=\"text\"\r\n                placeholder=\"{{ 'ADMINISTRATION.LASTNAME' | transloco }}\"\r\n                formControlName=\"LastName\"\r\n                data-testid=\"lastNameInput\"\r\n              />\r\n            </div>\r\n            <span class=\"feedback\">\r\n              <lib-control-message\r\n                [control]=\"userForm.get('LastName')\"\r\n                data-testid=\"lastNameFeedback\"\r\n              ></lib-control-message\r\n            ></span>\r\n          </div>\r\n          <div class=\"vertical-flow space-between-025\">\r\n            <label for=\"Username\">{{\r\n              'ADMINISTRATION.USERNAME' | transloco\r\n            }}</label>\r\n            <div>\r\n              <input\r\n                pInputText\r\n                id=\"Username\"\r\n                type=\"text\"\r\n                placeholder=\"{{ 'ADMINISTRATION.USERNAME' | transloco }}\"\r\n                formControlName=\"Username\"\r\n                data-testid=\"usernameInput\"\r\n              />\r\n            </div>\r\n            <span class=\"feedback\">\r\n              <lib-control-message\r\n                [control]=\"userForm.get('Username')\"\r\n                data-testid=\"usernameFeedback\"\r\n              ></lib-control-message\r\n            ></span>\r\n          </div>\r\n          <ng-container *ngIf=\"isUpdating\">\r\n            <div\r\n              class=\"vertical-flow\"\r\n              [ngClass]=\"\r\n                passwordEmpty ? 'space-between-050' : 'space-between-025'\r\n              \"\r\n            >\r\n              <div>\r\n                <p-checkbox\r\n                  id=\"showPassword\"\r\n                  label=\"{{ 'COMMON.UPDATE_PASSWORD' | transloco }}\"\r\n                  (onChange)=\"handleUpdatePassword($event)\"\r\n                  data-testid=\"showPasswordCheckbox\"\r\n                >\r\n                </p-checkbox>\r\n              </div>\r\n              <div\r\n                class=\"vertical-flow space-between-025\"\r\n                *ngIf=\"showUpdatePassword\"\r\n              >\r\n                <label for=\"Password\">\r\n                  {{ 'ADMINISTRATION.PASSWORD' | transloco }}</label\r\n                >\r\n                <div class=\"strongPasswordHint\">\r\n                  {{ 'COMMON.STRONG_PASSWORD_MESSAGE' | transloco }}\r\n                </div>\r\n\r\n                <input\r\n                  [feedback]=\"false\"\r\n                  pPassword\r\n                  id=\"Password\"\r\n                  type=\"password\"\r\n                  placeholder=\"{{ 'ADMINISTRATION.PASSWORD' | transloco }}\"\r\n                  formControlName=\"Password\"\r\n                  data-testid=\"passwordInput\"\r\n                />\r\n                <div class=\"vertical-flow space-between-050\">\r\n                  <span class=\"password-feedback\">\r\n                    <lib-password-validation\r\n                      [passwordToCheck]=\"userForm.value.Password\"\r\n                      (hasPassword)=\"passwordFieldEmptyCheck($event)\"\r\n                      data-testid=\"passwordFeedback\"\r\n                    >\r\n                    </lib-password-validation>\r\n                  </span>\r\n                  <label\r\n                    for=\"ConfirmPassword\"\r\n                    [ngClass]=\"passwordEmpty ? 'space-before-075' : 'no-margin'\"\r\n                    >{{ 'ADMINISTRATION.CONFIRM_PASSWORD' | transloco }}</label\r\n                  >\r\n                </div>\r\n                <input\r\n                  [feedback]=\"false\"\r\n                  pPassword\r\n                  id=\"ConfirmPassword\"\r\n                  type=\"password\"\r\n                  placeholder=\"{{\r\n                    'ADMINISTRATION.CONFIRM_PASSWORD' | transloco\r\n                  }}\"\r\n                  formControlName=\"ConfirmPassword\"\r\n                  data-testid=\"confirmPasswordInput\"\r\n                />\r\n                <span class=\"feedback\">\r\n                  <lib-control-message\r\n                    id=\"message\"\r\n                    [control]=\"userForm.get('ConfirmPassword')\"\r\n                    [errorMsg]=\"message.confirmPassword\"\r\n                    data-testid=\"confirmPasswordFeedback\"\r\n                  >\r\n                  </lib-control-message\r\n                ></span>\r\n              </div>\r\n\r\n              <div\r\n                [formGroup]=\"phoneForm\"\r\n                class=\"vertical-flow space-between-025 space-before-200\"\r\n              >\r\n                <label>\r\n                  {{ 'ADMINISTRATION.PHONE' | transloco }}\r\n                </label>\r\n\r\n                <p-dropdown\r\n                  [options]=\"countries\"\r\n                  (onChange)=\"resetPhoneNumber()\"\r\n                  styleClass=\"width-100 height-46\"\r\n                  formControlName=\"PhoneCountry\"\r\n                  filter=\"true\"\r\n                  placeholder=\"{{ 'ACTIONS.SELECT' | transloco }}\"\r\n                  data-testid=\"countryDropdown\"\r\n                >\r\n                </p-dropdown>\r\n\r\n                <input\r\n                  pInputText\r\n                  id=\"Phone\"\r\n                  type=\"text\"\r\n                  (input)=\"formatPhoneNumber()\"\r\n                  placeholder=\"{{ 'COMMON.PHONE_NUMBER' | transloco }}\"\r\n                  formControlName=\"Phone\"\r\n                  class=\"space-before-200\"\r\n                  data-testid=\"phoneInput\"\r\n                />\r\n                <span class=\"feedback\">\r\n                  <lib-control-message\r\n                    [control]=\"phoneForm?.get('Phone')\"\r\n                    data-testid=\"phoneFeedback\"\r\n                  ></lib-control-message>\r\n                </span>\r\n                <input\r\n                  pInputText\r\n                  id=\"PhoneExtension\"\r\n                  type=\"text\"\r\n                  placeholder=\"{{ 'COMMON.PHONE_EXTENSION' | transloco }}\"\r\n                  formControlName=\"PhoneExtension\"\r\n                  data-testid=\"phoneExtensionInput\"\r\n                />\r\n                <span class=\"feedback\">\r\n                  <lib-control-message\r\n                    [control]=\"phoneForm?.get('PhoneExtension')\"\r\n                    [errorMsg]=\"extension.extension\"\r\n                    data-testid=\"phoneExtensionFeedback\"\r\n                  ></lib-control-message>\r\n                  <lib-control-message\r\n                    [control]=\"phoneForm\"\r\n                    data-testid=\"phoneFormFeedback\"\r\n                  ></lib-control-message>\r\n                </span>\r\n              </div>\r\n            </div>\r\n            <div class=\"vertical-flow space-between-025\">\r\n              <label for=\"Language\" class=\"space-before-075\">{{\r\n                'ADMINISTRATION.LANGUAGE' | transloco\r\n              }}</label>\r\n              <div>\r\n                <p-dropdown\r\n                  [options]=\"languageTypes\"\r\n                  id=\"Language\"\r\n                  formControlName=\"Language\"\r\n                  filter=\"true\"\r\n                  placeholder=\"{{\r\n                    'ADMINISTRATION.SELECT_LANGUAGE' | transloco\r\n                  }}\"\r\n                  data-testid=\"languageDropdown\"\r\n                >\r\n                </p-dropdown>\r\n              </div>\r\n              <span class=\"feedback\">\r\n                <lib-control-message\r\n                  [control]=\"userForm.get('Language')\"\r\n                  data-testid=\"languageFeedback\"\r\n                ></lib-control-message>\r\n              </span>\r\n            </div>\r\n            <div class=\"vertical-flow space-between-025\">\r\n              <label for=\"TimeZone\">\r\n                {{ 'ADMINISTRATION.TIMEZONE' | transloco }}</label\r\n              >\r\n              <div>\r\n                <p-dropdown\r\n                  [options]=\"timeZoneTypes\"\r\n                  id=\"TimeZone\"\r\n                  formControlName=\"TimeZone\"\r\n                  filter=\"true\"\r\n                  placeholder=\"{{\r\n                    'ADMINISTRATION.SELECT_TIMEZONE' | transloco\r\n                  }}\"\r\n                  data-testid=\"timeZoneDropdown\"\r\n                >\r\n                </p-dropdown>\r\n              </div>\r\n              <span class=\"feedback\">\r\n                <lib-control-message\r\n                  [control]=\"userForm.get('TimeZone')\"\r\n                  data-testid=\"timeZoneFeedback\"\r\n                ></lib-control-message\r\n              ></span>\r\n            </div>\r\n\r\n            <div class=\"vertical-flow space-between-025\">\r\n              <label for=\"DateFormat\">{{\r\n                'ADMINISTRATION.DATE_FORMAT' | transloco\r\n              }}</label>\r\n              <div>\r\n                <p-dropdown\r\n                  [options]=\"dateFormatTypes\"\r\n                  id=\"DateFormat\"\r\n                  formControlName=\"DateFormat\"\r\n                  placeholder=\"{{\r\n                    'ADMINISTRATION.SELECT_DATE_FORMAT' | transloco\r\n                  }}\"\r\n                  data-testid=\"dateFormatDropdown\"\r\n                >\r\n                </p-dropdown>\r\n              </div>\r\n              <span class=\"feedback\">\r\n                <lib-control-message\r\n                  [control]=\"userForm.get('DateFormat')\"\r\n                  data-testid=\"dateFormatFeedback\"\r\n                ></lib-control-message>\r\n              </span>\r\n            </div>\r\n          </ng-container>\r\n          <div\r\n            class=\"horizontal-flow form-controls space-between-050 space-before-200\"\r\n          >\r\n            <button\r\n              pButton\r\n              type=\"button\"\r\n              id=\"cancelButton1\"\r\n              label=\"{{ 'ACTIONS.CANCEL' | transloco }}\"\r\n              class=\"ds secondary\"\r\n              [routerLink]=\"['/AdministrationModule']\"\r\n              data-testid=\"cancelButton\"\r\n            ></button>\r\n            <button\r\n              pButton\r\n              type=\"button\"\r\n              id=\"submitButton\"\r\n              label=\"{{ userInfoButtonLabel }}\"\r\n              class=\"ds primary\"\r\n              (click)=\"isUpdating ? save() : submit()\"\r\n              [disabled]=\"userForm.invalid || phoneForm.invalid\"\r\n              data-testid=\"submitButton\"\r\n            ></button>\r\n          </div>\r\n        </form>\r\n      </p-tabPanel>\r\n\r\n      <p-tabPanel\r\n        header=\"{{ 'ADMINISTRATION.PAGE_PERMISSIONS_TAB' | transloco }}\"\r\n        [selected]=\"activatePagePermissions\"\r\n        data-testid=\"permissionsTab\"\r\n      >\r\n        <form [formGroup]=\"permissionsForm\">\r\n          <p>\r\n            {{ 'ADMINISTRATION.PAGE_PERMISSIONS_LABEL' | transloco }}\r\n          </p>\r\n          <p-tree\r\n            [value]=\"allPermissions\"\r\n            [(selection)]=\"selectedPermissions\"\r\n            selectionMode=\"checkbox\"\r\n            id=\"permissionsTree\"\r\n            [propagateSelectionUp]=\"false\"\r\n            [propagateSelectionDown]=\"true\"\r\n            data-testid=\"permissionsTree\"\r\n          ></p-tree>\r\n          <div\r\n            class=\"horizontal-flow form-controls space-between-050 space-before-300\"\r\n          >\r\n            <button\r\n              pButton\r\n              type=\"button\"\r\n              id=\"cancelButton2\"\r\n              label=\"{{ 'ACTIONS.CANCEL' | transloco }}\"\r\n              class=\"ds secondary\"\r\n              [routerLink]=\"['/AdministrationModule']\"\r\n              data-testid=\"cancelButton\"\r\n            ></button>\r\n            <button\r\n              pButton\r\n              type=\"button\"\r\n              id=\"saveButton\"\r\n              label=\"{{ 'ACTIONS.SAVE' | transloco }}\"\r\n              class=\"ds primary\"\r\n              (click)=\"save()\"\r\n              [disabled]=\"userForm.invalid || phoneForm.invalid\"\r\n              data-testid=\"submitButton\"\r\n            ></button>\r\n          </div>\r\n        </form>\r\n      </p-tabPanel>\r\n    </p-tabView>\r\n  </div>\r\n</div>\r\n",
        styles: [""]
    })
], UserDetailsV2Component);

const ɵ0$6 = () => {
    return `/v2/user/account/new`;
}, ɵ1$6 = () => {
    return `/v2/user/account/edit`;
}, ɵ2$6 = () => {
    return `/v2/user/account/copy`;
};
const apiUrls = {
    addUserWizardUrl: ɵ0$6,
    editUserWizardUrl: ɵ1$6,
    copyUserWizardUrl: ɵ2$6,
};
const ɵ3$3 = () => {
    return `/AdministrationModule/user`;
};
const moduleUrls = {
    userAdministrationUrl: ɵ3$3,
};

let UserDetailsWizardComponent = class UserDetailsWizardComponent {
    constructor(router, route, toast, translocoService, adminService) {
        this.router = router;
        this.route = route;
        this.toast = toast;
        this.translocoService = translocoService;
        this.adminService = adminService;
        this.wizardUrl = '';
        this.templateTypes = TemplateTypes;
        this.action = '';
        this.id = 0;
    }
    ngOnInit() {
        this.action = this.route.snapshot.url[0].path;
        this.route.queryParams
            .pipe(tap((params) => {
            this.id = JSON.parse((params === null || params === void 0 ? void 0 : params.id) || 0);
        }))
            .subscribe();
        this.setWizardConfig();
        this.wizardUrl = this.adminService.getConfig().apiBaseUrl;
    }
    setWizardConfig() {
        switch (this.action) {
            case 'add':
                this.wizardConfig = {
                    endpoint: apiUrls.addUserWizardUrl(),
                    httpMethod: HttpMethod$1.POST,
                };
                break;
            case 'copy':
                this.wizardConfig = {
                    endpoint: apiUrls.copyUserWizardUrl(),
                    httpMethod: HttpMethod$1.POST,
                    body: {
                        key: this.id,
                    },
                };
                break;
            case 'update':
                this.wizardConfig = {
                    endpoint: apiUrls.editUserWizardUrl(),
                    httpMethod: HttpMethod$1.POST,
                    body: {
                        key: this.id,
                    },
                };
                break;
        }
    }
    submit(event) {
        this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
        this.router.navigate([moduleUrls.userAdministrationUrl()], {
            relativeTo: this.route,
        });
    }
    redirect() {
        this.router.navigate([moduleUrls.userAdministrationUrl()], {
            relativeTo: this.route,
        });
    }
};
UserDetailsWizardComponent.ctorParameters = () => [
    { type: Router },
    { type: ActivatedRoute },
    { type: ToastrNotificationService },
    { type: TranslocoService },
    { type: AdministrationService }
];
UserDetailsWizardComponent = __decorate([
    Component({
        selector: 'lib-user-details-wizard',
        template: "<lui-wizard-v3\r\n  [baseUrl]=\"wizardUrl\"\r\n  [wizardConfig]=\"wizardConfig\"\r\n  (submit)=\"submit($event)\"\r\n  (cancel)=\"redirect()\"\r\n>\r\n  <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n    <div\r\n      class=\"error\"\r\n      style=\"\r\n        min-height: 30vh;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n      \"\r\n    >\r\n      <div>\r\n        <span>\r\n          <i class=\"pi pi-times-circle\"></i>\r\n          {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n        </span>\r\n      </div>\r\n    </div>\r\n    <button\r\n      pButton\r\n      (click)=\"redirect()\"\r\n      class=\"ds secondary\"\r\n      data-testid=\"cancelButton\"\r\n    >\r\n      {{ 'ACTIONS.CANCEL' | transloco }}\r\n    </button>\r\n  </ng-template>\r\n</lui-wizard-v3>\r\n",
        providers: [ConfirmationService$3]
    })
], UserDetailsWizardComponent);

let AdministrationModule = class AdministrationModule {
};
AdministrationModule = __decorate([
    NgModule({
        declarations: [
            AdministrationComponent,
            ViewusersComponent,
            UserDetailsComponent,
            UserDetailsV2Component,
            MarketplaceControlComponent,
            MarketplaceControlViewComponent,
            DataCrossReferenceComponent,
            UserDefinedTagsComponent,
            UserDetailsWrapperComponent,
            UserDetailsWizardComponent,
        ],
        providers: [DatePipe, ConfirmationService$2, SpinnerService],
        imports: [
            AdministrationRoutingModule,
            TableModule,
            DropdownModule,
            VirtualScrollerModule,
            MultiSelectModule,
            MenubarModule,
            TranslocoModule,
            InputTextModule,
            ButtonModule$1,
            FormsModule,
            ReactiveFormsModule,
            TabViewModule,
            UtilsModule,
            ConfirmDialogModule,
            PasswordModule,
            CommonModule,
            CheckboxModule,
            SearchContainerModule,
            SearchContainerLoaderModule,
            DialogModule,
            UtilsModule,
            TreeModule,
            EditorModule,
            FileUploadModule,
            MarketplaceConnectorModule,
            AccountingConfigurationModule,
            LuiWizardModule,
            LuiWizardV3Module,
            LuiWidgetWrapperModule,
        ],
        schemas: [CUSTOM_ELEMENTS_SCHEMA],
        exports: [AdministrationComponent],
    })
], AdministrationModule);

class AdminConfig {
    constructor() {
        this.apiBaseUrl = null;
        this.accountAssetsEndPoint = null;
        this.addUserEndpoint = null;
        this.copyUserEndpoint = null;
        this.updateUserEndpoint = null;
        this.deleteUserEndpoint = null;
        this.searchUserEndpoint = null;
        this.listPermissionsEndpoint = null;
        this.listPermissionsEndpointV2 = null;
        this.updateUserPermissionsEndpoint = null;
        this.languageTypesEndpoint = null;
        this.timeZoneTypesEndpoint = null;
        this.dateFormatTypesEndpoint = null;
        this.exportUsersEndpoint = null;
        this.getConfigEndpoint = null;
        this.getAccountEndpoint = null;
        this.getAccountRootURL = null;
        this.getExportsEndpoint = null;
        this.getConnectorEndpoint = null;
        this.getConfiguration = null;
        this.taggingEndpoint = null;
    }
}

/*
 * Public API Surface of administration
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AdminConfig, AdministrationComponent, AdministrationModule, AdministrationService, ViewusersComponent as ɵa, UserService as ɵb, PayableComponent as ɵba, MarketplaceConnectorModule as ɵbb, WizardModule as ɵbc, WizardComponent as ɵbd, ScreenComponent as ɵbf, AccountingConfigurationModule as ɵbg, ReceivableEditFormComponent as ɵbh, ReceivableViewFormComponent as ɵbi, ViewFormComponent as ɵbj, EditFormComponent as ɵbk, AccountingReceivableBulkUpdateComponent as ɵbl, AccountingReceivableBulkUpdateContainerComponent as ɵbm, AccountingPayableBulkUpdateComponent as ɵbn, AccountingPayableBulkUpdateContainerComponent as ɵbo, PayConfigBulkUpdateComponent as ɵbp, PayConfigBulkUpdateContainerComponent as ɵbq, UserDetailsComponent as ɵc, UserDetailsV2Component as ɵd, UserService$1 as ɵe, MarketplaceControlComponent as ɵf, AccountControlService as ɵg, MarketplaceControlViewComponent as ɵh, DataCrossReferenceComponent as ɵi, UserDefinedTagsComponent as ɵj, UserDetailsWrapperComponent as ɵk, UserDetailsWizardComponent as ɵl, appRoutes as ɵm, AdministrationRoutingModule as ɵn, AuthGuardService as ɵo, PayConfigurationComponent as ɵp, BaseHttpService as ɵq, routes as ɵr, MarketplaceConnectorComponent as ɵs, ViewMarketplaceConnectorsComponent as ɵt, NewConnectionWizardComponent as ɵv, EditConnectionWizardComponent as ɵw, routes$1 as ɵx, AccountingConfigurationComponent as ɵy, ReceivableComponent as ɵz };
//# sourceMappingURL=lbmx-administration.js.map
